// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
  urlSearchParamsBodySerializer,
} from "@hey-api/client-next";
import type {
  GetCitiesFromAGivenStateData,
  GetAllStatesData,
  GetAllDiseaseCodesData,
  GetDiseasesByIdData,
  GetCitiesAndStatesFromZipcodeData,
  GetAllLicenseTypesData,
  GetAllLicenseTypesResponse,
  GetCaseFilesData,
  UpdateCaseFilesData,
  DetachAFileFromACaseData,
  DetachAFileFromACaseResponse,
  AttachAFileToACaseData,
  AttachAFileToACaseResponse,
  GetCaseEventsData,
  DeleteCasePrescriptionData,
  UpdateCasePrescriptionData,
  GetCasePrescriptionsData,
  UpdateCasePrescriptionsData,
  CreateCasePrescriptionData,
  UpdateCasePrescriptionsStatusesData,
  GetCaseQuestionsData,
  PostCaseQuestionData,
  PostCaseQuestionResponse,
  GetCaseServicesData,
  GetCaseServicesResponse,
  CreateServicesData,
  GetCaseDiseasesData,
  GetCaseDiseasesResponse,
  AttachNewDiseasesData,
  AttachNewDiseasesResponse,
  DeleteDiseasesData,
  DeleteDiseasesResponse,
  SendCaseToSupportData,
  UpdateHoldStatusFlagData,
  CancelCaseData,
  CancelCaseResponse,
  SetCaseAsAssignedData,
  SendAnApprovedCaseToProcessingData,
  GetNotesData,
  DetachTagData,
  UpdateTagNoteData,
  AttachTagData,
  GetCaseData,
  GetCaseResponse,
  GetServicesPdfData,
  CreateCaseData,
  CreateCaseResponse,
  GetMessagesData,
  GetMessagesResponse,
  CreateMessageData,
  CreateMessageResponse,
  GetMessageData,
  GetMessageResponse,
  RemovePharmacyFromPatientData,
  RemovePharmacyFromPatientResponse,
  AddPharmacyToPatientData,
  AddPharmacyToPatientResponse,
  GetPharmaciesFromPatientData,
  GetPharmaciesFromPatientResponse,
  SendOneTimePasswordData,
  ValidateVerificationCodeData,
  GetDriversLicenseRequestUrlData,
  GetDriversLicenseRequestUrlResponse,
  GetMessagingAppUrlData,
  GetMessagingAppUrlResponse,
  GetIntroVideoRequestUrlData,
  GetIntroVideoRequestUrlResponse,
  GetFileRequestUrlData,
  GetFileRequestUrlResponse,
  RequestPatientDataData,
  RequestPatientDataDeletionData,
  RequestPatientDataDeletionResponse,
  UpdatePatientData,
  UpdatePatientResponse,
  GetPatientExamData,
  GetPatientExamsData,
  GetPatientVouchersData,
  GetCoverageData,
  GetMedicationsHistoryData,
  CreatePatientData,
  CreatePatientResponse,
  SearchPatientsData,
  GetPatientData,
  GetPatientResponse,
  GetPatientEventsData,
  GetPatientEventsResponse,
  GetPatientCasesData,
  SearchSuppliesData,
  SearchSuppliesResponse,
  GetAllSuppliesData,
  GetAllSuppliesResponse,
  SearchMedicationsData,
  SearchMedicationsResponse,
  GetDetailsForASpecificMedicationData,
  GetDetailsForASpecificMedicationResponse,
  GetAllMedicationsData,
  GetAllMedicationsResponse,
  DeleteFileData,
  GetFileData,
  GetFileResponse,
  CreateFileData,
  CreateFileResponse,
  GetPharmaciesData,
  GetPharmaciesResponse,
  GetPharmacyData,
  GetPharmacyResponse,
  GetDispenseUnitsData,
  GetDispenseUnitsResponse,
  SearchForCompoundsData,
  SearchForCompoundsResponse,
  CreatePartnerCompoudData,
  CreatePartnerCompoudResponse,
  GetServiceData,
  ListServicesData,
  GetVouchersData,
  DeleteVoucherData,
  GetVoucherData,
  CreateVoucherData,
  ExpireVoucherData,
  ListQuestionsData,
  ListQuestionnairesData,
  GetQuestionnaireData,
  GetClinicianInformationData,
  GetSupportStaffInformationData,
  GetInternalSupportStaffInformationData,
  GetMedicalAssistantInformationData,
  GetPartnerNotificationsData,
  GetPartnerNotificationsResponse,
  GetPartnerNotificationData,
  GetPartnerNotificationResponse,
  CreateEncounterData,
  CreateEncounterResponse,
  PostEncounterStatusData,
  CreateEncounterPrescriptionData,
  ReassignClinicianToEncounterData,
  CreatePatientAndEncounterData,
  CreateMessage1Data,
  EmbeddingUrlsData,
  CaseCreatedData,
  GetAuthenticatedPartnerData,
  GetAuthenticatedPartnerResponse,
  RequestAccessTokenData,
  RequestAccessTokenResponse,
  GetApiStatusData,
  ValidateVerificationCode1Data,
  SendOneTimePassword1Data,
  AttachFileData,
  CreateCase1Data,
  GetPatientCases1Data,
  GetPatientCaseData,
  GetPatientCasePrescriptionsData,
  GetAllPatientPartnersData,
  GetPartnerData,
  GetPharmacies1Data,
  GetPharmacy1Data,
  SetPreferredPharmacyData,
  RefreshTokenData,
  CreateFile1Data,
  DeleteFile1Data,
  GetFile1Data,
  GetPatientExams1Data,
  ListStatesByCountryAbbreviationData,
  RequestPatientDataDeletion1Data,
  GetAuthenticatedPatientData,
  UpdatePatient1Data,
  RequestPatientData1Data,
  CreateFile2Data,
  DeleteFile2Data,
  GetFile2Data,
  SetCompletionTimeData,
  ListQuestions1Data,
  SetDroppedFromData,
  ListQuestionnaires1Data,
  GetQuestionnaire1Data,
  ListStatesByPartnerOperationCountryData,
  GetPharmacies2Data,
  GetPharmacy2Data,
  GetVoucher1Data,
  ValidatePatientInformationData,
  CreatePatientAndCaseData,
  CreatePatient1Data,
  PatchQuestionnaireProgressData,
  GetMessages1Data,
  CreateMessage2Data,
  GetMessage1Data,
  ReadMessageData,
  GetArticlesData,
  GetArticleData,
  CreateAccessTokenData,
  Validate2FaCodeData,
  CheckInactivityData,
  RefreshAccessTokenData,
  GetCoverage1Data,
  GetMedicationsHistory1Data,
  CacheMedicationsHistoryData,
  GetFilesData,
  AttachFile1Data,
  GetReadingsData,
  GetMessages2Data,
  CreateMessage3Data,
  GetMessage2Data,
  ReadMessage1Data,
  UnreadMessageData,
  DismissMessagesData,
  ForwardMessageData,
  UndismissMessageData,
  GetPatientsMetricsData,
  GetPharmaciesFromPatient1Data,
  PostPreferredPharmacyRequestData,
  PostDriversLicenseRequestData,
  GetPatientappUrlData,
  RequestPatientData2Data,
  PostIntroVideoRequestData,
  ExamsRequestData,
  GetRecentVouchedData,
  CreateVouchedData,
  GetPatientExam1Data,
  GetPatientExams2Data,
  DetachPatientTagData,
  PatchPatientTagData,
  AttachPatientTagData,
  DisablePatientData,
  GetPatient1Data,
  UpdatePatient2Data,
  GetPatientsData,
  GetPatientEvents1Data,
  GetPatientCases2Data,
  GetPatientFilesData,
  GetPatientClinicalNotesData,
  SearchPatients1Data,
  CreatePatient2Data,
  PostPatientPrimaryClinicianData,
  PostScanPatientFileData,
  PatchVerifiedManuallyData,
  GetDispenseUnits1Data,
  GetPharmacies3Data,
  GetPharmacy3Data,
  RevokeTheAccessTokenUsedInTheRequestData,
  RevokeAllAccessTokensBelongingToTheLoggedUserData,
  SearchForCompoundsFromAGivenPartnerData,
  CreateCompoundForAGivenPartnerData,
  PartnerMedicationsData,
  PartnerSuppliesData,
  GetCompletedCasesData,
  GetPartnerTagsData,
  GetPartnerNotifications1Data,
  GetPartnerNotification1Data,
  ListQuestionnaires2Data,
  GetVoucher2Data,
  CreateVoucher1Data,
  GetWildcardsData,
  CreateWildcardData,
  GetCitiesFromAGivenState1Data,
  GetAllStates1Data,
  GetAllDiseaseCodes1Data,
  GetDiseasesById1Data,
  GetEnvironmentsData,
  GetAllLicenseTypes1Data,
  GetCaseFiles1Data,
  UpdateCaseFiles1Data,
  DetachAFileFromACase1Data,
  AttachAFileToACase1Data,
  GetCasePrescriptions1Data,
  UpdateCasePrescriptions1Data,
  CreateCasePrescription1Data,
  DeleteCasePrescription1Data,
  UpdateCasePrescription1Data,
  CancelCasePrescriptionData,
  UpdateCasePrescriptionsStatuses1Data,
  ResubmitCasePrescriptionData,
  CancelCasePrescriptionsData,
  ResetCasePrescriptionsData,
  GetCaseQuestions1Data,
  UpdateQuestionData,
  GetNotes1Data,
  CreateNoteData,
  TransferCaseToSupportData,
  SetCaseAsWaitingData,
  SetCaseAsCompletedData,
  SetCaseAsProcessingData,
  SetCaseAsApprovedData,
  SetCaseAsAssigned1Data,
  SetCaseAsCancelledData,
  GetCaseDiseases1Data,
  AttachNewDiseases1Data,
  DeleteDiseases1Data,
  SetPrimaryDiseaseData,
  RemoveServicesData,
  UpdateCaseServicesData,
  GetCaseServices1Data,
  AddNewServicesData,
  GetCaseEvents1Data,
  AddCaseEventsData,
  AddClinicianEventsData,
  AttachCaseData,
  GetPinnedCasesToMeData,
  GetPinnedCasesByMeData,
  UnpinCasePinnedToMeData,
  UnpinCasePinnedByMeData,
  DetachTag1Data,
  UpdateTagNote1Data,
  AttachTag1Data,
  FileAttachRequestData,
  SwapWildcardsData,
  CreateCase2Data,
  GetCase1Data,
  GetCaseAssignmentData,
  GeneratePdfData,
  GenerateMedicalNecessityPdfData,
  UpdateServicePdfExportedFlagData,
  CreatePdfFileData,
  GetCasesByStatusData,
  SearchCasesData,
  ReassignClinicianRandomlyToCaseData,
  UpdateCaseSynchronicityStatusData,
  UpdateCaseChargeabilityStatusData,
  ReassignClinicianToCaseData,
  ResubmitCasePrescriptionsData,
  SetCasePriorityData,
  PatchAdditionalApprovalFlagData,
  SendPartnerEscalationEmailData,
  CreateFile3Data,
  DeleteFile3Data,
  GetFile3Data,
  PatchFileData,
  AttachFileSnippetData,
  GetFileSnippetsData,
  DetachFileSnippetData,
  SearchSupplies1Data,
  GetPredefinedMessagesData,
  CreatePredefinedMessageData,
  DeletePredefinedMessageData,
  UpdatePredefinedMessageData,
  UpdatePredefinedMessagesOrderData,
  PriorAuthAppealData,
  PriorAuthCancelData,
  GetPriorAuthQuestionData,
  AnswerPriorAuthQuestionData,
  AddAttachmentToAPriorAuthData,
  RequestResetPasswordData,
  SubmitNewPasswordData,
  ChangePasswordData,
  UpdateAuthenticatedClinicianSLicenseData,
  CreateLicenseForAuthenticatedClinicianData,
  GetClinicianSAverageResponseTimeData,
  GetAverageProcessingCasesTimeData,
  GetAveragePatientWaitTreatmentTimeData,
  GetCountOfCompletedCasesByPeriodData,
  GetAmountDueForCompletedCasesByPeriodData,
  GetCountOfCasesOnEachStatusData,
  GetMedicalAssistantsData,
  CreateMedicalAssistantData,
  DeleteMedicalAssistantData,
  SearchMedications1Data,
  GetDetailsForASpecificMedication1Data,
  GetNotificationsData,
  DismissANotificationData,
  ChangeNotifiedUserData,
  ListPracticeAreasData,
  AttachAPracticeAreaData,
  DetachAPracticeAreaData,
  UpdateAPracticeAreaData,
  GetClinicianInformation1Data,
  SearchAssociatedCliniciansSupportStaffsData,
  ListChangelogsData,
  GetService1Data,
  ListServices1Data,
  ListServiceNotificationsData,
  DetachFavoriteTagData,
  AttachFavoriteTagData,
  GetFavoriteTagsData,
  GetTagsData,
  CreateTagData,
  DeleteTagData,
  UpdateTagData,
  GetTicketsData,
  CreateTicketData,
  GetTicketData,
  DeleteTicketData,
  GetMessages3Data,
  GetDevicesData,
  DeleteDeviceData,
  SwapWildcards1Data,
  GetAvailableCliniciansData,
  GetAuthenticatedClinicianData,
  UpdateAuthenticatedClinicianData,
  GetStatusData,
  ReplicateCompoundData,
  ReplicateMedicationData,
  ReplicateOfferingsData,
  ReplicateQuestionnaireData,
  ReplicateServiceData,
  ReplicateSupplyData,
  GetMedicationsSearchData,
  GetMedicationSelectData,
  GetPharmaciesSearchData,
  GetPharmacy4Data,
  GetSuppliesSearchData,
  GetSupplyData,
  GenerateTextData,
  GetArticles1Data,
  GetArticle1Data,
  GetEnvironments1Data,
  GetEnvironmentData,
  GetFiles1Data,
  AttachFile2Data,
  GetReadings1Data,
  GetMessages4Data,
  CreateMessage4Data,
  GetMessage3Data,
  ReadMessage2Data,
  UnreadMessage1Data,
  DismissMessages1Data,
  UndismissMessage1Data,
  GetStatus1Data,
  LoginUserData,
  LogoutUserData,
  LogoutUserAllData,
  CreatePasscodeData,
  GetNotificationsMessagesData,
  GetUserData,
  GetMedicationsSearch1Data,
  GetMedicationSelect1Data,
  GetPharmaciesSearch1Data,
  GetPharmacy5Data,
  GetStatus2Data,
  GetSuppliesSearch1Data,
  GetSupply1Data,
  GetPatientPrescriptionBenefitsData,
  GetPatientMedicationsHistoryData,
  DosespotBenefitsCheckData,
  NotifyChangelogData,
  SendTextMessageData,
  SendEmailData,
  GetStatus3Data,
  SendWebhookData,
  PatchFile1Data,
  GetFile4Data,
  GetThumbnailData,
  GetStatus4Data,
  GetArticles2Data,
  GetArticle2Data,
  GetChangelogsData,
  CreateChangelogData,
  DeleteChangelogData,
  UpdateChangelogData,
  GetCategoriesData,
  GetCategoryData,
  GetLicensesData,
  GetMedicalAssistants1Data,
  DetachMedicalAssistantData,
  AttachMedicalAssistantData,
  GetStatesData,
  GetSpecialtiesData,
  DetachSpecialtyData,
  UpdateSpecialtyData,
  AttachSpecialtyData,
  GetCliniciansData,
  CreateClinicianData,
  GetClinicianData,
  PatchClinicianData,
  GetClinicianExportFileData,
  GetClinicianPartnersData,
  GetCountriesData,
  GetCountryData,
  GetDiseaseData,
  GetDiseasesData,
  GetDispenseUnitData,
  GetDispenseUnits2Data,
  GetEmailTemplatesData,
  GetEmailTemplateData,
  GetEnvironments2Data,
  GetEnvironment1Data,
  CreateFile4Data,
  GetFile5Data,
  GetInternalSupportStaffData,
  GetInternalSupportStaffsData,
  CreateSupportStaffData,
  GetInternalSupportStaffPartnersData,
  GetSupportStaffData,
  UpdateSupportStaffData,
  DeleteMedicalAssistant1Data,
  GetMedicalAssistantData,
  UpdateMedicalAssistantData,
  GetMedicalAssistants2Data,
  CreateMedicalAssistant1Data,
  GetMedicalAssistantCliniciansData,
  CreatePanelUserData,
  GetPanelUserData,
  UpdatePanelUserData,
  GetServiceNotificationsData,
  GetCategories1Data,
  DetachCategoryData,
  AttachCategoryData,
  DetachClinicianData,
  UpdateAttachedClinicianData,
  AttachClinicianData,
  GetClinicians1Data,
  GetCliniciansExportFileData,
  GetDiseases1Data,
  DetachDiseaseData,
  AttachDiseaseData,
  GetTags1Data,
  DetachTag2Data,
  UpdateTag1Data,
  AttachTag2Data,
  GetStates1Data,
  DetachStateData,
  AttachStateData,
  DeleteCompoundData,
  GetCompoundData,
  UpdateCompoundData,
  GetCompoundsData,
  CreateCompoundData,
  RestoreCompoundData,
  ApplyCompoundsReviewsData,
  ApplyCompoundReviewData,
  ReplicateCompound1Data,
  GetContactsData,
  CreateContactData,
  DeleteContactData,
  UpdateContactData,
  GetCredentialsData,
  CreateCredentialData,
  DeleteCredentialData,
  GetDocumentationsData,
  CreateDocumentationData,
  DeleteDocumentationData,
  UpdateDocumentationData,
  GetEncountersData,
  ExportEncountersData,
  GetEnvironments3Data,
  CreateEnvironmentData,
  DeleteEnvironmentData,
  GetEnvironment2Data,
  UpdateEnvironmentData,
  ContactEmailData,
  GetFiles2Data,
  DetachFileData,
  UpdateFileData,
  AttachFile3Data,
  DetachInternalSupportStaffData,
  UpdateInternalSupportStaffData,
  AttachInternalSupportStaffData,
  GetInternalSupportStaffs1Data,
  GetInvoicesData,
  GetDiseases2Data,
  DetachDisease1Data,
  AttachDisease1Data,
  GetTags2Data,
  DetachTag3Data,
  UpdateTag2Data,
  AttachTag3Data,
  GetStates2Data,
  DetachState1Data,
  AttachState1Data,
  DeleteMedicationData,
  GetMedicationData,
  UpdateMedicationData,
  GetMedicationsData,
  CreateMedicationData,
  RestoreMedicationData,
  ApplyMedicationsReviewsData,
  ApplyMedicationReviewData,
  ReplicateMedication1Data,
  GetOfferingReviewsData,
  RejectReviewData,
  DismissReviewData,
  ReplicateOfferings1Data,
  GetPanelUsersData,
  CreatePanelUser1Data,
  AttachPanelUserEmailData,
  DetachPanelUserData,
  AttachPanelUserData,
  GetPatients1Data,
  GetParametersData,
  CreateParameterData,
  DeleteParameterData,
  UpdateParameterData,
  GetDiseases3Data,
  DetachDisease2Data,
  AttachDisease2Data,
  GetTags3Data,
  DetachTag4Data,
  UpdateTag3Data,
  AttachTag4Data,
  GetStates3Data,
  DetachState2Data,
  AttachState2Data,
  GetSupply2Data,
  DeleteSupplyData,
  UpdateSupplyData,
  GetSuppliesData,
  CreateSupplyData,
  RestoreSupplyData,
  ApplySuppliesReviewsData,
  ApplySupplyReviewData,
  ReplicateSupply1Data,
  GetDiseases4Data,
  DetachDisease3Data,
  AttachDisease3Data,
  GetTags4Data,
  DetachTag5Data,
  UpdateTag4Data,
  AttachTag5Data,
  GetStates4Data,
  DetachState3Data,
  AttachState3Data,
  DeleteServiceData,
  GetService2Data,
  UpdateServiceData,
  GetServicesData,
  CreateServiceData,
  RestoreServiceData,
  ApplyServicesReviewsData,
  ApplyServiceReviewData,
  ReplicateService1Data,
  GetSupportStaffsData,
  CreateSupportStaff1Data,
  AttachSupportStaffEmailData,
  DetachSupportStaffData,
  UpdateSupportStaff1Data,
  AttachSupportStaffData,
  GetSpecialties1Data,
  DetachSpecialty1Data,
  PatchSpecialtyData,
  AttachSpecialty1Data,
  GetTickets1Data,
  CreateTicket1Data,
  DeleteTicket1Data,
  GetTicket1Data,
  GetOptionsData,
  PostOptionData,
  DeleteOptionData,
  GetOptionData,
  PatchOptionData,
  ApplyOptionReviewData,
  GetRequirementsData,
  PostRequirementData,
  DeleteRequirementData,
  GetRequirementData,
  PatchRequirementData,
  ApplyRequirementReviewData,
  GetRulesData,
  PostRuleData,
  DeleteRuleData,
  GetRuleData,
  PatchRuleData,
  PostRuleRequirementsData,
  ApplyRuleReviewData,
  DetachFile1Data,
  AttachFile4Data,
  GetQuestionsData,
  PostQuestionData,
  DeleteQuestionData,
  GetQuestionData,
  PatchQuestionData,
  ApplyQuestionReviewData,
  GetRequirements1Data,
  PostRequirement1Data,
  DeleteRequirement1Data,
  GetRequirement1Data,
  PatchRequirement1Data,
  ApplyRequirementReview1Data,
  GetRules1Data,
  PostRule1Data,
  DeleteRule1Data,
  GetRule1Data,
  PatchRule1Data,
  PostRuleRequirements1Data,
  ApplyRuleReview1Data,
  GetOfferingsData,
  PostOfferingsData,
  DeleteOfferingData,
  GetOfferingData,
  PatchOfferingData,
  ApplyOfferingReviewData,
  GetQuestionnairesData,
  PostQuestionnaireData,
  DeleteQuestionnaireData,
  GetQuestionnaire2Data,
  PatchQuestionnaireData,
  ApplyQuestionnaireReviewData,
  ApplyQuestionnairesReviewsData,
  RestoreQuestionnaireData,
  ReplicateQuestionnaire1Data,
  GetTags5Data,
  CreateTag1Data,
  DeleteTag1Data,
  UpdateTag5Data,
  GetVouchers1Data,
  CreateVoucher2Data,
  DeleteVoucher1Data,
  GetVoucher3Data,
  ExpireVoucher1Data,
  GetWebhooksData,
  GetWebhookData,
  TestWebhookData,
  PostWebhookResendData,
  CreatePartnerSSlackChannelData,
  CreateEncounter1Data,
  PostEncounterStatus1Data,
  CreateEncounterPrescription1Data,
  ReassignClinicianToEncounter1Data,
  CreatePatientAndEncounter1Data,
  GetEncounterData,
  CreateMessage5Data,
  GetAuditsData,
  GetReviewsData,
  AssociateProductsData,
  AssociationProductsData,
  DiassociationProductsData,
  AssociationProducts1Data,
  ProductQuestionnaireAssociationsData,
  ProductQuestionnaireAssociation1Data,
  ProductQuestionnaireAssociation3Data,
  ProductQuestionnaireAssociationData,
  ProductQuestionnaireAssociation2Data,
  ProductOfferingAssociationData,
  ProductOfferingsAssociationData,
  ProductOfferingsAssociation2Data,
  ProductOfferingsAssociationsData,
  ProductOfferingsAssociation1Data,
  GetProductsData,
  GetOrderAnalysisData,
  DeleteEmailDomainData,
  GetEmailDomainData,
  PostEmailDomainData,
  PostValidateEmailDomainData,
  PostSendTestEmailDomainData,
  GetEmailTemplates1Data,
  PostEmailTemplateData,
  DeleteEmailTemplateData,
  GetEmailTemplate1Data,
  PatchEmailTemplateData,
  PostEmailTemplateSendTestData,
  DeleteWildcardData,
  UpdateWildcardData,
  DeleteEmailStyleData,
  GetEmailStyleData,
  PostEmailStyleData,
  GetPartner1Data,
  UpdatePartnerData,
  CreatePartnerData,
  ReviewPartnerData,
  GetPartnerStatisticData,
  GetClinicians2Data,
  GetPartnersData,
  GetCompounds1Data,
  GetMedications1Data,
  GetSupplies1Data,
  GetServices1Data,
  GetQuestionnaires1Data,
  PostQuestionnaire1Data,
  GetDiseases5Data,
  AttachDisease4Data,
  DetachDisease4Data,
  GetTags6Data,
  DetachTag6Data,
  UpdateTag6Data,
  AttachTag6Data,
  GetStates5Data,
  DetachState4Data,
  AttachState4Data,
  AttachSpecialty2Data,
  DetachSpecialty2Data,
  DeleteOffering1Data,
  GetOffering1Data,
  UpdateOfferingData,
  GetOfferings1Data,
  CreateOfferingData,
  RestoreOfferingData,
  ReplicateOfferingData,
  GetOptions1Data,
  PostOption1Data,
  DeleteOption1Data,
  GetOption1Data,
  PatchOption1Data,
  GetRequirements2Data,
  PostRequirement2Data,
  DeleteRequirement2Data,
  GetRequirement2Data,
  PatchRequirement2Data,
  GetRules2Data,
  PostRule2Data,
  DeleteRule2Data,
  GetRule2Data,
  PatchRule2Data,
  PostRuleRequirements2Data,
  DetachFile2Data,
  AttachFile5Data,
  GetQuestions1Data,
  PostQuestion1Data,
  DeleteQuestion1Data,
  GetQuestion1Data,
  PatchQuestion1Data,
  GetRequirements3Data,
  PostRequirement3Data,
  DeleteRequirement3Data,
  GetRequirement3Data,
  PatchRequirement3Data,
  GetRules3Data,
  PostRule3Data,
  DeleteRule3Data,
  GetRule3Data,
  PatchRule3Data,
  PostRuleRequirements3Data,
  GetOfferings2Data,
  PostOfferings1Data,
  DeleteOffering2Data,
  GetOffering2Data,
  PatchOffering1Data,
  DeleteQuestionnaire1Data,
  GetQuestionnaire3Data,
  PatchQuestionnaire1Data,
  RestoreQuestionnaire1Data,
  ReplicateQuestionnaire2Data,
  GetSpecialties2Data,
  PostSpecialtyData,
  DeleteSpecialtyData,
  GetSpecialtyData,
  PatchSpecialty1Data,
  GetStateData,
  GetStates6Data,
  GetStatisticsData,
  GetStatus5Data,
  GetSupportStaffs1Data,
  CreateSupportStaff2Data,
  GetSupportStaffPartnersData,
  GetTimezonesData,
  GetTimezoneData,
  Request2FaData,
  LoginUser1Data,
  LogoutUser1Data,
  LogoutUserAll1Data,
  CreatePasswordResetTokenData,
  ResetPasswordResetData,
  GetPartners1Data,
  GetDevices1Data,
  DeleteDevice1Data,
  GetUser1Data,
  UpdateUserData,
  GetReviews1Data,
  GetPartnerPatientsData,
  RequestPatientData3Data,
  DeletePartnerPatientData,
  GetPartnerVouchersData,
  DeletePartnerShopifyData,
  UpdatePartnerShopifyData,
  NotificationsData,
  ProcessingCasesQueueData,
  ServersLoadData,
  ServersMemoryData,
  ServersStorageData,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get cities from a given state
 * Return a list of all cities from a given state from USA.
 */
export const getCitiesFromAGivenState = <ThrowOnError extends boolean = false>(
  options: Options<GetCitiesFromAGivenStateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/metadata/states/{state_id}/cities",
    ...options,
  });
};

/**
 * Get all states
 * Return a list of all states from USA.
 */
export const getAllStates = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllStatesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/metadata/states",
      ...options,
    }
  );
};

/**
 * Get all Disease Codes
 * Return a list of all diseases codes.
 */
export const getAllDiseaseCodes = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllDiseaseCodesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/metadata/diseases",
      ...options,
    }
  );
};

/**
 * Get diseases by ID
 * Return the disease data by its ID.
 */
export const getDiseasesById = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseasesByIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/metadata/diseases/{disease_id}",
    ...options,
  });
};

/**
 * Get Cities and States from Zipcode
 * Returns Cities and State for each City that matches the Zipcode passed.
 */
export const getCitiesAndStatesFromZipcode = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCitiesAndStatesFromZipcodeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/metadata/zipcodes",
      ...options,
    }
  );
};

/**
 * Get all license types
 * Get all license types
 */
export const getAllLicenseTypes = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllLicenseTypesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllLicenseTypesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/metadata/license-types",
    ...options,
  });
};

/**
 * Get case files
 * Returns a list of all attached files to the case.
 */
export const getCaseFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseFilesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/files",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Update case files
 * Update cases files.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | case_files | array(uuid)* | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 */
export const updateCaseFiles = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCaseFilesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach a file from a case
 * Attach a file to a case.
 */
export const detachAFileFromACase = <ThrowOnError extends boolean = false>(
  options: Options<DetachAFileFromACaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DetachAFileFromACaseResponse,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/files/{file_id}",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Attach a file to a case
 * Attach a file to a case.
 */
export const attachAFileToACase = <ThrowOnError extends boolean = false>(
  options: Options<AttachAFileToACaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AttachAFileToACaseResponse,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/files/{file_id}",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Get case events
 * Returns a list of events related to the case.
 */
export const getCaseEvents = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseEventsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/events",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Delete case prescription
 * Delete a specific case prescription.
 */
export const deleteCasePrescription = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCasePrescriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/prescriptions/{prescription_id}",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Update case prescription
 * Update a specific case prescription.
 *
 * # Payload
 *
 * Receives an array of **Prescriptions**.
 *
 * ## Prescription Properties
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The prescription ordering |
 * | name | string | Prescription name. _Only update when its from compound otherwise it comes from Partner Medication/Supply registered._ |
 */
export const updateCasePrescription = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCasePrescriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/prescriptions/{prescription_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get case prescriptions
 * Return all prescriptions for a given case ID.
 */
export const getCasePrescriptions = <ThrowOnError extends boolean = false>(
  options: Options<GetCasePrescriptionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/prescriptions",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Update case prescriptions
 * Update cases prescriptions.
 *
 * # Payload
 *
 * Receives an array of **Prescriptions**.
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to.  <br>  <br>**Required if**: `dosespot_medication_id` is present.  <br>**Required if**: `partner_medication_id` or `partner_medication_id` does not have a registered default pharmacy.  <br>  <br>Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available. |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The prescription ordering |
 * | name | string | Prescription name. _Only update when its from compound otherwise it comes from Partner Medication/Supply registered._ |
 */
export const updateCasePrescriptions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCasePrescriptionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/prescriptions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create case prescription
 * Create a case prescription.
 *
 * # Payload
 *
 * Receives an object of **Prescription**.
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID.It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The prescription ordering |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/f669c052-625e-41b9-8742-185671cbd615/aW1hZ2UucG5n" width="1637" height="421">
 */
export const createCasePrescription = <ThrowOnError extends boolean = false>(
  options: Options<CreateCasePrescriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/cases/{case_id}/prescriptions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Update case prescriptions statuses
 * Update cases prescriptions statuses. In case the encounter has all prescriptions as "pharmacy_verified" it will also set the case as completed.
 * In case it finds an error in any of the prescription statuses, it will set the case to support.
 */
export const updateCasePrescriptionsStatuses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCasePrescriptionsStatusesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/prescriptions/status",
    ...options,
  });
};

/**
 * Get case questions
 * Return all questions for a given case ID.
 */
export const getCaseQuestions = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseQuestionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post case question
 * Create a case question.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | text\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as important |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 * | description | text | A description for your question |
 * | label | string(50) | The question label |
 * | metadata | text | A metadata field |
 * | displayed_options | array | An array of options that were displayed to the patient |
 * | is_critical | boolean | Mark question as critical |
 */
export const postCaseQuestion = <ThrowOnError extends boolean = false>(
  options: Options<PostCaseQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostCaseQuestionResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get case services
 * List all case services for a given case ID.
 */
export const getCaseServices = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseServicesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetCaseServicesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/services",
    ...options,
  });
};

/**
 * Create services
 * Create a case service.
 *
 * # Payload
 *
 * Receives an object of **Service**.
 *
 * **\## Service Properties**
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | order | integer |
 */
export const createServices = <ThrowOnError extends boolean = false>(
  options: Options<CreateServicesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/cases/{case_id}/services",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get case diseases
 * List all diseases for a given case ID.
 */
export const getCaseDiseases = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseDiseasesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetCaseDiseasesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/diseases",
    ...options,
  });
};

/**
 * Attach new diseases
 * Attach a Disease to the given Case.
 *
 * # Payload
 *
 * **Note**: Use the "Get all Disease Codes" endpoint under the metadata folder to find a list of all availables UUID to be used. Once you know a disease id, you can also retrieve its information through the API using the Get Disease route
 *
 * | **field** | **type** |
 * | --- | --- |
 * | disease_id | UUID (**required)** |
 */
export const attachNewDiseases = <ThrowOnError extends boolean = false>(
  options: Options<AttachNewDiseasesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AttachNewDiseasesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/diseases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete diseases
 * Delete disease from a case.
 */
export const deleteDiseases = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDiseasesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteDiseasesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/diseases/{disease_id}",
    ...options,
  });
};

/**
 * Send case to Support
 * Set a given case as in support.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | reason | string | A reason description |
 */
export const sendCaseToSupport = <ThrowOnError extends boolean = false>(
  options: Options<SendCaseToSupportData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/cases/{case_id}/support",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Update hold status flag
 * Update the hold status flag.
 *
 * | **Field** | **Type** | **Description** |
 * | --- | --- | --- |
 * | hold_status | boolean* | If the case is in **created** status you can update the flag hold status, that way you can choose when the case will enter the MDI flow. |
 */
export const updateHoldStatusFlag = <ThrowOnError extends boolean = false>(
  options: Options<UpdateHoldStatusFlagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Cancel case
 * Set case as cancelled.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | reason | string | A reason description (optional) |
 */
export const cancelCase = <ThrowOnError extends boolean = false>(
  options: Options<CancelCaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CancelCaseResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set case as Assigned
 * Set a given case as assigned.
 */
export const setCaseAsAssigned = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseAsAssignedData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/cases/{case_id}/assigned",
      ...options,
    }
  );
};

/**
 * Send an Approved Case to Processing
 * Send an Approved Case to Processing
 */
export const sendAnApprovedCaseToProcessing = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendAnApprovedCaseToProcessingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/cases/{case_id}/processing",
      ...options,
    }
  );
};

/**
 * Get notes
 * Return all the clinical notes for a given case.
 */
export const getNotes = <ThrowOnError extends boolean = false>(
  options: Options<GetNotesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/notes",
    ...options,
  });
};

/**
 * Detach tag
 * Detach a tag from case.
 */
export const detachTag = <ThrowOnError extends boolean = false>(
  options: Options<DetachTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/tags/{tag_id}",
    ...options,
  });
};

/**
 * Update tag note
 * Allow to update the tag note related to case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | notes | string\* | Allow to add a note when attaching tags |
 */
export const updateTagNote = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTagNoteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/tags/{tag_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach tag
 * Attach a tag to case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | notes | string | Allow to add a note when attaching tags |
 */
export const attachTag = <ThrowOnError extends boolean = false>(
  options: Options<AttachTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/cases/{case_id}/tags/{tag_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get case
 * Get the following case details:
 *
 * - Patient
 * - Partner
 * - Priority status and reason
 * - Status (if is cancelled or not)
 *
 * To get details from `prescriptions`, `files` and `questions` you must use specific API endpoints:
 *
 * - Files: check **"Partners > Cases > Files"**
 * - Prescriptions: check **"Partners > Cases > Prescriptions"**
 * - Questions: check **"Partners > Cases > Questions"**
 */
export const getCase = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetCaseResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}",
    ...options,
  });
};

/**
 * Get Services PDF
 * Get Services PDF
 */
export const getServicesPdf = <ThrowOnError extends boolean = false>(
  options: Options<GetServicesPdfData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases/{case_id}/pdf",
    ...options,
  });
};

/**
 * Create case
 * Create a new case for a given patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | hold_status | boolean | Flag to hold the status to not enter into the MDI flow. It will be **false** by default. |
 * | is_additional_approval_needed | boolean | It defines if the case needs an additional approve, |
 * | reference_case_id | uuid | The referenced case UUID |
 * | patient_id | uuid\* | Patient ID. Check **Partners > Cases > Patients** to create new patients |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | diseases | array(Disease) | List of diseases to be attached to the case (ICD). |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | case_services | array(Services) | List of services to be reviewed by a clinician |
 * | is_chargeable | boolean | Whether or not the case should be charged |
 * | tags | array(object(uuid)) | Tag ID to be attached to the case. |
 *
 * ## Diseases Properties
 *
 * **Important**: Every disease object will add the disease with the ICD (International Classification of Disease) to the case.
 *
 * `[{disease_id}, {disease_id}]`
 *
 * **Note**: Use the "Get all Disease Codes" endpoint under the metadata folder to find a list of all availables UUID to be used. Once you know a disease id, you can also retrieve its information through the API using the Get Disease route.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | disease_id | UUID | Disease ID. It can be found through the diseases endpoints. |
 *
 * ## Tag Properties
 *
 * `[{tag_id}, {tag_id}]`
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | tags | array | Tag UUID. It can be found through the tags endpoints. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed. |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Required if**: `dosespot_medication_id` is present.  <br>**Required if**: `partner_medication_id` or `partner_medication_id` does not have a registered default pharmacy.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | title | string | Prescription title |
 * | name | string | Prescription name. _Only update when its from compound otherwise it comes from Partner Medication/Supply registered._ |
 * | order | integer | The prescription ordering |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/16c57564-952c-4c9d-ad95-21993b06116b/aW1hZ2UucG5n" width="1637" height="421">
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 * | description | text | A description for your question |
 * | label | string(50) | The question label |
 * | metadata | text | A metadata field |
 * | displayed_options | array | An array of options that were displayed to the patient |
 * | is_critical | boolean | Mark question as critical |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 * | order | integer |
 */
export const createCase = <ThrowOnError extends boolean = false>(
  options?: Options<CreateCaseData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateCaseResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/cases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Messages
 * Get the patient's messages (paginated).
 */
export const getMessages = <ThrowOnError extends boolean = false>(
  options: Options<GetMessagesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetMessagesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient}/messages",
    ...options,
  });
};

/**
 * Create Message
 * Creates a patient's message, and attaches its files.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | channel\* | string |
 * | text | string |
 * | reference_message_id | uuid |
 * | files | array |
 *
 * # Payload (files)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 */
export const createMessage = <ThrowOnError extends boolean = false>(
  options: Options<CreateMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateMessageResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Message
 * Get the patient's message details.
 */
export const getMessage = <ThrowOnError extends boolean = false>(
  options: Options<GetMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetMessageResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient}/messages/{message}",
    ...options,
  });
};

/**
 * Remove pharmacy from patient
 * Removes a pharmacy from a patient’s preferred pharmacies list. This API endpoint forwards the request to DoseSpot API in order to remove patient's pharmacies.
 *
 * This does not change any existing medications in that patient’s record even if they are queued up or already sent to that pharmacy.
 */
export const removePharmacyFromPatient = <ThrowOnError extends boolean = false>(
  options: Options<RemovePharmacyFromPatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    RemovePharmacyFromPatientResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patientId}/pharmacies/{pharmacyId}",
    ...options,
  });
};

/**
 * Add pharmacy to patient
 * Adds a pharmacy to a patient’s preferred pharmacies list.
 *
 * To check a list of available pharmacies to be added to the patient, check **Partners > Pharmacies**.
 */
export const addPharmacyToPatient = <ThrowOnError extends boolean = false>(
  options: Options<AddPharmacyToPatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AddPharmacyToPatientResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patientId}/pharmacies/{pharmacyId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get pharmacies from patient
 * Retrieves a detailed list of preferred pharmacies in the patient’s record. This API endpoint forwards the request to DoseSpot API in order to retrieve this information.
 */
export const getPharmaciesFromPatient = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmaciesFromPatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPharmaciesFromPatientResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patientId}/pharmacies",
    ...options,
  });
};

/**
 * Send one-time password
 * If patient exists with the email informed then we send a verification code to the patient email.
 *
 * | **param** | **type** | **description** |
 * | --- | --- | --- |
 * | email | string\* | Patient's email |
 */
export const sendOneTimePassword = <ThrowOnError extends boolean = false>(
  options?: Options<SendOneTimePasswordData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/auth/2fa",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Validate verification code
 * This endpoint validates the verification code sent to the patient's email.
 *
 * If the code is validated then we return the patient object.
 */
export const validateVerificationCode = <ThrowOnError extends boolean = false>(
  options?: Options<ValidateVerificationCodeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/auth/2fa/validate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Drivers License Request URL
 * Get URL for Drivers License Request workflow.
 *
 * You may find additional details on embedding and auto-login [here](#98004812-41bd-4771-915e-180ec888d420).
 */
export const getDriversLicenseRequestUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDriversLicenseRequestUrlData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDriversLicenseRequestUrlResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/drivers-license",
    ...options,
  });
};

/**
 * Get Messaging App URL
 * Get Messaging App auth link URL.
 *
 * You may find additional details on embedding and auto-login [here](#98004812-41bd-4771-915e-180ec888d420).
 */
export const getMessagingAppUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetMessagingAppUrlData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetMessagingAppUrlResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/auth",
    ...options,
  });
};

/**
 * Get Intro Video Request URL
 * Get URL for Intro Video Request workflow.
 *
 * You may find additional details on embedding and auto-login [here](#98004812-41bd-4771-915e-180ec888d420).
 */
export const getIntroVideoRequestUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetIntroVideoRequestUrlData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntroVideoRequestUrlResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/intro-video",
    ...options,
  });
};

/**
 * Get File Request URL
 * Get URL for File Request workflow.
 *
 * You may find additional details on embedding and auto-login [here](#98004812-41bd-4771-915e-180ec888d420).
 */
export const getFileRequestUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetFileRequestUrlData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetFileRequestUrlResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/file-url",
    ...options,
  });
};

/**
 * Request Patient Data
 * Sends the patient data requested to the patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | patient_id | uuid | Required if not use the patient email to request their data. |
 * | patient_email | string | Required if the patient_id is empty. |
 */
export const requestPatientData = <ThrowOnError extends boolean = false>(
  options?: Options<RequestPatientDataData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/data",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Request Patient Data Deletion
 * Patient data deletion request.
 *
 * We send an email to the patient to confirm the deletion request. Once confirmed we deactivate the patient on MD Integrations application.
 */
export const requestPatientDataDeletion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RequestPatientDataDeletionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    RequestPatientDataDeletionResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}",
    ...options,
  });
};

/**
 * Update patient
 * Update a patient record both on MD Integrations and DoseSpot.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10) | Prefix |
 * | first_name | string(35) | First name |
 * | last_name | string(35) | Last name |
 * | ssn | string(11) | Security Social Number.  <br>**Format**: `AAAGGSSSS` |
 * | email | string(80) | E-mail |
 * | date_of_birth | date | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | gender | integer | Gender (ISO 5218 format) |
 * | phone_number | string(25) | Phone number - _US format_ |
 * | phone_type | integer | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35) | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9) | US zip code - _5 or 9 digit format  <br>OR  <br>_CA zip code - 6 alphanumeric characters |
 * | address.city_id | uuid | City ID. Check **Metadata > States > Cities> Get cities from a given state** to get city ID. If you use this parameter you don't need to use **city_name** parameter. |
 * | address.city_name | string(35) | City name. If you use this parameter you don't need use **city_id** parameter. |
 * | address.state_name | string | State name or State USPS abbreviation. If you use this parameter you don't need to use **city_id** parameter. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | medical_conditions | text | A medical condition information. |
 * | intro_video_id | uuid | Patient's Intro Video, needs to reference an existing **File**. Created through **Files > Create file**. |
 */
export const updatePatient = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdatePatientResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get patient exam
 * This endpoint returns the patient's exam detail.
 */
export const getPatientExam = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientExamData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/exams/{exam_id}",
    ...options,
  });
};

/**
 * Get patient exams
 * This endpoint returns all exams related to the patient passed on the request.
 */
export const getPatientExams = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientExamsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/exams",
    ...options,
  });
};

/**
 * Get patient vouchers
 * This endpoint returns all exams related to the patient passed on the request.
 */
export const getPatientVouchers = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientVouchersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/vouchers",
    ...options,
  });
};

/**
 * Get coverage
 * This endpoint returns the insurance coverage based on medication NDC and patient eligibility ID
 *
 * **P.S**.: _It returns a Dosespot response._
 */
export const getCoverage = <ThrowOnError extends boolean = false>(
  options: Options<GetCoverageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/dosespot/formulary",
    ...options,
  });
};

/**
 * Get Medications History
 * It gets the Dosespot medications history and caches it to the given patient.
 */
export const getMedicationsHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetMedicationsHistoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/dosespot/medications/history",
    ...options,
  });
};

/**
 * Create patient
 * Creates a new patient record both on MD Integrations and DoseSpot.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10) | Prefix |
 * | first_name | string(35)\* | First name |
 * | last_name | string(35)\* | Last name |
 * | ssn | string(11) | Security Social Number.  <br>**Format**: `AAAGGSSSS` |
 * | email | string(80)\* | E-mail |
 * | date_of_birth | date\* | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | gender | integer\* | Gender (ISO 5218 format) |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | phone_number | string(25)\* | Phone number - _US format_ |
 * | phone_type | integer\* | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35)\* | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9)\* | US zip code - _5 or 9 digit format  <br>OR  <br>_CA zip code - 6 alphanumeric characters |
 * | address.city_name | string(35)\* | City name. |
 * | address.state_name | string\* | State name or State USPS abbreviation. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | medical_conditions | text | Medical conditions related to the patient |
 * | intro_video_id | uuid | Patient's Intro Video, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | metafields | array | Patient custom properties |
 * | metafields.\*.key | string\* | Field key |
 * | metafields.\*.title | string | Field title (label) |
 * | metafields.\*.value | string\* | Field value |
 * | metafields.\*.type | string\* | Field type |
 */
export const createPatient = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePatientData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    CreatePatientResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Search patients
 * This route returns a list of Patients based on the `"search"` string parameter passed.
 *
 * ## Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | search | string* | Should be either the patient's full name, phone number, last name or e-mail. |
 */
export const searchPatients = <ThrowOnError extends boolean = false>(
  options?: Options<SearchPatientsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get patient
 * Get patient details.
 */
export const getPatient = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}",
    ...options,
  });
};

/**
 * Get patient events
 * Get the patient's events.
 */
export const getPatientEvents = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientEventsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientEventsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/events",
    ...options,
  });
};

/**
 * Get patient cases
 * This endpoint returns all cases related to the patient passed on the request.
 */
export const getPatientCases = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientCasesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/patients/{patient_id}/cases",
    ...options,
  });
};

/**
 * Search Supplies
 * Search DoseSpot supplies based on `name` and/or `NDC`.
 *
 * This API endpoint forwards the request to DoseSpot API in order to retrieve the supplies.
 */
export const searchSupplies = <ThrowOnError extends boolean = false>(
  options?: Options<SearchSuppliesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchSuppliesResponse,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/supplies/search",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Get all supplies
 * Get all registered supplies on your company's dashboard related to the logged in partner.
 */
export const getAllSupplies = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllSuppliesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllSuppliesResponse,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/supplies",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Search Medications
 * Search DoseSpot medications using a given name.
 *
 * This API endpoint forwards the request to DoseSpot API in order to retrieve the medications.
 *
 * The returned results can be used to get details for a given medication (check **"Partner > Medications > Get Details For a Specific Medication"**).
 */
export const searchMedications = <ThrowOnError extends boolean = false>(
  options?: Options<SearchMedicationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchMedicationsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/medications/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Details For a Specific Medication
 * Get DoseSpot medication details according given **name** and **strength**.
 *
 * This API endpoint forwards the request to Dosespot in order to retrieve the medication details.
 */
export const getDetailsForASpecificMedication = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetDetailsForASpecificMedicationData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDetailsForASpecificMedicationResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/medications/select",
    ...options,
  });
};

/**
 * Get all medications
 * Get all registered medications on your company's dashboard related to the logged in partner.
 */
export const getAllMedications = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllMedicationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllMedicationsResponse,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/medications",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Delete file
 * Delete a given file ID.
 */
export const deleteFile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/files/{file_id}",
    ...options,
  });
};

/**
 * Get file
 * Get information from a given file ID.
 *
 */
export const getFile = <ThrowOnError extends boolean = false>(
  options: Options<GetFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/files/{file_id}",
    ...options,
  });
};

/**
 * Create file
 * Upload a single file to MD Integrations using **multipart/form-data**.
 *
 * | **Type** | **Maximum Size** |
 * | --- | --- |
 * | Images files | 25mb |
 * | Video files | 140mb |
 * | Other types | 16mb |
 *
 * Accepted types:
 *
 * - document
 *
 * - review
 *
 * - other
 *
 * - insurance-policy
 *
 * - contract
 *
 * - driver-license
 *
 * - lab-result
 *
 * - photo
 *
 * - av-video
 *
 * - full-body-photo
 *
 * - back-photo
 *
 * - face-photo
 *
 * - avatar-photo
 *
 * - ipledge-document
 *
 * - auth-form
 */
export const createFile = <ThrowOnError extends boolean = false>(
  options?: Options<CreateFileData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateFileResponse,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Get pharmacies
 * Search DoseSpot pharmacies according to a given query parameter. At least **one** query parameter is required. If no query parameter is provided, an error will be thrown.
 *
 * This API endpoint forwards the request to DoseSpot in order to search for pharmacies.
 */
export const getPharmacies = <ThrowOnError extends boolean = false>(
  options?: Options<GetPharmaciesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPharmaciesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/pharmacies",
    ...options,
  });
};

/**
 * Get pharmacy
 * Get DoseSpot pharmacy details from a given pharmacy ID.
 *
 * This API endpoint forwards the request to DoseSpot in order to retrieve the pharmacy details.
 */
export const getPharmacy = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmacyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPharmacyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/pharmacies/{pharmacy_id}",
    ...options,
  });
};

/**
 * Get dispense units
 * Get DoseSpot dispense units. You can search for dispenses units using the `name` query parameter.
 *
 * This API endpoint forwards the request to DoseSpot in order to retrieve dispense units.
 */
export const getDispenseUnits = <ThrowOnError extends boolean = false>(
  options?: Options<GetDispenseUnitsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDispenseUnitsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/dispense-units",
    ...options,
  });
};

/**
 * Search for compounds
 * Search compounds belonging to the logged partner.
 *
 * In case a search term is not provided, all the available compounds are returned.
 */
export const searchForCompounds = <ThrowOnError extends boolean = false>(
  options?: Options<SearchForCompoundsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchForCompoundsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/compounds/search",
    ...options,
  });
};

/**
 * Create Partner Compoud
 * Creates a new Partner Compound record on MD Integrations.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | title | string(105) | Title |
 * | name | string(105)\* | Name |
 * | dispense_unit_id | integer\* | Dispense Unit ID |
 * | pharmacy_id | integer | Pharmacy ID |
 * | quantity | string(11)\* | Quantity |
 * | directions | string(140)\* | Directions |
 * | days_supply | integet(365) | Days Supply |
 * | refills | integer(99)\* | Refills |
 * | allow_substitutions | boolean | Allow Substituitions |
 * | clinical_note | string | _Clinician Note_ |
 * | thank_you_note | integer | Thank You Note |
 * | metadata | string(800) | The field is meant to store any information that helps identify the compound. (e.g., an ID that will be used to identify this compound in another database) |
 * | order | integer | The ordering field for the compounds |
 * | effective_date | integer | Effective Date (In Days) |
 * | diseases | array | Diseases attached to the Compound |
 * | diseases.\*.disease_id | UUID\* | Diseases ID. Check **Diseases** to check the existing diseases |
 *
 * ## Diseases Properties
 *
 * **Important**: Every disease object will add the disease with the ICD (International Classification of Disease) to the case.
 *
 * `[{disease_id}, {disease_id}]`
 *
 * **Note**: Diseases can be found in the diseases list on your company's dashboard. Once you know a disease's id, you can also retrieve its information through the API using the **Get Disease** route.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | disease_id | UUID | Disease ID.It can be found on your company's dashboard or through the diseases endpoints. |
 */
export const createPartnerCompoud = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePartnerCompoudData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    CreatePartnerCompoudResponse,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/compounds",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Get Service
 * Returns a single Partner Service that can be used as a template to generate a Case Service.
 */
export const getService = <ThrowOnError extends boolean = false>(
  options: Options<GetServiceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/services/{partner_service_id}",
    ...options,
  });
};

/**
 * List Services
 * Returns a single Partner Service that can be used as a template to generate a Case Service.
 */
export const listServices = <ThrowOnError extends boolean = false>(
  options?: Options<ListServicesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/services",
      ...options,
    }
  );
};

/**
 * Get vouchers
 * This endpoint returns all vouchers related to the filters passed on the request.
 */
export const getVouchers = <ThrowOnError extends boolean = false>(
  options?: Options<GetVouchersData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/vouchers/",
      ...options,
    }
  );
};

/**
 * Delete Voucher
 * Deletes the partner's voucher.
 */
export const deleteVoucher = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVoucherData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/vouchers/{voucher_id}",
    ...options,
  });
};

/**
 * Get voucher
 * Return voucher data for a voucher ID.
 *
 * You may find additional details on embedding at [this](https://galactic-shadow-134413.postman.co/workspace/MD-Integrations~0bf566d7-bf01-4290-ab8e-1f3cf71a8da6/request/14212272-98004812-41bd-4771-915e-180ec888d420?action=share&source=copy-link&creator=14212272&ctx=documentation) documentation.
 */
export const getVoucher = <ThrowOnError extends boolean = false>(
  options: Options<GetVoucherData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/vouchers/{voucher_id}",
    ...options,
  });
};

/**
 * Create voucher
 * Creates a new voucher.
 *
 * ## Payload
 *
 * **Important**: when creating a voucher you can specify the medications, compounds and services to be used.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | **questionnaire_id** | **uuid**\* | Partner Questionnaire ID. It can be found on your company's dashboard or using **Patient App > Questionnaires > List questionnaires** |
 * | patient_id | uuid | Patient ID. |
 * | hold_status | boolean | Flag to hold the status to not enter into the MDI flow. It will be **false** by default. |
 * | demo | boolean | Demo vouchers will not create any patient or cases and will not expire. Default `false` |
 * | expires_at | datetime | If not passed then the default will be a month ahead. |
 * | case_services | array | It can be empty |
 * | case_services**.\*.**partner_service_id | uuid\* | Partner Service ID. It can be found on your company's dashboard. Required if is present. |
 * | case_prescriptions | array | It can be empty |
 * | case_prescriptions**.\*.**partner_compound_id | uuid\* | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. Required if is present. |
 * | case_prescriptions**.\*.**partner_medication_id | uuid\* | Partner medication ID. It can be found on your company's dashboard. Required if is present. |
 * | diseases | array | it can be empty or null. |
 * | diseases.**\*.**disease_id | uuid | Disease ID. It can be found on your company's dashboard or through the diseases endpoint. Nullable. |
 * | metadata | string (255) | Metadata value. It can be empty or null. |
 * | pharmacy_id | integer | the Dosespot Pharmacy ID.  <br>  <br>Check **Partners** > **Pharmacies** > **Get pharmacies** to get a list of all pharmacies available. |
 *
 * You may find additional details on embedding [here](#98004812-41bd-4771-915e-180ec888d420).
 */
export const createVoucher = <ThrowOnError extends boolean = false>(
  options?: Options<CreateVoucherData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/vouchers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Expire Voucher
 * Expires the partner's voucher.
 */
export const expireVoucher = <ThrowOnError extends boolean = false>(
  options: Options<ExpireVoucherData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/vouchers/{voucher_id}/expire",
      ...options,
    }
  );
};

/**
 * List questions
 * Return all questions given a questionnaire ID.
 */
export const listQuestions = <ThrowOnError extends boolean = false>(
  options: Options<ListQuestionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/questionnaires/{questionnaire_id}/questions",
    ...options,
  });
};

/**
 * List questionnaires
 * Return all enabled partner questionnaires based on the logged in partner.
 */
export const listQuestionnaires = <ThrowOnError extends boolean = false>(
  options?: Options<ListQuestionnairesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/questionnaires",
      ...options,
    }
  );
};

/**
 * Get questionnaire
 * Return the specific enabled partner questionnaire given a questionnaire ID.
 */
export const getQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionnaireData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/questionnaires/{questionnaire_id}",
    ...options,
  });
};

/**
 * Get clinician information
 * Get clinician information based on the passed clinician_id.
 */
export const getClinicianInformation = <ThrowOnError extends boolean = false>(
  options: Options<GetClinicianInformationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/clinicians/{clinician_id}",
    ...options,
  });
};

/**
 * Get support staff information
 * It gets the internal support staff details.
 */
export const getSupportStaffInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSupportStaffInformationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/support-staffs/{support_staff_id}",
    ...options,
  });
};

/**
 * Get internal support staff information
 * It gets the internal support staff details (MDI Support users).
 */
export const getInternalSupportStaffInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetInternalSupportStaffInformationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/internal-support-staffs/{internal_support_staff_id}",
    ...options,
  });
};

/**
 * Get medical assistant information
 * It gets the internal support staff details (MDI Support users).
 */
export const getMedicalAssistantInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMedicalAssistantInformationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/medical-assistants/{medical_assistant_id}",
    ...options,
  });
};

/**
 * Get Partner Notifications
 * List all notifications for current logged in Partner
 */
export const getPartnerNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetPartnerNotificationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPartnerNotificationsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/notifications",
    ...options,
  });
};

/**
 * Get Partner Notification
 * View a Partner Notification base off his UUID
 */
export const getPartnerNotification = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerNotificationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPartnerNotificationResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/notifications/{partner_notification_id}",
    ...options,
  });
};

/**
 * Create Encounter
 * Create a new encounter for a given patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | patient_id | uuid\* | Patient ID. Check **Partners > Cases > Patients** to create new patients |
 * | reference_case_id | uuid | The referenced case UUID |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid\* | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_services | array(Service) | List of services to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | is_chargeable | boolean | Whether or not the case should be charged |
 * | tags | array(object(uuid)) | Tags ID to be attached to the case. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`, `dosespot_supply_ndc`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found on your company's dashboard. **Required if** `dosespot_medication_id` and `partner_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found on your company's dashboard. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `dosespot_supply_ndc` are `null` |
 * | dosespot_supply_ndc | string | Dosespot Supply NDC code. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/b5039151-5d8d-48e7-8fda-24feff80438b/aW1hZ2UucG5n" width="1637" height="421">
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 * | description | text | A description for your question |
 * | label | string(50) | The question label |
 * | metadata | text | A metadata field |
 * | displayed_options | array | An array of options that were displayed to the patient |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 */
export const createEncounter = <ThrowOnError extends boolean = false>(
  options?: Options<CreateEncounterData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateEncounterResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner/tests/encounters",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Encounter Status
 * Create a new encounter for a given patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | status | string\* | The new status (assigned, processing, waiting, support, cancelled, resubmit, completed) |
 * | reason | string | The reason. Necessary if the status is cancelled or waiting. |
 * | clinician_id | uuid\* | Clinician to simulate the action. |
 */
export const postEncounterStatus = <ThrowOnError extends boolean = false>(
  options: Options<PostEncounterStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/tests/encounters/{encounter_id}/status",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Encounter Prescription
 * Create a encounter prescription.
 *
 * # Payload
 *
 * Receives an object of **Prescription**.
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`, `dosespot_supply_ndc`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | clinician_id | uuid\* | Clinician to simulate the action |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `dosespot_supply_ndc` are `null` |
 * | dosespot_supply_ndc | string | Dosespot Supply NDC code. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/f2e85db2-8cd9-4f25-ae04-8e72d17fdb0a/aW1hZ2UucG5n" width="1637" height="421">
 */
export const createEncounterPrescription = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateEncounterPrescriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/tests/encounters/{encounter_id}/prescriptions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Reassign clinician to encounter
 * Reassign a given clinician to a given encounter.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | clinician_id | uuid\* | Clinician UUID |
 * | reason | string | A reason for the assignment. |
 */
export const reassignClinicianToEncounter = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReassignClinicianToEncounterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/tests/encounters/{encounter_id}/reassign",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Patient and Encounter
 * Create a new patient and encounter.
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | preferred_pharmacy_id | integer | Dosespot Pharmacy ID |
 * | questionnaire_id | uuid\* | Questionnaire ID |
 * | completion_time | string\* | Time in the format "hh:mm:ss" |
 *
 * # Patient Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10)\* | Prefix |
 * | first_name | string(35)\* | First name |
 * | last_name | string(35)\* | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80)\* | E-mail |
 * | date_of_birth | date\* | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | gender | integer\* | Gender (ISO 5218 format) |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | phone_number | string(25)\* | Phone number - _US format_ |
 * | phone_type | integer\* | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35)\* | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9)\* | US zip code - _5 or 9 digit format\*_OR\*CA zip code - 6 alphanumeric characters |
 * | address.city_name | string(35)\* | City name. |
 * | address.state_name | string\* | State name or State USPS abbreviation. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | intro_video_id | uuid | Patient's Intro Video, needs to reference an existing **File**. Created through **Files > Create file**. |
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | case_services | array(Services) | List of services to be reviewed by a clinician |
 * | tags | array(uuid) | Tags ID to be attached to the case. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Required if**: `dosespot_medication_id` is present.  <br>**Required if**: `partner_medication_id` or `partner_medication_id` does not have a registered default pharmacy.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 *
 * # Diseases
 *
 * **Important**: Every disease object will add the disease with the ICD (International Classification of Disease) to the case.
 *
 * **Note**: Diseses can be found on the diseases page on the Admin panel. Once you know a disease id, you can also retrieve its information through the API using the Get Disease route.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | disease_id | UUID | Disease ID. It can be found through the diseases endpoints. |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 */
export const createPatientAndEncounter = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatientAndEncounterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/tests/vouchers/{voucher_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Message
 * Creates a patient's message, and attaches its files.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | channel\* | string |
 * | clinician_id | uuid |
 * | support_staff_id | uuid |
 * | text | string |
 * | reference_message_id | uuid |
 * | files | array |
 *
 * # Payload (files)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 */
export const createMessage1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateMessage1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/partner/tests/patients/{patient_id}/messages",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Embedding URLs
 * The following documentation applies to all white label experiences. Some of this functionality might be limited to certain events.
 *
 * ``` html
 * <iframe src="{{ mdi_url }}" allow="camera; microphone"></iframe>
 *
 * ```
 *
 * ## Embedded Form
 *
 * If you plan on embedding the intake form on your own page, you may append the following query parameter at the end of the URL provided on workflow request responses to remove borders, branding and other visual elements for a seamless experience:
 *
 * | param | type | description |
 * | --- | --- | --- |
 * | **fullscreen** | boolean\* | If set to TRUE will remove borders, logos and other visual elements from around the intake form window to make it seamless when embedding it. |
 *
 * You may also subscribe to [window postMessage events](https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage) to keep track of important events and user progress. Different workflows may trigger different events.
 *
 * | event | data | description | **scope** |
 * | --- | --- | --- | --- |
 * | load | \- | White Label App loaded | all |
 * | unload | \- | User is attempting to close the screen | all |
 * | start | \- | User has started filling out the questionnaire | intake form |
 * | finish | \- | User has finished the intake form | intake form |
 * | step | step, index, estimated, total, question_id\* | User has progressed through a step. It can either be a demographic step or customized question | intake form |
 * | logged_in | patient_id | User has logged in | all |
 * | encounter_created | encounter_id, patient_id | Encounter created | intake form |
 * | patient_created | patient_id | Patient created | intake form |
 * | skipped_question | \- | User has skipped a question and progressed through a step. | intake form |
 * | dead_end_question | \- | User has reached a question that blocks her from progressing on the intake. | intake form |
 * | otp_ready¹ | \- | User has reached the OTP screen | all |
 * | otp_failed¹ | \- | Provided OTP is invalid | all |
 *
 * An embedded white label app will also support certain events and messages:
 *
 * | **message** | **data** | **description** | **scope** |
 * | --- | --- | --- | --- |
 * | otp¹ | _string_ | Sends in an OTP to be inputted and auto submits the form. Use this message to create a seamless login experience on workflows that require additional authentication | OTP pages |
 *
 * The following sample showcases how one of the events above would be sent client-side to an iframe with one of our white label experiences embedded:
 *
 * ``` typescript
 * const payload = {
 * message: 'otp',
 * data: 'ABCDEF',
 * };
 * iFrame?.contentWindow?.postMessage(payload, '*');
 *
 * ```
 *
 * Note by Nov. 12th we will no longer return pre-authenticated URLs for the white label workflows², effectively requiring an OTP code to be inserted manually by the user. If you are embedding them on your website and want to keep a seamless login experience, you should listen for a `otp_ready` event from the iframe and send an `otp` message with the verification_code returned by the workflow endpoint like so:
 *
 * ``` typescript
 * window.addEventListener('message', (e) => {
 * const event = e.data.event;
 * if (event === 'otp_ready') {
 * iframe.contentWindow.postMessage({ message: 'otp', data: verification_code }, '*');
 * }
 * });
 *
 * ```
 *
 * ¹: Feature will only be available after Nov 12th, 2024.
 * ²: Intake Forms are excluded from this change.
 */
export const embeddingUrls = <ThrowOnError extends boolean = false>(
  options?: Options<EmbeddingUrlsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/",
      ...options,
    }
  );
};

/**
 * Case Created
 * This event will be dispatched when a case has been created.
 *
 * [<b>https://your.api.endpoint/</b>](https://your.api.endpoint/) = _Your API endpoint previously registered on our platform._
 *
 * **Secret Key** = _Your Secret Key previously registered on our platform._
 *
 * The request will have a header called Signature created by Secret Key that will contain a signature the receiving app can use to verify the payload hasn't been tampered with.
 *
 * To create the Signature we use the Secret Key as a salt with SHA256 following this example below:
 *
 * `$signature = hash_hmac('sha256', json_encode(payload), secret);`
 *
 * **Authorization** = _Your Authorization previously registered on our platform._
 *
 * The request will have a header called Authorization used to authenticate to your API
 */
export const caseCreated = <ThrowOnError extends boolean = false>(
  options?: Options<CaseCreatedData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get authenticated partner
 * Get the following logged partner information:
 *
 * - Profile
 * - Address
 *
 */
export const getAuthenticatedPartner = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthenticatedPartnerData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthenticatedPartnerResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partner",
    ...options,
  });
};

/**
 * Request access token
 * With this endpoint, you can exchange your **Client ID** and **Client Secret** for an access token with _limited lifetime_.
 *
 * The access token allows your application to make authenticated requests to the MD Integrations API.
 *
 * For more details on the expected flow, you can checkout the **Authentication** section in the **Introduction**.
 *
 * ## Payload
 *
 * For this request, all fields in the payload are **required**.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | grant_type | string\* | Should always be `client_credentials` |
 * | client_id | string\* | Client ID credential |
 * | client_secret | string\* | Client Secret credential |
 * | scope | string\* | Should always be `\*` |
 *
 * ## Expired tokens
 *
 * Whenever an access token expires, you should request a brand new one for making new requests.
 *
 * ## Client Credentials
 *
 * Your credentials will be provided to you by the MD Integrations team.
 *
 * Keep in mind the importance of **protecting your credentials** to avoid unauthorized access.
 */
export const requestAccessToken = <ThrowOnError extends boolean = false>(
  options?: Options<RequestAccessTokenData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    RequestAccessTokenResponse,
    unknown,
    ThrowOnError
  >({
    url: "/partner/auth/token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get API status
 * Return the current API status. If the API is working as expected, you should receive **200 OK**.
 *
 * For details about error codes, check **"API Errors > Error Codes"** from **Introduction** section.
 *
 * | **Available Plataforms** |
 * | --- |
 * | `api` |
 * | `patient-app` |
 * | `partner-app` |
 * | `clinician-app` |
 * | `messaging-app` |
 */
export const getApiStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetApiStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/status/{plataform}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Validate verification code
 * This endpoint validates the verification code sent to the patient's email.
 */
export const validateVerificationCode1 = <ThrowOnError extends boolean = false>(
  options?: Options<ValidateVerificationCode1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/auth/2fa/validate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Send one-time password
 * If patient exists with the email informed then we send a verification code to the patient email.
 *
 * | **param** | **type** | **description** |
 * | --- | --- | --- |
 * | email | string\* | Patient's email |
 * | voucher_id | uuid | The partner voucher ID. |
 */
export const sendOneTimePassword1 = <ThrowOnError extends boolean = false>(
  options?: Options<SendOneTimePassword1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/auth/2fa",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach File
 * Attach a file to the case.
 */
export const attachFile = <ThrowOnError extends boolean = false>(
  options: Options<AttachFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/cases/{case}/files/{file}",
      ...options,
    }
  );
};

/**
 * Create case
 * Create a new case.
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MD Integrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | case_services | array(Services) | List of services to be reviewed by a clinician |
 * | tags | array(uuid) | Tags ID to be attached to the case. |
 * | is_additional_approval_needed | boolean | If the case needs an additional approval |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise to add a medication to the Admin Panel so it's easier to manage a prescription's details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found at the Admin Panel. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found at the Admin Panel. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Required if**: `dosespot_medication_id` is present.  <br>**Required if**: `partner_medication_id` or `partner_medication_id` does not have a registered default pharmacy.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The prescription ordering |
 * | is_additional_approval_needed | boolean | If the case needs an additional approval |
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | text\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 * | description | text | A description for your question |
 * | label | string(50) | The question label |
 * | metadata | text | A metadata field |
 * | displayed_options | array | An array of options that were displayed to the patient |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found at the partner details page on the Admin panel. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 * | order | integer |
 *
 * # Diseases
 *
 * **Important**: Every disease object will add the disease with the ICD (International Classification of Disease) to the case.
 *
 * **Note**: Diseases can be found in the diseases list on the Admin panel. Once you know a disease's id, you can also retrieve its information through the API using the **Get Disease** route.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | disease_id | UUID | Disease ID. It can be found at the Admin Panel or through the diseases endpoints. |
 *
 * # Other Params
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | preferred_pharmacy_id | integer | Dosespot Pharmacy ID |
 * | voucher_id | uuid | Optional voucher created by partners. |
 * | questionnaire_id | uuid\* | Quesionnaire ID |
 * | completion_time | string\* | Time in the format "hh:mm:ss" |
 */
export const createCase1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateCase1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/patients/{patient}/cases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get patient cases
 * Get all patient cases.
 */
export const getPatientCases1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientCases1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}/cases",
    ...options,
  });
};

/**
 * Get patient case
 * Get patient case details.
 */
export const getPatientCase = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientCaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}/cases/{case_id}",
    ...options,
  });
};

/**
 * Get patient case prescriptions
 * Get all case prescriptions and services.
 */
export const getPatientCasePrescriptions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientCasePrescriptionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/cases/{case}/prescriptions",
    ...options,
  });
};

/**
 * Get all patient partners
 * Return all partners related to the logged in patient.
 */
export const getAllPatientPartners = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllPatientPartnersData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/partners",
      ...options,
    }
  );
};

/**
 * Get partner
 * Return partner data based on the logged in patient.
 */
export const getPartner = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}/partner",
    ...options,
  });
};

/**
 * Get pharmacies
 * Search DoseSpot pharmacies according to a given query parameter. At least **one** query parameter is required. If no query parameter is provided, an error will be thrown.
 *
 * This API endpoint forwards the request to DoseSpot in order to search for pharmacies.
 */
export const getPharmacies1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetPharmacies1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/pharmacies",
      ...options,
    }
  );
};

/**
 * Get pharmacy
 * Get DoseSpot pharmacy details from a given pharmacy ID.
 *
 * This API endpoint forwards the request to DoseSpot in order to retrieve the pharmacy details.
 *
 * **Important note**:
 *
 * For each environment (**staging** and **production**) Dosespot works with different IDs for the pharmacies.
 *
 * For example:
 *
 * - In a **Staging** environment, the **Curexa** pharmacy ID is **13012**.
 *
 * - In a **Production** environment, the **Curexa** pharmacy ID changes to **29992**.
 */
export const getPharmacy1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmacy1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/pharmacies/{pharmacy_id}",
    ...options,
  });
};

/**
 * Set Preferred Pharmacy
 * Set the patient's preferred pharmacy.
 */
export const setPreferredPharmacy = <ThrowOnError extends boolean = false>(
  options: Options<SetPreferredPharmacyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{patient}/pharmacies/{pharmacy}",
    ...options,
  });
};

/**
 * Refresh token
 * Refresh the patient bearer token.
 */
export const refreshToken = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshTokenData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/auth/refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create file
 * Upload a single file to MD Integrations using **multipart/form-data**.
 *
 * | **Type** | **Maximum Size** |
 * | --- | --- |
 * | Images files | 25mb |
 * | Video files | 140mb |
 * | Other types | 16mb |
 *
 * Accepted types:
 *
 * - document
 *
 * - review
 *
 * - other
 *
 * - insurance-policy
 *
 * - contract
 *
 * - driver-license
 *
 * - lab-result
 *
 * - photo
 *
 * - av-video
 *
 * - full-body-photo
 *
 * - back-photo
 *
 * - face-photo
 *
 * - avatar-photo
 *
 * - ipledge-document
 *
 * - auth-form
 */
export const createFile1 = <ThrowOnError extends boolean = false>(
  options?: Options<CreateFile1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Delete file
 * Delete a given file ID.
 */
export const deleteFile1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFile1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/files/{file_id}",
    ...options,
  });
};

/**
 * Get file
 * Get information from a given file ID.
 *
 */
export const getFile1 = <ThrowOnError extends boolean = false>(
  options: Options<GetFile1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/files/{file_id}",
    ...options,
  });
};

/**
 * Get patient exams
 * Get all patient cases.
 */
export const getPatientExams1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientExams1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}/exams",
    ...options,
  });
};

/**
 * List states by country abbreviation
 * Return all states based on the country abbreviation.
 */
export const listStatesByCountryAbbreviation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListStatesByCountryAbbreviationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/countries/{abbreviation}/states",
    ...options,
  });
};

/**
 * Request patient data deletion
 * Patient data deletion request.
 *
 * We send an email to the patient to confirm the deletion request. Once confirmed we deactivate the patient on MD Integrations application.
 */
export const requestPatientDataDeletion1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RequestPatientDataDeletion1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}",
    ...options,
  });
};

/**
 * Get authenticated patient
 * Return the authenticated patient information.
 */
export const getAuthenticatedPatient = <ThrowOnError extends boolean = false>(
  options: Options<GetAuthenticatedPatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}",
    ...options,
  });
};

/**
 * Update patient
 * Update a patient record on MD Integrations.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10) | Prefix |
 * | first_name | string(35) | First name |
 * | middle_name | string(35) | Middle name |
 * | last_name | string(35) | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80) | E-mail |
 * | date_of_birth | date | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | gender | integer | Gender (ISO 5218 format) |
 * | phone_number | string(25) | Phone number - _US format_ |
 * | phone_type | integer | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35) | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9) | US zip code - _5 or 9 digit format\*_OR\*CA zip code - 6 alphanumeric characters |
 * | address.city_id | uuid | City ID. Check **Metadata > States > Cities> Get cities from a given state** to get city ID. If you use this parameter you don't need to use **city_name** parameter. |
 * | address.city_name | string(35) | City name. If you use this parameter you don't need use **city_id** parameter. |
 * | address.state_name | string | State name or State USPS abbreviation. If you use this parameter you don't need to use **city_id** parameter. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | medical_conditions | text | Medical conditions related to the patient. |
 * | intro_video_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 */
export const updatePatient1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePatient1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Request patient data
 * Sends the patient data requested to the patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | patient_id | uuid | Required if not use the patient email to request their data. |
 * | patient_email | string | Required if the patient_id is empty. |
 */
export const requestPatientData1 = <ThrowOnError extends boolean = false>(
  options: Options<RequestPatientData1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/patients/{patient}/data",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create file
 * Upload a single file to MD Integrations using **multipart/form-data**.
 */
export const createFile2 = <ThrowOnError extends boolean = false>(
  options: Options<CreateFile2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      ...formDataBodySerializer,
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/{voucher_id}/files",
      ...options,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete file
 * Delete a given file ID.
 */
export const deleteFile2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFile2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/files/{file_id}",
    ...options,
  });
};

/**
 * Get file
 * Get information from a given file ID.
 *
 */
export const getFile2 = <ThrowOnError extends boolean = false>(
  options: Options<GetFile2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/files/{file_id}",
    ...options,
  });
};

/**
 * Set completion time
 * Set the completion time of the question.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | completion_time | string* | Time in the format "hh:mm:ss" |
 */
export const setCompletionTime = <ThrowOnError extends boolean = false>(
  options: Options<SetCompletionTimeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/{voucher_id}/questions/{question_id}/statistics/completion-time",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * List questions
 * Return all questions given a voucher ID and a questionnaire ID.
 */
export const listQuestions1 = <ThrowOnError extends boolean = false>(
  options: Options<ListQuestions1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/questionnaires/{questionnaire_id}/questions",
    ...options,
  });
};

/**
 * Set dropped from
 * Set the completion time of the questionnaire.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | dropped_from | string* | The page or step the user dropped from |
 */
export const setDroppedFrom = <ThrowOnError extends boolean = false>(
  options: Options<SetDroppedFromData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/{voucher_id}/questionnaires/{questionnaire_id}/statistics/dropped-from",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * List questionnaires
 * Return all enabled partner questionnaires given a voucher ID created by a partner.
 */
export const listQuestionnaires1 = <ThrowOnError extends boolean = false>(
  options: Options<ListQuestionnaires1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/questionnaires",
    ...options,
  });
};

/**
 * Get questionnaire
 * Return the specific enabled partner questionnaire given a voucher ID created by a partner.
 */
export const getQuestionnaire1 = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionnaire1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/questionnaires/{questionnaire_id}",
    ...options,
  });
};

/**
 * List states by partner operation country
 * Return all states based on the partner operation country.
 */
export const listStatesByPartnerOperationCountry = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListStatesByPartnerOperationCountryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/states",
    ...options,
  });
};

/**
 * Get pharmacies
 * Search DoseSpot pharmacies according to a given query parameter. At least **one** query parameter is required. If no query parameter is provided, an error will be thrown.
 *
 * This API endpoint forwards the request to DoseSpot in order to search for pharmacies.
 */
export const getPharmacies2 = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmacies2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/pharmacies",
    ...options,
  });
};

/**
 * Get pharmacy
 * Get DoseSpot pharmacy details from a given pharmacy ID.
 *
 * This API endpoint forwards the request to DoseSpot in order to retrieve the pharmacy details.
 *
 * **Important note**:
 *
 * For each environment (**staging** and **production**) Dosespot works with different IDs for the pharmacies.
 *
 * For example:
 *
 * - In a **Staging** environment, the **Curexa** pharmacy ID is **13012**.
 *
 * - In a **Production** environment, the **Curexa** pharmacy ID changes to **29992**.
 */
export const getPharmacy2 = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmacy2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/{voucher_id}/pharmacies/{pharmacy_id}",
    ...options,
  });
};

/**
 * Get voucher
 * Return partner data given a partner ID.
 */
export const getVoucher1 = <ThrowOnError extends boolean = false>(
  options: Options<GetVoucher1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/vouchers/{voucher_id}",
    ...options,
  });
};

/**
 * Validate Patient information
 * Validates patient data as they are passed in the request.
 *
 * # Patient Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | first_name | string(35) | First name |
 * | last_name | string(35) | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80) | E-mail |
 * | date_of_birth | date | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | gender | integer | Gender (ISO 5218 format) |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | phone_number | string(25) | Phone number - _US format_ |
 * | phone_type | integer | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35) | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9) | US zip code - _5 or 9 digit format  <br>OR  <br>_CA zip code - 6 alphanumeric characters |
 * | address.city_name | string(35) | City name. |
 * | address.state_name | string | State name or State USPS abbreviation. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 */
export const validatePatientInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ValidatePatientInformationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/{voucher_id}/patients/validate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Patient and Case
 * Create a new patient and case.
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | preferred_pharmacy_id | integer | Dosespot Pharmacy ID |
 * | questionnaire_id | uuid\* | Questionnaire ID |
 * | completion_time | string\* | Time in the format "hh:mm:ss" |
 *
 * # Patient Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10)\* | Prefix |
 * | first_name | string(35)\* | First name |
 * | last_name | string(35)\* | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80)\* | E-mail |
 * | date_of_birth | date\* | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | gender | integer\* | Gender (ISO 5218 format) |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | phone_number | string(25)\* | Phone number - _US format_ |
 * | phone_type | integer\* | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35)\* | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9)\* | US zip code - _5 or 9 digit format\*_OR\*CA zip code - 6 alphanumeric characters |
 * | address.city_name | string(35)\* | City name. |
 * | address.state_name | string\* | State name or State USPS abbreviation. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | medical_conditions | text | Medical conditions related to the patient. |
 * | intro_video_id | uuid | Patient's Intro Video, needs to reference an existing **File**. Created through **Files > Create file**. |
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | case_services | array(Services) | List of services to be reviewed by a clinician |
 * | tags | array(uuid) | Tags ID to be attached to the case. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Required if**: `dosespot_medication_id` is present.  <br>**Required if**: `partner_medication_id` or `partner_medication_id` does not have a registered default pharmacy.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The presrcription ordering |
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 *
 * # Diseases
 *
 * **Important**: Every disease object will add the disease with the ICD (International Classification of Disease) to the case.
 *
 * **Note**: Diseses can be found on the diseases page on the Admin panel. Once you know a disease id, you can also retrieve its information through the API using the Get Disease route.
 *
 * field
 *
 * | type | description |
 * | --- | --- |
 * | disease_id | UUID | Disease ID. It can be found through the diseases endpoints. |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 * | order | integer |
 */
export const createPatientAndCase = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatientAndCaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/{voucher_id}/cases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Patient
 * Create a new patient and case.
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | preferred_pharmacy_id | integer | Dosespot Pharmacy ID |
 * | questionnaire_id | uuid\* | Questionnaire ID |
 * | completion_time | string\* | Time in the format "hh:mm:ss" |
 *
 * # Patient Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10)\* | Prefix |
 * | first_name | string(35)\* | First name |
 * | last_name | string(35)\* | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80)\* | E-mail |
 * | date_of_birth | date\* | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | gender | integer\* | Gender (ISO 5218 format) |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | phone_number | string(25)\* | Phone number - _US format_ |
 * | phone_type | integer\* | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35)\* | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9)\* | US zip code - _5 or 9 digit format\*_OR\*CA zip code - 6 alphanumeric characters |
 * | address.city_name | string(35)\* | City name. |
 * | address.state_name | string\* | State name or State USPS abbreviation. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | medical_conditions | text | Medical conditions related to the patient. |
 * | intro_video_id | uuid | Patient's Intro Video, needs to reference an existing **File**. Created through **Files > Create file**. |
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | case_services | array(Services) | List of services to be reviewed by a clinician |
 * | tags | array(uuid) | Tags ID to be attached to the case. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise to add a medication to the Admin Panel so it's easier to manage a prescription's details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found at the Admin Panel. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found at the Admin Panel. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Required if**: `dosespot_medication_id` is present.  <br>**Required if**: `partner_medication_id` or `partner_medication_id` does not have a registered default pharmacy.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The presrcription ordering |
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 *
 * # Diseases
 *
 * **Important**: Every disease object will add the disease with the ICD (International Classification of Disease) to the case.
 *
 * **Note**: Diseases can be found in the diseases list on the Admin panel. Once you know a disease's id, you can also retrieve its information through the API using the **Get Disease** route.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | disease_id | UUID | Disease ID. It can be found at the Admin Panel or through the diseases endpoints. |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found at the partner details page on the Admin panel. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 * | order | integer |
 */
export const createPatient1 = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatient1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/{voucher_id}/patients",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Patch Questionnaire Progress
 * Save the progress of intake responses.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question_id | uuid\* | Questionnaire ID |
 * | answers | string\* | Answer |
 * | file_id | uuid\* | Files |
 */
export const patchQuestionnaireProgress = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchQuestionnaireProgressData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/vouchers/{voucher_id}/progress",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Messages
 * Get the patient's messages (paginated).
 */
export const getMessages1 = <ThrowOnError extends boolean = false>(
  options: Options<GetMessages1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}/messages",
    ...options,
  });
};

/**
 * Create Message
 * Creates a patient's message, and attaches its files.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | channel\* | string |
 * | text | string |
 * | reference_message_id | uuid |
 * | files | array |
 *
 * # Payload (files)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 */
export const createMessage2 = <ThrowOnError extends boolean = false>(
  options: Options<CreateMessage2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/patients/{patient}/messages",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Message
 * Get the patient's message details.
 */
export const getMessage1 = <ThrowOnError extends boolean = false>(
  options: Options<GetMessage1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/patient/patients/{patient}/messages/{message}",
    ...options,
  });
};

/**
 * Read Message
 * Reads the patient's message.
 */
export const readMessage = <ThrowOnError extends boolean = false>(
  options: Options<ReadMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/patient/patients/{patient}/messages/{message}/read",
      ...options,
    }
  );
};

/**
 * Get Articles
 * Get the articles (paginated).
 */
export const getArticles = <ThrowOnError extends boolean = false>(
  options?: Options<GetArticlesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/articles",
      ...options,
    }
  );
};

/**
 * Get Article
 * Get the article details.
 */
export const getArticle = <ThrowOnError extends boolean = false>(
  options: Options<GetArticleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/articles/{article}",
    ...options,
  });
};

/**
 * Create access token
 * Send a 2FA code to the clinician email to allow to login in the application.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | username | string(80)\* | Clinician's e-mail |
 * | password | string(35)\* | Clinician's password |
 */
export const createAccessToken = <ThrowOnError extends boolean = false>(
  options?: Options<CreateAccessTokenData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/clinician/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Validate 2FA Code
 * Generate an access token for a clinician.
 *
 * Considering you have a registered clinician record, you may request an access token using the user's e-mail address and the 2FA code sent to the email.
 *
 * Access tokens expire **24 hours** after they are issued. Once a token gets expired you will start receiving **401 Unauthorized HTTP** responses. To refresh your access token check _Clinician > Access Tokens > Refresh access token_.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | email | string(80)\* | Clinician's e-mail |
 * | code | string(6)\* | Clinician's code sent to their email. |
 */
export const validate2FaCode = <ThrowOnError extends boolean = false>(
  options?: Options<Validate2FaCodeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/clinician/auth/2fa/validate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Check inactivity
 * Check the clinician inactivity using the Bearer Token and the passoword.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | password | string(80)\* | Clinician's password |
 */
export const checkInactivity = <ThrowOnError extends boolean = false>(
  options?: Options<CheckInactivityData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/auth/inactivity/check",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Refresh access token
 * Refreshes an access token for a clinician.
 *
 * Considering you have an expired access token, you can issue a new access token using the `refresh_token`.
 *
 * The `refresh_token` information is obtained on the response after generating a new access token (_Clinician > Access Tokens > Create access token_).
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | refresh_token | JWT* | Refresh token information obtained when a new access token is created (_Clinician > Access Tokens > Create access token_) |
 */
export const refreshAccessToken = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshAccessTokenData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/auth/refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get coverage
 * This endpoint returns the coverage information based on medication NDC and patient eligibility ID.
 */
export const getCoverage1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCoverage1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/dosespot/formulary",
    ...options,
  });
};

/**
 * Get Medications History
 * It returns the patient's medication history cached from Dosespot.
 */
export const getMedicationsHistory1 = <ThrowOnError extends boolean = false>(
  options: Options<GetMedicationsHistory1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/dosespot/medications/history",
    ...options,
  });
};

/**
 * Cache Medications History
 * It gets the Dosespot medications history and caches it to the given patient.
 */
export const cacheMedicationsHistory = <ThrowOnError extends boolean = false>(
  options: Options<CacheMedicationsHistoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/dosespot/medications/history",
    ...options,
  });
};

/**
 * Get Files
 * Get the patient's message's files (paginated).
 */
export const getFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetFilesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages/{message}/files",
    ...options,
  });
};

/**
 * Attach File
 * Attach the file to the patient's message.
 */
export const attachFile1 = <ThrowOnError extends boolean = false>(
  options: Options<AttachFile1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages/{message}/files/{file}",
    ...options,
  });
};

/**
 * Get Readings
 * Get the patient's message's readings (paginated).
 */
export const getReadings = <ThrowOnError extends boolean = false>(
  options: Options<GetReadingsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages/{message}/readings",
    ...options,
  });
};

/**
 * Get Messages
 * Get the patient's messages (paginated).
 */
export const getMessages2 = <ThrowOnError extends boolean = false>(
  options: Options<GetMessages2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages",
    ...options,
  });
};

/**
 * Create Message
 * Creates a patient's message, and attaches its files.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | channel\* | string |
 * | text | string |
 * | reference_message_id | uuid |
 * | files | array |
 * | is_notification_sent | boolean |
 * | notified_models | array |
 *
 * # Payload (files)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 *
 * # Payload (notified_models)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | notified_model_type\* | clinician or support-staff or mdi-support-staff |
 * | notified_model_id | uuid |
 */
export const createMessage3 = <ThrowOnError extends boolean = false>(
  options: Options<CreateMessage3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient}/messages",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Message
 * Get the patient's message details.
 */
export const getMessage2 = <ThrowOnError extends boolean = false>(
  options: Options<GetMessage2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages/{message}",
    ...options,
  });
};

/**
 * Read Message
 * Reads the patient's message.
 */
export const readMessage1 = <ThrowOnError extends boolean = false>(
  options: Options<ReadMessage1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient}/messages/{message}/read",
      ...options,
    }
  );
};

/**
 * Unread Message
 * Unreads the patient's message.
 */
export const unreadMessage = <ThrowOnError extends boolean = false>(
  options: Options<UnreadMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages/{message}/unread",
    ...options,
  });
};

/**
 * Dismiss Messages
 * Dismisses the patient's messages.
 */
export const dismissMessages = <ThrowOnError extends boolean = false>(
  options: Options<DismissMessagesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages/dismiss",
    ...options,
  });
};

/**
 * Forward Message
 * Forward the patient's message to the channel.
 */
export const forwardMessage = <ThrowOnError extends boolean = false>(
  options: Options<ForwardMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient}/messages/{message}/forward",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Undismiss Message
 * Undismisses the patient's message.
 */
export const undismissMessage = <ThrowOnError extends boolean = false>(
  options: Options<UndismissMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient}/messages/{message}/undismiss",
    ...options,
  });
};

/**
 * Get patients metrics
 * This route returns Patient metrics by Partner.
 *
 *
 * ## Payload
 * | field | type | description |
 * |-------|:----:|------------:|
 * |partner_id|uuid*|Should be a valid partner ID.|
 */
export const getPatientsMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetPatientsMetricsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/metrics",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get pharmacies from patient
 * Retrieves a detailed list of preferred pharmacies in the patient’s record. This API endpoint forwards the request to DoseSpot API in order to retrieve this information.
 */
export const getPharmaciesFromPatient1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmaciesFromPatient1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patientId}/pharmacies",
    ...options,
  });
};

/**
 * Post Preferred Pharmacy Request
 * Post Preferred Pharmacy Request
 */
export const postPreferredPharmacyRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostPreferredPharmacyRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient}/preferred-pharmacy-request",
      ...options,
    }
  );
};

/**
 * Post Drivers License Request
 * Post Drivers License Request
 */
export const postDriversLicenseRequest = <ThrowOnError extends boolean = false>(
  options: Options<PostDriversLicenseRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient_id}/drivers-license-request",
      ...options,
    }
  );
};

/**
 * Get PatientApp URL
 * Get Patient App auth link.
 */
export const getPatientappUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientappUrlData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/auth",
    ...options,
  });
};

/**
 * Request Patient Data
 * Sends the patient data requested to the patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | patient_id | uuid | Required if not use the patient email to request their data. |
 * | patient_email | string | Required if the patient_id is empty. |
 */
export const requestPatientData2 = <ThrowOnError extends boolean = false>(
  options?: Options<RequestPatientData2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/data",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Intro Video Request
 * Post Intro Video Request
 */
export const postIntroVideoRequest = <ThrowOnError extends boolean = false>(
  options: Options<PostIntroVideoRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient_id}/intro-video-request",
      ...options,
    }
  );
};

/**
 * Exams Request
 * Exams Request
 */
export const examsRequest = <ThrowOnError extends boolean = false>(
  options: Options<ExamsRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient_id}/exams-request",
      ...options,
    }
  );
};

/**
 * Get Recent Vouched
 * Get the last Vouched integration related to the given patient.
 */
export const getRecentVouched = <ThrowOnError extends boolean = false>(
  options: Options<GetRecentVouchedData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/vouched",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Create Vouched
 * Create a new Vouched integration entry for the patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | payload | string | The Vouched integration json |
 */
export const createVouched = <ThrowOnError extends boolean = false>(
  options: Options<CreateVouchedData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient_id}/vouched",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get patient exam
 * This endpoint returns the patient's exam detail.
 */
export const getPatientExam1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientExam1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/exams/{exam_id}",
    ...options,
  });
};

/**
 * Get patient exams
 * This endpoint returns all exams related to the patient passed on the request.
 */
export const getPatientExams2 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientExams2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/exams",
    ...options,
  });
};

/**
 * Detach patient tag
 * Detach the tag from the patient.
 */
export const detachPatientTag = <ThrowOnError extends boolean = false>(
  options: Options<DetachPatientTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/tags/{tag_id}",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Patch patient tag
 * Update the tag from the patient.
 */
export const patchPatientTag = <ThrowOnError extends boolean = false>(
  options: Options<PatchPatientTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/tags/{tag_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach patient tag
 * Attach the tag to the patient.
 */
export const attachPatientTag = <ThrowOnError extends boolean = false>(
  options: Options<AttachPatientTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/tags/{tag_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Disable patient
 * Disable patient
 */
export const disablePatient = <ThrowOnError extends boolean = false>(
  options: Options<DisablePatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}",
    ...options,
  });
};

/**
 * Get Patient
 * Get patient details.
 */
export const getPatient1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatient1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}",
    ...options,
  });
};

/**
 * Update patient
 * Update a patient record both on MD Integrations and DoseSpot.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | Prefix | string(10) | Prefix |
 * | first_name | string(35) | First name |
 * | last_name | string(35) | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80) | E-mail |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | date_of_birth | date | Date of birth, as YYYY-MM-DD |
 * | gender | integer | Gender (ISO 5218 format) |
 * | phone_number | string(25) | Phone number - _US format_ |
 * | phone_type | integer | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35) | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9) | US zip code - _5 or 9 digit format  <br>OR  <br>_CA zip code - 6 alphanumeric characters |
 * | address.city_name | string(35) | City name. If you use this parameter you don't need use **city_id** parameter. |
 * | address.state_name | string | State name or State USPS abbreviation. If you use this parameter you don't need to use **city_id** parameter. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | medical_conditions | text | Medical conditions related to the patient |
 */
export const updatePatient2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePatient2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Patients
 * This route returns a paginated list of Patients.
 *
 * ## Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_id | uuid\* | Should be a valid partner ID. |
 * | state_id | uuid | Should be a valid state ID. |
 * | gender | integer | Identifies the patient gender: 0 = "not known", 1 = "male", 2 = "female", 0 = "not applicable". |
 * | dob_period | array | An array containing two dates, if passed, the patients returned from the route will have their birthday between these two dates. |
 * | sort_direction | string | The direction of ordering records.  <br>They can be: _asc_ or _desc_ |
 * | sort_by | string | The fields that can be sorted.  <br>They can be: _first_name_, _last_name_ or _created_at_ |
 * | is_live | boolean | Defines if the live patients should be returned (defaults to true) |
 * | is_sandbox | boolean | Defines if the sandbox patients should be returned (defaults to false |
 */
export const getPatients = <ThrowOnError extends boolean = false>(
  options?: Options<GetPatientsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get patient events
 * This endpoint returns all events related to the patient passed on the request.
 */
export const getPatientEvents1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientEvents1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/events",
    ...options,
  });
};

/**
 * Get patient cases
 * This endpoint returns all cases related to the patient passed on the request.
 */
export const getPatientCases2 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientCases2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/cases",
    ...options,
  });
};

/**
 * Get patient files
 * This endpoint returns all cases files related to the patient passed on the request.
 */
export const getPatientFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientFilesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/files",
    ...options,
  });
};

/**
 * Get patient clinical notes
 * This endpoint returns all cases notes related to the patient passed on the request.
 */
export const getPatientClinicalNotes = <ThrowOnError extends boolean = false>(
  options: Options<GetPatientClinicalNotesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/notes",
    ...options,
  });
};

/**
 * Search patients
 * This route returns a list of Patients based on the `"search"` string parameter passed, as long as the Clinician and the patient are linked to the Partner being passed through the `"partner_id"` parameter.
 *
 * ## Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_id | uuid | Should be a valid partner ID. |
 * | search | string* | Should be either the patient's full name, phone number, last name or e-mail. |
 */
export const searchPatients1 = <ThrowOnError extends boolean = false>(
  options?: Options<SearchPatients1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create patient
 * Creates a new patient record both on MD Integrations and DoseSpot.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10)\* | Prefix |
 * | first_name | string(35)\* | First name |
 * | last_name | string(35)\* | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80)\* | E-mail |
 * | date_of_birth | date\* | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | gender | integer\* | Gender (ISO 5218 format) |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | phone_number | string(25)\* | Phone number - _US format_ |
 * | phone_type | integer\* | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35)\* | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9)\* | Zip code - _5 or 9 digit format_ |
 * | address.city_id | uuid | City ID. Required if you do not use the **city_name** and **state_name** parameters. Check **Metadata > States > Cities> Get cities from a given state** to get city ID. |
 * | address.city_name | string(35) | City name. Required if you do not use the **city_id** parameter. Required if you use **state_name** parameter. |
 * | address.state_name | string | State name or State USPS abbreviation. Required if you do not use the **city_id** parameter. Required if you use **city_name** parameter. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | medical_conditions | text | Medical conditions related to the patient |
 * | partner_id\* | uuid | Partner ID. |
 * | is_live\* | boolean | Define the patient's environment (live or sandbox) |
 */
export const createPatient2 = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePatient2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Patient Primary Clinician
 * Set the patient's primary Clinician.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | clinician_id | uuid\* | Should be a valid Clinician ID. |
 */
export const postPatientPrimaryClinician = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostPatientPrimaryClinicianData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient_id}/clinician",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Post scan patient file
 * This endpoint will start the scan file.
 * Eg. driver-license scan.
 */
export const postScanPatientFile = <ThrowOnError extends boolean = false>(
  options: Options<PostScanPatientFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/patients/{patient_id}/scan",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Patch Verified Manually
 * Patch the file.
 */
export const patchVerifiedManually = <ThrowOnError extends boolean = false>(
  options: Options<PatchVerifiedManuallyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/patients/{patient_id}/drivers-license/{file_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get dispense units
 * Get DoseSpot dispense units. You can search for dispenses units using the `name` query parameter.
 *
 * This API endpoint forwards the request to DoseSpot in order to retrieve dispense units.
 */
export const getDispenseUnits1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetDispenseUnits1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/dispense-units",
      ...options,
    }
  );
};

/**
 * Get pharmacies
 * Search DoseSpot pharmacies according to a given query parameter. At least **one** query parameter is required. If no query parameter is provided, an error will be thrown.
 *
 * This API endpoint forwards the request to DoseSpot in order to search for pharmacies.
 */
export const getPharmacies3 = <ThrowOnError extends boolean = false>(
  options?: Options<GetPharmacies3Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/pharmacies",
      ...options,
    }
  );
};

/**
 * Get pharmacy
 * Get DoseSpot pharmacy details from a given pharmacy ID.
 *
 * This API endpoint forwards the request to DoseSpot in order to retrieve the pharmacy details.
 */
export const getPharmacy3 = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmacy3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/pharmacies/{pharmacy_id}",
    ...options,
  });
};

/**
 * Revoke the access token used in the request
 * Revoke the access token used in the request for the clinician.
 *
 * In case the clinician has any other valid access tokens (e.g.: the clinician is logged in more than one browser), they will still be valid.
 */
export const revokeTheAccessTokenUsedInTheRequest = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RevokeTheAccessTokenUsedInTheRequestData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/auth/logout",
    ...options,
  });
};

/**
 * Revoke all access tokens belonging to the logged user
 * Revoke **all the access tokens** belonging to the logged clinician.
 *
 * In case the clinician has any other valid access tokens (e.g.: the clinician is logged in more than one browser), they will all be revoked.
 */
export const revokeAllAccessTokensBelongingToTheLoggedUser = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RevokeAllAccessTokensBelongingToTheLoggedUserData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/auth/logout/all",
    ...options,
  });
};

/**
 * Search for compounds from a given partner
 * Search compounds belonging to a given partner.
 *
 * In case a search term is not provided, all the available compounds are returned.
 */
export const searchForCompoundsFromAGivenPartner = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SearchForCompoundsFromAGivenPartnerData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/compounds/search",
    ...options,
  });
};

/**
 * Create compound for a given partner
 * Create compounds for a given partner.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | title | string(105) | Title of compound |
 * | name | string(105)\* | Name of compound |
 * | dispense_unit_id | integer\* | Compounds can be associated with any available dispense unit ID. For a list of all available dispense units check _Partners > Dispense Units_. |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to. Check _Partners > Pharmacies > Get pharmacies_ to get a list of all pharmacies available.  <br>  <br>_Important note_:  <br>  <br>Dosespot works with different IDs for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in staging environment: 13012  <br>\- Curexa pharmacy ID in production environment: 29992 |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | quantity | string\* | Medication quantity string representing a float number |
 * | directions | string(140)\* | Instructions about how the medication is administered |
 * | days_supply | integer | Between 0 and 365 - Number of days of supply of the medication provided - Allows null value |
 * | refills | integer\* | Between 0 and 99 - Total of refills for the given medication |
 * | allow_substitutions | boolean | Allows a substitute medication/compound |
 * | clinical_note | string | Additional clinical information |
 * | thank_you_note | string | Additional information |
 * | metadata | string(800) | Additional information |
 * | order | integer | The compound ordering |
 * | effective_date | integer | Number of days. It will set the prescription effective date. `E.g.: Prescription date + 30 days` |
 */
export const createCompoundForAGivenPartner = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateCompoundForAGivenPartnerData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/partners/{partner_id}/compounds",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Partner Medications
 * Returns all Medications linked to Partner.
 */
export const partnerMedications = <ThrowOnError extends boolean = false>(
  options: Options<PartnerMedicationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/medications",
    ...options,
  });
};

/**
 * Partner Supplies
 * Returns all Supplies linked to Partner.
 */
export const partnerSupplies = <ThrowOnError extends boolean = false>(
  options: Options<PartnerSuppliesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/supplies",
    ...options,
  });
};

/**
 * Get completed cases
 * Get all partner cases, filter by cases that have services or not using **only_with_services** parameter equal to **true**.
 */
export const getCompletedCases = <ThrowOnError extends boolean = false>(
  options: Options<GetCompletedCasesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/completed-cases",
    ...options,
  });
};

/**
 * Get partner tags
 * Get all partners's tags given a partner ID.
 *
 * It also returns Global and System tags.
 */
export const getPartnerTags = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerTagsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/tags",
    ...options,
  });
};

/**
 * Get Partner Notifications
 * List all partner notifications related to the partner UUID.
 */
export const getPartnerNotifications1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerNotifications1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/notifications",
    ...options,
  });
};

/**
 * Get Partner Notification
 * View a single partner notification, belongs to a partner
 */
export const getPartnerNotification1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerNotification1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/notifications/{partner_notification_id}",
    ...options,
  });
};

/**
 * List questionnaires
 * Return all enabled partner questionnaires based on the logged in partner.
 */
export const listQuestionnaires2 = <ThrowOnError extends boolean = false>(
  options: Options<ListQuestionnaires2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/questionnaires",
    ...options,
  });
};

/**
 * Get voucher
 * Return voucher data given a voucher ID.
 */
export const getVoucher2 = <ThrowOnError extends boolean = false>(
  options: Options<GetVoucher2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/partners/{partner_id}/vouchers/{voucher_id}",
    ...options,
  });
};

/**
 * Create voucher
 * Create a new voucher for the questionnaire's flow.
 *
 * ## Payload
 *
 * **Important**: When creating a voucher you can specify the medications, compounds and services to be used.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | **questionnaire_id** | uuid | Partner Questionnaire ID. It can be found under your company's intake forms from the Partners Website or using **Patient App > Questionnaires > List questionnaires** |
 * | patient_id | uuid | Patient ID. |
 * | **hold_status** | boolean | Flag to hold the status to not enter into the MDI flow. It will be **false** by default. |
 * | demo | boolean | Demo vouchers will not create any patient or cases and will not expire. Default `false` |
 * | **case_services** | array | It can be empty. |
 * | **case_services.\*.**partner_service_id | uuid\* | Partner Service ID. It can be found under your company's offerings from the Partners Website. Required if is present. |
 * | **case_prescriptions** | array | It can be empty. |
 * | **case_prescriptions.\*.**partner_compound_id | uuid\* | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. Required if is present. |
 * | **case_prescriptions.\*.**partner_medication_id | uuid\* | Partner medication ID. It can be found under your company's offerings from the Partners Website. Required if is present. |
 * | **diseases** | array | it can be empty or null. |
 * | **diseases.\*.**disease_id | UUID | Disease ID. It can be found through the diseases endpoint. Nullable. |
 * | metadata | string (255) | Metadata value. It can be empty. |
 */
export const createVoucher1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateVoucher1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/partners/{partner_id}/vouchers",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Wildcards
 * Get the partner's wildcards.
 */
export const getWildcards = <ThrowOnError extends boolean = false>(
  options: Options<GetWildcardsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/wildcards",
    ...options,
  });
};

/**
 * Create Wildcard
 * Creates a wildcard for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | key\* | string |
 * | color\* | string |
 * | description | string |
 * | removable_role | string (admin) |
 * | auto_detach_status | array (created, assigned, waiting, support, processing, cancelled, completed) |
 */
export const createWildcard = <ThrowOnError extends boolean = false>(
  options: Options<CreateWildcardData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/wildcards",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get cities from a given state
 * Return a list of all cities from a given state in the USA.
 */
export const getCitiesFromAGivenState1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCitiesFromAGivenState1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/metadata/states/{state_id}/cities",
    ...options,
  });
};

/**
 * Get all states
 * Return a list of all cities from a given state in the USA.
 */
export const getAllStates1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllStates1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/metadata/states",
      ...options,
    }
  );
};

/**
 * Get all Disease Codes
 * Return a list of all diseases codes.
 */
export const getAllDiseaseCodes1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllDiseaseCodes1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/metadata/diseases",
      ...options,
    }
  );
};

/**
 * Get diseases by ID
 * Return the disease data by its ID.
 */
export const getDiseasesById1 = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseasesById1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/metadata/diseases/{disease_id}",
    ...options,
  });
};

/**
 * Get Environments
 * Return a list of all environments (paginated).
 */
export const getEnvironments = <ThrowOnError extends boolean = false>(
  options?: Options<GetEnvironmentsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/metadata/environments",
      ...options,
    }
  );
};

/**
 * Get all license types
 * Get all license types
 */
export const getAllLicenseTypes1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllLicenseTypes1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/metadata/license-types",
      ...options,
    }
  );
};

/**
 * Get case files
 * Returns a list of all attached files to the case.
 */
export const getCaseFiles1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseFiles1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/files",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Update case files
 * Update cases files.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | case_files | array(uuid)* | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 */
export const updateCaseFiles1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCaseFiles1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach a file from a case
 * Attach a file to a case.
 */
export const detachAFileFromACase1 = <ThrowOnError extends boolean = false>(
  options: Options<DetachAFileFromACase1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/files/{file_id}",
    ...options,
  });
};

/**
 * Attach a file to a case
 * Attach a file to a case.
 */
export const attachAFileToACase1 = <ThrowOnError extends boolean = false>(
  options: Options<AttachAFileToACase1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/files/{file_id}",
      ...options,
    }
  );
};

/**
 * Get case prescriptions
 * Return all prescriptions for a given case ID.
 */
export const getCasePrescriptions1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCasePrescriptions1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/prescriptions",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Update case prescriptions
 * Update cases prescriptions.
 *
 * # Payload
 *
 * Receives an array of **Prescriptions**.
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`, `dosespot_supply_ndc`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `dosespot_supply_ndc` are `null` |
 * | dosespot_supply_ndc | string | Dosespot Supply NDC code. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The prescription ordering |
 */
export const updateCasePrescriptions1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCasePrescriptions1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/prescriptions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create case prescription
 * Create a case prescription.
 *
 * # Payload
 *
 * Receives an object of **Prescription**.
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`, `dosespot_supply_ndc`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `dosespot_supply_ndc` are `null` |
 * | dosespot_supply_ndc | string | Dosespot Supply NDC code. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The prescription ordering |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/f2e85db2-8cd9-4f25-ae04-8e72d17fdb0a/aW1hZ2UucG5n" width="1637" height="421">
 */
export const createCasePrescription1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateCasePrescription1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/prescriptions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete case prescription
 * Delete a specific case prescription.
 */
export const deleteCasePrescription1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCasePrescription1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/prescriptions/{prescription_id}",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Update case prescription
 * Update a specific case prescription.
 *
 * # Payload
 *
 * Receives an array of **Prescriptions**.
 *
 * ## Prescription Properties
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 */
export const updateCasePrescription1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCasePrescription1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/prescriptions/{prescription_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Cancel case prescription
 * Cancels a specific case prescription.
 */
export const cancelCasePrescription = <ThrowOnError extends boolean = false>(
  options: Options<CancelCasePrescriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    ...urlSearchParamsBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/prescriptions/{prescription_id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options?.headers,
    },
  });
};

/**
 * Update case prescriptions statuses
 * Update cases prescriptions statuses. In case the encounter has all prescriptions as "pharmacy_verified" it will also set the case as completed.
 * In case it finds an error in any of the prescription statuses, it will set the case to support.
 */
export const updateCasePrescriptionsStatuses1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCasePrescriptionsStatuses1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/prescriptions/status",
    ...options,
  });
};

/**
 * Resubmit case prescription
 * Resubmit the case prescription.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | pharmacy_id | integer | Dosespot Pharmacy ID |
 */
export const resubmitCasePrescription = <ThrowOnError extends boolean = false>(
  options: Options<ResubmitCasePrescriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/prescriptions/{prescription_id}/resubmit",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Cancel case prescriptions
 * Cancel cases prescriptions and move the case to assigned.
 */
export const cancelCasePrescriptions = <ThrowOnError extends boolean = false>(
  options: Options<CancelCasePrescriptionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/prescriptions/cancel",
      ...options,
    }
  );
};

/**
 * Reset case prescriptions
 * Update cases prescriptions statuses. In case the encounter has all prescriptions as "pharmacy_verified" it will also set the case as completed.
 * In case it finds an error in any of the prescription statuses, it will set the case to support.
 */
export const resetCasePrescriptions = <ThrowOnError extends boolean = false>(
  options: Options<ResetCasePrescriptionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/prescriptions/reset",
      ...options,
    }
  );
};

/**
 * Get case questions
 * Return all questions for a given case ID.
 */
export const getCaseQuestions1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseQuestions1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/questions",
    ...options,
  });
};

/**
 * Update question
 * Update a question.
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via email: [mj.serota@gmail.com](mailto:mj.serota@gmail.com) and [lepurdy2@gmail.com](mailto:lepurdy2@gmail.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | text\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as important |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 * | description | text | A description for your question |
 * | label | string(50) | The question label |
 * | metadata | text | A metadata field |
 * | displayed_options | array | An array of options that were displayed to the patient |
 */
export const updateQuestion = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/questions/{case_question_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get notes
 * Return all the clinical notes for a given case.
 *
 * In order to have access to a given patient, the clinician must belong to the partner which the given patient belongs to.
 */
export const getNotes1 = <ThrowOnError extends boolean = false>(
  options: Options<GetNotes1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/notes",
    ...options,
  });
};

/**
 * Create note
 * Create a new clinical note for a given case.
 *
 * In order to have access to a given patient, the clinician must belong to the partner which the given patient belongs to.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | text | text* | Clinical note content. |
 */
export const createNote = <ThrowOnError extends boolean = false>(
  options: Options<CreateNoteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/notes",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Transfer case to Support
 * Transfer case to support.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | reason | string* | Support reason description |
 */
export const transferCaseToSupport = <ThrowOnError extends boolean = false>(
  options: Options<TransferCaseToSupportData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/support",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Set case as Waiting
 * Set a given case as waiting.
 *
 * Waiting cases indicate that the clinician is waiting for a patient action (reply to a message, attach a blood exam, etc)
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | reason | string* | Reason description |
 */
export const setCaseAsWaiting = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseAsWaitingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/waiting",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Set case as Completed
 * Set a given case as completed.
 *
 * **Note:** When this endpoint is called all case prescriptions will be deleted.
 *
 * A case goes to completed through successfully sending in a prescription or when moved manually from assigned clinician.
 *
 * In case something goes wrong with the **DoseSpot** integration then the case will be automatically added to the **support** queue.
 */
export const setCaseAsCompleted = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseAsCompletedData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/completed",
      ...options,
    }
  );
};

/**
 * Set case as Processing
 * Set a given case as processing.
 *
 * Prescriptions will be sent to Dosespot and while there is no confirmation from **DoseSpot**, the case remains in Processing status.
 *
 * In case something goes wrong with the **DoseSpot** integration then the case will be automatically added to the **support** queue.
 */
export const setCaseAsProcessing = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseAsProcessingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/processing",
      ...options,
    }
  );
};

/**
 * Set case as Approved
 * Set a given case as Approved status.
 *
 * It will create all prescriptions on Dosespot but not send them to the pharmacy yet.
 *
 * | **field** | **type** | **description** |
 * | --- | --- | --- |
 * | thank_you_message | string | A thank you message to be sent when the case goes to processing status |
 * | extra_message | string | An extra message to be sent when the case goes to processing status |
 * | clinical_note | string | A clinical note to be added to the case |
 * | files | array | Files to be attached and sent as a message to the patient when the case goes to processing status |
 * | files.\* | uuid\* | Valid and existent UUID from files table |
 */
export const setCaseAsApproved = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseAsApprovedData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/approved",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Set case as Assigned
 * Set a given case as assigned.
 */
export const setCaseAsAssigned1 = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseAsAssigned1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/assigned",
      ...options,
    }
  );
};

/**
 * Set case as Cancelled
 * Set a given case as cancelled.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | reason | string* | A reason description |
 */
export const setCaseAsCancelled = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseAsCancelledData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/cancelled",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get case diseases
 * List all diseases for a given case ID.
 */
export const getCaseDiseases1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseDiseases1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/diseases",
    ...options,
  });
};

/**
 * Attach new diseases
 * Update cases diseases.
 *
 * # Payload
 *
 * Note: Use the "Get all Disease Codes" endpoint under the metadata folder to find a list of all availables UUID to be used. Once you know a disease id, you can also retrieve its information through the API using the Get Disease route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | disease_id | UUID (**required)** |
 */
export const attachNewDiseases1 = <ThrowOnError extends boolean = false>(
  options: Options<AttachNewDiseases1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/diseases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete diseases
 * Delete disease from a case.
 */
export const deleteDiseases1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDiseases1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/diseases/{disease_id}",
    ...options,
  });
};

/**
 * Set primary disease
 * Set a case disease as primary to be sent to Dosespot.
 */
export const setPrimaryDisease = <ThrowOnError extends boolean = false>(
  options: Options<SetPrimaryDiseaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/diseases/{disease_id}/primary",
      ...options,
    }
  );
};

/**
 * Remove services
 * Delete case services from a case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | case_services | array* | An array of uuid |
 */
export const removeServices = <ThrowOnError extends boolean = false>(
  options: Options<RemoveServicesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/services/{service_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update case services
 * Update case services
 */
export const updateCaseServices = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCaseServicesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/services/{service_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get case services
 * Get all case services.
 */
export const getCaseServices1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseServices1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/services",
    ...options,
  });
};

/**
 * Add new services
 * Update cases prescriptions.
 *
 * # Payload
 *
 * Receives an array of **Services**.
 *
 * **\## Service Properties**
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | order | integer |
 */
export const addNewServices = <ThrowOnError extends boolean = false>(
  options: Options<AddNewServicesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/services",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get case events
 * Returns a list of events related to the case.
 */
export const getCaseEvents1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseEvents1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/events",
    ...options,
    headers: {
      "Content-Type": "text/plain",
      ...options?.headers,
    },
  });
};

/**
 * Add case events
 * Insert a new audit event to the related case.
 */
export const addCaseEvents = <ThrowOnError extends boolean = false>(
  options: Options<AddCaseEventsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/events",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Add clinician events
 * Returns a list of events related to the case.
 */
export const addClinicianEvents = <ThrowOnError extends boolean = false>(
  options: Options<AddClinicianEventsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/clinicians/{clinician_id}/events",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Attach case
 * Attach a case to the logged in clinician or a clinician passed as a parameter.
 *
 * | **Param** | **type** | **Description** |
 * | --- | --- | --- |
 * | reason | string(255) | A reason for the case pinned. |
 * | clinician_id | uuid | Clinician ID to attach the case to. If not passed then the logged in clinician will be attached. |
 */
export const attachCase = <ThrowOnError extends boolean = false>(
  options: Options<AttachCaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/pin",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get pinned cases to me
 * Get all cases pinned to the logged in clinican
 *
 * ## Filters
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partners | array(uuid) | If passed, only cases will belong to this partner. |
 * | clinicians | array(uuid) | If passed, only cases assigned to this clinician will be displayed. |
 * | states | array(uuid) | If passed, only cases with patients from these states will be returned. |
 * | diseases | array(uuid) | If passed, only cases with these diseases will be returned. |
 * | case_type | string ('new' or "follow-up') | If passed, only cases from the type will be returned |
 * | is_sync | boolean | If passed, only cases that are Routine or Extended Care will be returned. |
 * | sort | string | Sorts by created_at from the Case Status, desc or asc. |
 * | tags | array(uuid) | Filter by an array of Tag UUID. |
 */
export const getPinnedCasesToMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetPinnedCasesToMeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/pinned/to-me",
      ...options,
    }
  );
};

/**
 * Get pinned cases by me
 * Get all cases pinned by the the logged in clinican
 *
 * ## Filters
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partners | array(uuid) | If passed, only cases will belong to this partner. |
 * | clinicians | array(uuid) | If passed, only cases assigned to this clinician will be displayed. |
 * | states | array(uuid) | If passed, only cases with patients from these states will be returned. |
 * | diseases | array(uuid) | If passed, only cases with these diseases will be returned. |
 * | case_type | string ('new' or "follow-up') | If passed, only cases from the type will be returned |
 * | is_sync | boolean | If passed, only cases that are Routine or Extended Care will be returned. |
 * | sort | string | Sorts by created_at from the Case Status, desc or asc. |
 * | tags | array(uuid) | Filter by an array of Tag UUID. |
 */
export const getPinnedCasesByMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetPinnedCasesByMeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/pinned/by-me",
      ...options,
    }
  );
};

/**
 * Unpin case pinned to me
 * Detach a case pinned to the logged in clinician.
 */
export const unpinCasePinnedToMe = <ThrowOnError extends boolean = false>(
  options: Options<UnpinCasePinnedToMeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/unpin/to-me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Unpin case pinned by me
 * Detach a case pinned by the logged in clinician.
 */
export const unpinCasePinnedByMe = <ThrowOnError extends boolean = false>(
  options: Options<UnpinCasePinnedByMeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/unpin/by-me",
    ...options,
  });
};

/**
 * Detach tag
 * Detach a tag from case.
 */
export const detachTag1 = <ThrowOnError extends boolean = false>(
  options: Options<DetachTag1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/tags/{tag_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update tag note
 * Allow to update the tag note related to case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | notes | string\* | Allow to add a note when attaching tags |
 */
export const updateTagNote1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTagNote1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/tags/{tag_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach tag
 * Attach a tag to case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | notes | string | Allow to add a note when attaching tags |
 */
export const attachTag1 = <ThrowOnError extends boolean = false>(
  options: Options<AttachTag1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/tags/{tag_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * File Attach Request
 * Notify the patient that an additional file is needed to continue processing the case.
 *
 * ## Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | reason | string\* | The files that need to be sent |
 */
export const fileAttachRequest = <ThrowOnError extends boolean = false>(
  options: Options<FileAttachRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/files-request",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Swap Wildcards
 * It swaps the wildcards based on the given case.
 *
 * ## Payload
 *
 * | field | type |
 * | --- | --- |
 * | text | string\* |
 */
export const swapWildcards = <ThrowOnError extends boolean = false>(
  options: Options<SwapWildcardsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/wildcards/swap",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create case
 * Create a new case for a given patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | patient_id | uuid\* | Patient ID. Check **Partners > Cases > Patients** to create new patients |
 * | reference_case_id | uuid | The referenced case UUID |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_services | array(Service) | List of services to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | is_chargeable | boolean | Whether or not the case should be charged |
 * | tags | array(object(uuid)) | Tags ID to be attached to the case. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`, `dosespot_supply_ndc`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `dosespot_supply_ndc` are `null` |
 * | dosespot_supply_ndc | string | Dosespot Supply NDC code. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 * | order | integer | The prescriptions ordering |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/b5039151-5d8d-48e7-8fda-24feff80438b/aW1hZ2UucG5n" width="1637" height="421">
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 * | description | text | A description for your question |
 * | label | string(50) | The question label |
 * | metadata | text | A metadata field |
 * | displayed_options | array | An array of options that were displayed to the patient |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 * | order | integer |
 */
export const createCase2 = <ThrowOnError extends boolean = false>(
  options?: Options<CreateCase2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get case
 * Get the following case details:
 *
 * - Patient
 * - Partner
 * - Priority status and reason
 * - Status
 *
 * To get details from `prescriptions`, `files` and `questions` you must use specific API endpoints:
 *
 * - Files: check **"Clinicians > Cases > Files"**
 * - Prescriptions: check **"Clinicians > Cases > Prescriptions"**
 * - Questions: check **"Clinicians > Cases > Questions"**
 */
export const getCase1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCase1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}",
    ...options,
  });
};

/**
 * Get case assignment
 * Get the current assignment for a given case.
 */
export const getCaseAssignment = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseAssignmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/assignment",
    ...options,
  });
};

/**
 * Generate PDF
 * Create pdf files for each case service.
 *
 * If the case has more than one service then it returns a Zip file with all PDF files into it.
 *
 * If the case has only one service then it returns the PDF file.
 *
 * Returns the URL to download a zip file containing all files.
 *
 * ## Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_id | uuid\* |  |
 * | date_range | array | Required if cases_id param is empty. A date range to search cases. |
 * | use_creation_date | boolean | Default false. If not passed then we use the completed status date |
 * | cases_id | array | Array of case_id |
 */
export const generatePdf = <ThrowOnError extends boolean = false>(
  options?: Options<GeneratePdfData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/generate-pdf",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Generate Medical Necessity PDF
 * Generates a medical necessity PDF for a case and sends it to the patient via message.
 */
export const generateMedicalNecessityPdf = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateMedicalNecessityPdfData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/generate-medical-necessity-pdf",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Update Service PDF Exported flag
 * This route changes the service pdf exported flag for a case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | exported | boolean* | Whether or not the case service file was already exported. |
 */
export const updateServicePdfExportedFlag = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateServicePdfExportedFlagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/service-pdf-exported",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create PDF file
 * Create pdf files for each case service given a case.
 *
 * If the case has more than one service then it returns a Zip file with all PDF files into it.
 *
 * If the case has only one service then it returns the PDF file.
 *
 * Returns the URL to download a zip file containing all files.
 *
 * If the _create_as_file_ option is passed then we store the file as return it as a normally file object.
 */
export const createPdfFile = <ThrowOnError extends boolean = false>(
  options: Options<CreatePdfFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/{case_id}/pdf",
    ...options,
  });
};

/**
 * Get cases by status
 * Return a list of cases according to a given status.
 *
 * The following statuses are available:
 *
 * - **Created**: a list of cases create and not assigned yet;
 *
 * - **Assigned**: a list of cases assigned to the clinician waiting for review;
 *
 * - **Waiting**: a list of cases assigned to the clinician, waiting for the patient information or review;
 *
 * - **Cancelled**: a list of cases assigned to the clinician and canceled by the partner;
 *
 * - **Support**: a list of cases assigned to the clinician and transferred to support;
 *
 * - **Processing**: a list of cases assigned to the clinician that were already reviewed and finished by the clinician, but with one or more prescriptions waiting for DoseSpot confirmation;
 *
 * - **Completed**: a list of cases assigned to the clinician with all its prescriptions already confirmed by DoseSpot (prescriptions already verified by the pharmacies).
 *
 *
 * ## Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partners | array(uuid) | If passed, all cases will belong to this partner. |
 * | clinicians | array(uuid) | If passed, all cases assigned to this clinician will be displayed. |
 * | sort | string | Sorts by created_at from the Case Status, desc or asc. |
 * | is_assigned_to_me | boolean | Cases returned will be assigned to the clinician calling the route. |
 * | tags | array(uuid) | Filter by an array of Tag UUID. |
 * | diseases | array(uuid) | Filter by an array of Diseases UUID |
 * | states | array(uuid) | Filter by an array of State UUID |
 * | case_type | string | Case Type can by New or Follow-up |
 * | is_sync | boolean | Searchs for Routine or Extended Care encounters. If missing, returns both. |
 * | is_live | boolean | Defines if the cases from live patients should be returned (defaults to true) |
 * | is_sandbox | boolean | Defines if the cases from sandbox patients should be returned (defaults to false) |
 * | is_additional_approval_needed | boolan | Search for cases that needs an additional approvel |
 */
export const getCasesByStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetCasesByStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/status/{status}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Search cases
 * Return a list of cases matching the provided parameters.
 *
 * In the case where multiple parameters are provided, the response will contain cases that match all the provided parameters, effectively making a logical 'AND'.
 *
 * All parameters are **optional**. In the case where none is provided, the response will contain all the assigned cases to the clinician.
 *
 * ## Payload
 * | field | type | description |
 * |-------|:----:|------------:|
 * |patient_name|string|Search cases by the related patient full name.|
 * |partners|array of uuid|Search cases by the related Partners. Each item should be a valid partner ID.|
 * |license_states|array of uuid|Search cases for  the given license states. Each item should be a valid state ID.|
 * |sort_by_queue_time|'desc' \| 'asc'| Sets the returned cases to be sorted by their queue time in ascending or descending order.|
 */
export const searchCases = <ThrowOnError extends boolean = false>(
  options?: Options<SearchCasesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/cases/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Reassign clinician randomly to case
 * Reassign clinician randomly to a given case.
 */
export const reassignClinicianRandomlyToCase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReassignClinicianRandomlyToCaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/reassign-randomly",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Update Case synchronicity status
 * This route changes synchronicity status for a case as long as it is not complete or cancelled.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | is_sync | boolean* | Whether or not the MD is dealing with the case synchronously or asynchronously |
 */
export const updateCaseSynchronicityStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCaseSynchronicityStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/sync",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Update Case Chargeability Status
 * This route changes chargeability status for a case as long as it is not complete or cancelled.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | is_chargeable | boolean* | Whether or not the case can be charged for. |
 */
export const updateCaseChargeabilityStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCaseChargeabilityStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/chargeable",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Reassign clinician to case
 * Reassign a given clinician to a given case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | clinician_id | uuid\* | Clinician UUID |
 * | reason | string | A reason for the assignment. |
 */
export const reassignClinicianToCase = <ThrowOnError extends boolean = false>(
  options: Options<ReassignClinicianToCaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/reassign",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Resubmit case prescriptions
 * Resubmit the case prescriptions.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | pharmacy_id | integer | Dosespot Pharmacy ID |
 */
export const resubmitCasePrescriptions = <ThrowOnError extends boolean = false>(
  options: Options<ResubmitCasePrescriptionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/resubmit",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Set case priority
 * Set a case as priority.
 *
 * # Payload
 *
 * | field | type |
 * | --- | --- |
 * | is_priority | boolean\* |
 * | reason | string\* |
 */
export const setCasePriority = <ThrowOnError extends boolean = false>(
  options: Options<SetCasePriorityData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/priority",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Patch Additional Approval flag
 * It updates the Is Additional Approval Needed flag.
 *
 * # Payload
 *
 * | field | type |
 * | --- | --- |
 * | is_priority | boolean\* |
 * | reason | string\* |
 */
export const patchAdditionalApprovalFlag = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdditionalApprovalFlagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/additional-approval",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Send Partner Escalation Email
 * This route changes the service pdf exported flag for a case.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | note | String\* | Text with some notes. This description will be in the content of the email. |
 */
export const sendPartnerEscalationEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendPartnerEscalationEmailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/cases/{case_id}/partner-escalation-email-send",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create file
 * Upload a single file to MD Integrations using **multipart/form-data**.
 *
 * | **Type** | **Maximum Size** |
 * | --- | --- |
 * | Images files | 25mb |
 * | Video files | 140mb |
 * | Other types | 16mb |
 *
 * Accepted types:
 *
 * - document
 *
 * - review
 *
 * - other
 *
 * - insurance-policy
 *
 * - contract
 *
 * - driver-license
 *
 * - lab-result
 *
 * - photo
 *
 * - av-video
 *
 * - full-body-photo
 *
 * - back-photo
 *
 * - face-photo
 *
 * - avatar-photo
 *
 * - ipledge-document
 *
 * - auth-form
 */
export const createFile3 = <ThrowOnError extends boolean = false>(
  options?: Options<CreateFile3Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Delete file
 * Delete a given file ID.
 */
export const deleteFile3 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFile3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/files/{file_id}",
    ...options,
  });
};

/**
 * Get file
 * Get information from a given file ID.
 *
 */
export const getFile3 = <ThrowOnError extends boolean = false>(
  options: Options<GetFile3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/files/{file_id}",
    ...options,
  });
};

/**
 * Patch File
 * Patch the file.
 */
export const patchFile = <ThrowOnError extends boolean = false>(
  options: Options<PatchFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/files/{file_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach file snippet
 * Attach a file to the logged in clinician and link it to a partner.
 *
 * | **Param** | **type** | **Description** |
 * | --- | --- | --- |
 * | file_id | uuid\* | File ID |
 * | partner_id | uuid\* | Partner ID |
 */
export const attachFileSnippet = <ThrowOnError extends boolean = false>(
  options?: Options<AttachFileSnippetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/snippets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get file snippets
 * Get all file snippets related to the logged in clinican and to the given partner.
 */
export const getFileSnippets = <ThrowOnError extends boolean = false>(
  options: Options<GetFileSnippetsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/snippets/{partner_id}",
    ...options,
  });
};

/**
 * Detach file snippet
 * Detach a given file ID.
 */
export const detachFileSnippet = <ThrowOnError extends boolean = false>(
  options: Options<DetachFileSnippetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/snippets/{file_id}",
    ...options,
  });
};

/**
 * Search Supplies
 * Search DoseSpot supplies based on `name` and/or `NDC`.
 *
 * This API endpoint forwards the request to DoseSpot API in order to retrieve the supplies.
 */
export const searchSupplies1 = <ThrowOnError extends boolean = false>(
  options?: Options<SearchSupplies1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/supplies/search",
      ...options,
    }
  );
};

/**
 * Get Predefined Messages
 * Return all the predefined messages for the authenticated clinician.
 */
export const getPredefinedMessages = <ThrowOnError extends boolean = false>(
  options?: Options<GetPredefinedMessagesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/predefined_messages",
      ...options,
    }
  );
};

/**
 * Create Predefined Message
 * Create a new predefined message for the authenticated clinician.
 */
export const createPredefinedMessage = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePredefinedMessageData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/predefined_messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete Predefined Message
 * Delete a predefined message by ID.
 */
export const deletePredefinedMessage = <ThrowOnError extends boolean = false>(
  options: Options<DeletePredefinedMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/predefined_messages/{id}",
    ...options,
  });
};

/**
 * Update Predefined Message
 * Update a predefined message by ID.
 */
export const updatePredefinedMessage = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePredefinedMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/predefined_messages/{predefined_message_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update Predefined Messages Order
 * Update the messages order based on the array order sent.
 */
export const updatePredefinedMessagesOrder = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<UpdatePredefinedMessagesOrderData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/predefined_messages/order",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Prior Auth Appeal
 * This endpoint appeals an existing Prior Authorization on a Dosespot Prescription.
 */
export const priorAuthAppeal = <ThrowOnError extends boolean = false>(
  options: Options<PriorAuthAppealData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/prescriptions/{prescription_id}/dosespot/prior-auth/appeal",
      ...options,
    }
  );
};

/**
 * Prior Auth Cancel
 * This endpoint cancels an existing Prior Authorization on a Dosespot Prescription.
 */
export const priorAuthCancel = <ThrowOnError extends boolean = false>(
  options: Options<PriorAuthCancelData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/prescriptions/{prescription_id}/dosespot/prior-auth/cancel",
      ...options,
    }
  );
};

/**
 * Get Prior Auth Question
 * It returns a Dosespot question related to the Prescription Prior Authorization.
 */
export const getPriorAuthQuestion = <ThrowOnError extends boolean = false>(
  options: Options<GetPriorAuthQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/prescriptions/{prescription_id}/dosespot/prior-auth/questions/{question_id}",
    ...options,
  });
};

/**
 * Answer Prior Auth Question
 * It will answer a Dosespot Prior Authorization Question based on the Get Question endpoint where the params will be exactly the Dosespot returned on Get Question.
 *
 * It will have question types, question options and etc.
 */
export const answerPriorAuthQuestion = <ThrowOnError extends boolean = false>(
  options: Options<AnswerPriorAuthQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/prescriptions/{prescription_id}/dosespot/prior-auth/questions/{question_id}/answer",
      ...options,
    }
  );
};

/**
 * Add Attachment to a Prior Auth
 * It attaches a file to a Dosespot Prior Authorization when needed.
 */
export const addAttachmentToAPriorAuth = <ThrowOnError extends boolean = false>(
  options: Options<AddAttachmentToAPriorAuthData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      ...formDataBodySerializer,
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/prescriptions/{prescription_id}/dosespot/prior-auth/attachments",
      ...options,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
    }
  );
};

/**
 * Request Reset Password
 * Request to reset the password corresponding to the given e-mail.
 *
 * If the e-mail corresponds to a valid clinician, then an e-mail will be sent with the link to set a new password.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | email | text* | Clinician's e-mail. |
 */
export const requestResetPassword = <ThrowOnError extends boolean = false>(
  options?: Options<RequestResetPasswordData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/auth/password/reset/request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Submit New Password
 * Submit a new password for the given e-mail.
 *
 * If the e-mail corresponds to a valid clinician and the given token is valid, then the password for the clinician will be updated.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | email | text* | Clinician's e-mail. |
 * | token | text* | Token received by e-mail when a request to reset the password is sent. |
 * | password | text* | New password. |
 * | password_confirmation | text* | New password confirmation. |
 */
export const submitNewPassword = <ThrowOnError extends boolean = false>(
  options?: Options<SubmitNewPasswordData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/auth/password/reset/submit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Change Password
 * Update the password from the authenticated clinician.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | new_password | text* | New password. |
 * | new_password_confirmation | text* | New password confirmation. |
 * | current_password | text* | Current password for the authenticated clinician. |
 */
export const changePassword = <ThrowOnError extends boolean = false>(
  options?: Options<ChangePasswordData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/password/change",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update authenticated clinician's license
 * Update authenticated clinician's license
 */
export const updateAuthenticatedClinicianSLicense = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAuthenticatedClinicianSLicenseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/licenses/{license}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create license for authenticated clinician
 * Create license for authenticated clinician
 */
export const createLicenseForAuthenticatedClinician = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CreateLicenseForAuthenticatedClinicianData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/licenses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get clinician's average response time
 * Get clinician's average response time
 */
export const getClinicianSAverageResponseTime = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetClinicianSAverageResponseTimeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/statistics/average/clinician-response-time",
      ...options,
    }
  );
};

/**
 * Get average processing cases time
 * Get average processing cases time
 */
export const getAverageProcessingCasesTime = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAverageProcessingCasesTimeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/statistics/average/processing-cases-time/",
      ...options,
    }
  );
};

/**
 * Get average patient wait treatment time
 * Get average patient wait treatment time
 */
export const getAveragePatientWaitTreatmentTime = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAveragePatientWaitTreatmentTimeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/statistics/average/patient-wait-treatment-time/",
      ...options,
    }
  );
};

/**
 * Get count of completed cases by period
 * Get count of processing cases by period
 */
export const getCountOfCompletedCasesByPeriod = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCountOfCompletedCasesByPeriodData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/statistics/count/completed-cases/{year}/{month}/{day}",
    ...options,
  });
};

/**
 * Get amount due for completed cases by period
 * Get clinician amount due for completed cases by period.
 */
export const getAmountDueForCompletedCasesByPeriod = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAmountDueForCompletedCasesByPeriodData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/statistics/amount-due/completed-cases/{year}/{month}/{day}",
    ...options,
  });
};

/**
 * Get count of cases on each status
 * Get count of cases on each status.
 *
 * ## Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partners | array(uuid) | If passed, all cases will belong to this partner. |
 * | clinicians | array(uuid) | If passed, all cases assigned to this clinician will be displayed. |
 * | is_assigned_to_me | boolean | Cases returned will be assigned to the clinician calling the route. |
 * | tags | array(uuid) | Filter by an array of Tag UUID. |
 * | diseases | array(uuid) | Filter by an array of Diseases UUID |
 * | states | array(uuid) | Filter by an array of State UUID |
 * | case_type | string | Case Type can by New or Follow-up |
 * | is_sync | boolean | Searchs for Routine or Extended Care encounters. If missing, returns both. |
 * | is_additional_approval_needed | boolean | Filter cases that needs an additional approval. |
 * | is_live | boolean | Defines if the cases from live patients should be returned (defaults to true) |
 * | is_sandbox | boolean | Defines if the cases from sandbox patients should be returned (defaults to false) |
 */
export const getCountOfCasesOnEachStatus = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCountOfCasesOnEachStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/statistics/count/cases-by-status/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Medical Assistants
 * Get Medical Assistants
 */
export const getMedicalAssistants = <ThrowOnError extends boolean = false>(
  options?: Options<GetMedicalAssistantsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/medical-assistants",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Medical Assistant
 * Create Medical Assistant
 */
export const createMedicalAssistant = <ThrowOnError extends boolean = false>(
  options?: Options<CreateMedicalAssistantData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/medical-assistants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete Medical Assistant
 * Delete Medical Assistant
 */
export const deleteMedicalAssistant = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMedicalAssistantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/medical-assistants/{medical-assistant}",
    ...options,
  });
};

/**
 * Search Medications
 * Search DoseSpot medications by name.
 *
 * This API endpoint forwards the request to DoseSpot in order to retrieve the medications.
 *
 * The returned results can be used to get details for a given medication (check **"Clinicians > Medications > Get Details For a Specific Medication"**).
 */
export const searchMedications1 = <ThrowOnError extends boolean = false>(
  options?: Options<SearchMedications1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/medications/search",
      ...options,
    }
  );
};

/**
 * Get Details For a Specific Medication
 * Get DoseSpot medication details according given **name** and **strength**.
 *
 * This API endpoint forwards the request to Dosespot in order to retrieve the medication details.
 */
export const getDetailsForASpecificMedication1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetDetailsForASpecificMedication1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/medications/select",
      ...options,
    }
  );
};

/**
 * Get Notifications
 * Get the user's notifications (paginated).
 */
export const getNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetNotificationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/notifications",
      ...options,
    }
  );
};

/**
 * Dismiss a notification
 * Dismiss a given notification.
 */
export const dismissANotification = <ThrowOnError extends boolean = false>(
  options: Options<DismissANotificationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/notifications/{notification}/dismiss",
    ...options,
  });
};

/**
 * Change notified user
 * Send this given notification to another group and/or a specific user.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | notified_model_type | string\* | clinician, support-staff, mdi-support-staff |
 * | notified_model_id | uuid | User ID |
 */
export const changeNotifiedUser = <ThrowOnError extends boolean = false>(
  options: Options<ChangeNotifiedUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/notifications/{notification}/notify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * List practice areas
 * List all clinician's practice areas registered.
 */
export const listPracticeAreas = <ThrowOnError extends boolean = false>(
  options?: Options<ListPracticeAreasData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/practice-areas",
      ...options,
    }
  );
};

/**
 * Attach a practice area
 * Attach a state to the authenticated clinician as a practice area.
 */
export const attachAPracticeArea = <ThrowOnError extends boolean = false>(
  options?: Options<AttachAPracticeAreaData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/practice-areas",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach a practice area
 * Detach a state from the authenticated clinician.
 */
export const detachAPracticeArea = <ThrowOnError extends boolean = false>(
  options: Options<DetachAPracticeAreaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/practice-areas/{state_id}",
    ...options,
  });
};

/**
 * Update a practice area
 * Update informations from a attached practice area.
 */
export const updateAPracticeArea = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAPracticeAreaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/practice-areas/{state_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get clinician information
 * Get clinician information based on the passed clinician_id.
 */
export const getClinicianInformation1 = <ThrowOnError extends boolean = false>(
  options: Options<GetClinicianInformation1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/clinicians/{clinician_id}",
    ...options,
  });
};

/**
 * Search associated Clinicians/Support staffs
 * Search for all clinician and support staff users by using filters.
 *
 * You can send an array of partners, if not passed, we will be using the clinician's partners.
 *
 * | **Field** | **Type** | **Description** |
 * | --- | --- | --- |
 * | only_clinicians | boolean | If passed it returns only clinicians, if not, it returns clinicians and support staff. **Default**: `false` |
 * | partners | array | Array of partner Ids. |
 */
export const searchAssociatedCliniciansSupportStaffs = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SearchAssociatedCliniciansSupportStaffsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/associated-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * List changelogs
 * List all existing Clinicians App changelogs.
 *
 * | **Param** | **Options** |
 * | --- | --- |
 * | scope | `api` `clinicians-app` `messages-app` `native-apps` `general` `patient-apps` |
 */
export const listChangelogs = <ThrowOnError extends boolean = false>(
  options?: Options<ListChangelogsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/changelogs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Service
 * Returns a single Partner Service that can be used as a template to generate a Case Service.
 */
export const getService1 = <ThrowOnError extends boolean = false>(
  options: Options<GetService1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/services/{partner_service_id}",
    ...options,
  });
};

/**
 * List Services
 * Returns a single Partner Service that can be used as a template to generate a Case Service.
 */
export const listServices1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListServices1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/services",
      ...options,
    }
  );
};

/**
 * List service notifications
 * List all existing Clinicians App service notifications.
 *
 * | **Param** | **Options** |
 * | --- | --- |
 * | type | `data-leak` `service-disruption` `maintenance` `other` |
 * | status | `scheduled` `ongoing` `completed` |
 * | scope | `api` `clinicians-app` `messages-app` `native-apps` `general` `patient-apps` |
 * | severity | `low` `medium` `high` |
 */
export const listServiceNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<ListServiceNotificationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/service-notifications",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach favorite tag
 * Allow to detach a favorite tag from clinician.
 */
export const detachFavoriteTag = <ThrowOnError extends boolean = false>(
  options: Options<DetachFavoriteTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/tags/{tag_id}/favorite",
    ...options,
  });
};

/**
 * Attach favorite tag
 * Allow to attach a favorite tag to clinician.
 */
export const attachFavoriteTag = <ThrowOnError extends boolean = false>(
  options: Options<AttachFavoriteTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/tags/{tag_id}/favorite",
      ...options,
    }
  );
};

/**
 * Get favorite tags
 * Get all clinician's favorite tags.
 *
 * It also returns Global and System tags.
 */
export const getFavoriteTags = <ThrowOnError extends boolean = false>(
  options?: Options<GetFavoriteTagsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/tags/favorite",
      ...options,
    }
  );
};

/**
 * Get tags
 * Get all tags created by the logged in clinician.
 *
 * It also returns Global and System tags.
 */
export const getTags = <ThrowOnError extends boolean = false>(
  options?: Options<GetTagsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/tags",
      ...options,
    }
  );
};

/**
 * Create tag
 * It allow clinicians to create private tags.
 *
 * | Description | Type |
 * | --- | --- |
 * | name | sring\* |
 * | key | string\* |
 * | color | string\* |
 * | description | string |
 * | removable_role | string (admin) |
 * | auto_detach_status | array |
 */
export const createTag = <ThrowOnError extends boolean = false>(
  options?: Options<CreateTagData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete tag
 * It allow clinicians to delete private tags.
 */
export const deleteTag = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/tags/{tag_id}",
    ...options,
  });
};

/**
 * Update tag
 * It allow clinicians to update private tags.
 *
 * | Description | Type |
 * | --- | --- |
 * | name | sring\* |
 * | color | string\* |
 * | description | string |
 * | removable_role | string (admin) |
 * | auto_detach_status | array |
 */
export const updateTag = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTagData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/tags/{tag_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Tickets
 * Get the partner's tickets (paginated).
 */
export const getTickets = <ThrowOnError extends boolean = false>(
  options?: Options<GetTicketsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/tickets",
      ...options,
    }
  );
};

/**
 * Create Ticket
 * Creates a ticket for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title\* | string |
 * | description\* | string |
 * | type\* | string (bug-report, feature-suggestion, question-help, other) |
 * | environment\* | string (development, staging, production, not-applicable) |
 * | product\* | string (api, clinician-portal, admin-panel, messaging-app, messaging-widget, onboarding-app, api-documentation, other) |
 * | is_urgent\* | boolean |
 * | requester_email\* | string |
 */
export const createTicket = <ThrowOnError extends boolean = false>(
  options?: Options<CreateTicketData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/tickets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Ticket
 * Get the partner's ticket details.
 */
export const getTicket = <ThrowOnError extends boolean = false>(
  options: Options<GetTicketData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/tickets/{ticket_id}",
    ...options,
  });
};

/**
 * Delete Ticket
 * Deletes the partner's ticket.
 */
export const deleteTicket = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTicketData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/tickets/{ticket}",
    ...options,
  });
};

/**
 * Get Messages
 * Get the user's notifications (messages) (paginated).
 */
export const getMessages3 = <ThrowOnError extends boolean = false>(
  options?: Options<GetMessages3Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/notifications/messages",
      ...options,
    }
  );
};

/**
 * Get devices
 * Get all active devices
 */
export const getDevices = <ThrowOnError extends boolean = false>(
  options?: Options<GetDevicesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician/devices",
      ...options,
    }
  );
};

/**
 * Delete device
 * Delete clinician device
 */
export const deleteDevice = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDeviceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/devices/{device_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Swap wildcards
 * It swaps the wildcards based on past information.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | text\* | string\* |
 * | patient_id | uuid |
 * | case_id | uuid |
 * | clinician_id | uuid |
 * | partner_id | uuid |
 */
export const swapWildcards1 = <ThrowOnError extends boolean = false>(
  options?: Options<SwapWildcards1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/wildcards/swap",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get available clinicians
 * Get available clinicians to be assigned to cases for a given partner.
 * The `state_id` will be used to filter by Clinician's Licenses State.
 *
 * # Payload
 *
 * | field | type | description |
 * |-------|:----:|------------:|
 * | partner_id | uuid* | Partner ID |
 * | state_id | uuid | State ID |
 */
export const getAvailableClinicians = <ThrowOnError extends boolean = false>(
  options?: Options<GetAvailableCliniciansData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician/available/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get authenticated clinician
 * Get the following information from the currently authenticated clinician:
 *
 * - Profile
 * - Address
 * - Licenses
 *
 * In order for a clinician to start prescribing medications or compounds, the clinician must be confirmed by DoseSpot (`dosespot_confirmed`). The confirmation is not instantaneous, so it may take a while.
 */
export const getAuthenticatedClinician = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthenticatedClinicianData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/clinician",
      ...options,
    }
  );
};

/**
 * Update authenticated clinician
 * Update the currently authenticated clinician record on both MD Integrations and DoseSpot.
 */
export const updateAuthenticatedClinician = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<UpdateAuthenticatedClinicianData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/clinician",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Status
 * Get the status details.
 */
export const getStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/admin/status",
      ...options,
    }
  );
};

/**
 * Replicate Compound
 * Replicates the partner's compound.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateCompound = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateCompoundData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/partners/{partner}/compounds/{compound}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Replicate Medication
 * Replicates the partner's medication.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateMedication = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateMedicationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/partners/{partner}/medications/{medication}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Replicate Offerings
 * Replicates all the partner's offerings.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateOfferings = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateOfferingsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/partners/{partner}/offerings/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Replicate Questionnaire
 * Replicates the partner's questionnaire.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateQuestionnaireData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/partners/{partner}/questionnaires/{questionnaire}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Replicate Service
 * Replicates the partner's service.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateService = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateServiceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/partners/{partner}/services/{service}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Replicate Supply
 * Replicates the partner's supply.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateSupply = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateSupplyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/admin/partners/{partner}/supplies/{supply}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Medications (Search)
 * Get the DoseSpot's medications with the search terms.
 */
export const getMedicationsSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetMedicationsSearchData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/admin/dosespot/medications/search",
      ...options,
    }
  );
};

/**
 * Get Medication (Select)
 * Get the DoseSpot's medication details with the select terms.
 */
export const getMedicationSelect = <ThrowOnError extends boolean = false>(
  options?: Options<GetMedicationSelectData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/admin/dosespot/medications/select",
      ...options,
    }
  );
};

/**
 * Get Pharmacies (Search)
 * Get the DoseSpot's pharmacies with the search terms.
 */
export const getPharmaciesSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetPharmaciesSearchData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/admin/dosespot/pharmacies/search",
      ...options,
    }
  );
};

/**
 * Get Pharmacy
 * Get the DoseSpot's pharmacy details.
 */
export const getPharmacy4 = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmacy4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/admin/dosespot/pharmacies/{pharmacy}",
    ...options,
  });
};

/**
 * Get Supplies (Search)
 * Get the DoseSpot's supplies with the search terms.
 */
export const getSuppliesSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetSuppliesSearchData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/admin/dosespot/supplies/search",
      ...options,
    }
  );
};

/**
 * Get Supply
 * Get the DoseSpot's supply.
 */
export const getSupply = <ThrowOnError extends boolean = false>(
  options: Options<GetSupplyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/admin/dosespot/supplies/{supplyId}",
    ...options,
  });
};

/**
 * Generate Text
 * Generate texts, get answers, etc., based on the given prompt using AI.
 */
export const generateText = <ThrowOnError extends boolean = false>(
  options?: Options<GenerateTextData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/ai/text",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Articles
 * Get the articles (paginated).
 */
export const getArticles1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetArticles1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/app/articles",
      ...options,
    }
  );
};

/**
 * Get Article
 * Get the article details.
 */
export const getArticle1 = <ThrowOnError extends boolean = false>(
  options: Options<GetArticle1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/articles/{article}",
    ...options,
  });
};

/**
 * Get Environments
 * Get the environments (paginated).
 */
export const getEnvironments1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetEnvironments1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/app/environments",
      ...options,
    }
  );
};

/**
 * Get Environment
 * Get the environment details.
 */
export const getEnvironment = <ThrowOnError extends boolean = false>(
  options: Options<GetEnvironmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/environments/{environment}",
    ...options,
  });
};

/**
 * Get Files
 * Get the patient's message's files (paginated).
 */
export const getFiles1 = <ThrowOnError extends boolean = false>(
  options: Options<GetFiles1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages/{message}/files",
    ...options,
  });
};

/**
 * Attach File
 * Attach the file to the patient's message.
 */
export const attachFile2 = <ThrowOnError extends boolean = false>(
  options: Options<AttachFile2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages/{message}/files/{file}",
    ...options,
  });
};

/**
 * Get Readings
 * Get the patient's message's readings (paginated).
 */
export const getReadings1 = <ThrowOnError extends boolean = false>(
  options: Options<GetReadings1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages/{message}/readings",
    ...options,
  });
};

/**
 * Get Messages
 * Get the patient's messages (paginated).
 */
export const getMessages4 = <ThrowOnError extends boolean = false>(
  options: Options<GetMessages4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages",
    ...options,
  });
};

/**
 * Create Message
 * Creates a patient's message, and attaches its files.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | channel\* | string |
 * | text | string |
 * | reference_message_id | uuid |
 * | files | array |
 *
 * # Payload (files)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 */
export const createMessage4 = <ThrowOnError extends boolean = false>(
  options: Options<CreateMessage4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/app/patients/{patient}/messages",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Message
 * Get the patient's message details.
 */
export const getMessage3 = <ThrowOnError extends boolean = false>(
  options: Options<GetMessage3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages/{message}",
    ...options,
  });
};

/**
 * Read Message
 * Reads the patient's message.
 */
export const readMessage2 = <ThrowOnError extends boolean = false>(
  options: Options<ReadMessage2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/app/patients/{patient}/messages/{message}/read",
      ...options,
    }
  );
};

/**
 * Unread Message
 * Unreads the patient's message.
 */
export const unreadMessage1 = <ThrowOnError extends boolean = false>(
  options: Options<UnreadMessage1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages/{message}/unread",
    ...options,
  });
};

/**
 * Dismiss Messages
 * Dismisses the patient's messages.
 */
export const dismissMessages1 = <ThrowOnError extends boolean = false>(
  options: Options<DismissMessages1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages/dismiss",
    ...options,
  });
};

/**
 * Undismiss Message
 * Undismisses the patient's message.
 */
export const undismissMessage1 = <ThrowOnError extends boolean = false>(
  options: Options<UndismissMessage1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/patients/{patient}/messages/{message}/undismiss",
    ...options,
  });
};

/**
 * Get Status
 * Get the status details.
 */
export const getStatus1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatus1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/app/status",
      ...options,
    }
  );
};

/**
 * Login User
 * Logins the user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | email\* | string |
 * | password\* | string |
 * | code\* | string |
 */
export const loginUser = <ThrowOnError extends boolean = false>(
  options?: Options<LoginUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/app/user/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Logout User
 * Logouts the user from the current device.
 */
export const logoutUser = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/user/logout",
    ...options,
  });
};

/**
 * Logout User (All)
 * Logouts the user from all devices.
 */
export const logoutUserAll = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutUserAllData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/app/user/logout/all",
    ...options,
  });
};

/**
 * Create Passcode
 * Creates a passcode for the user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | email\* | string |
 * | password\* | string |
 */
export const createPasscode = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePasscodeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/app/user/passcodes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Notifications (Messages)
 * Get the user's notifications (messages) (paginated).
 */
export const getNotificationsMessages = <ThrowOnError extends boolean = false>(
  options?: Options<GetNotificationsMessagesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/app/user/notifications/messages",
      ...options,
    }
  );
};

/**
 * Get User
 * Get the user details.
 */
export const getUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/app/user",
      ...options,
    }
  );
};

/**
 * Get Medications (Search)
 * Get the DoseSpot's medications with the search terms.
 */
export const getMedicationsSearch1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetMedicationsSearch1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/dosespot/medications/search",
      ...options,
    }
  );
};

/**
 * Get Medication (Select)
 * Get the DoseSpot's medication details with the select terms.
 */
export const getMedicationSelect1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetMedicationSelect1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/dosespot/medications/select",
      ...options,
    }
  );
};

/**
 * Get Pharmacies (Search)
 * Get the DoseSpot's pharmacies with the search terms.
 */
export const getPharmaciesSearch1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetPharmaciesSearch1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/dosespot/pharmacies/search",
      ...options,
    }
  );
};

/**
 * Get Pharmacy
 * Get the DoseSpot's pharmacy details.
 */
export const getPharmacy5 = <ThrowOnError extends boolean = false>(
  options: Options<GetPharmacy5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/dosespot/pharmacies/{pharmacy}",
    ...options,
  });
};

/**
 * Get Status
 * Get the status details.
 */
export const getStatus2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatus2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/dosespot/status",
      ...options,
    }
  );
};

/**
 * Get Supplies (Search)
 * Get the DoseSpot's supplies with the search terms.
 */
export const getSuppliesSearch1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetSuppliesSearch1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/dosespot/supplies/search",
      ...options,
    }
  );
};

/**
 * Get Supply
 * Get the DoseSpot's supply by ID.
 */
export const getSupply1 = <ThrowOnError extends boolean = false>(
  options: Options<GetSupply1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/dosespot/supplies/{supply_id}",
    ...options,
  });
};

/**
 * Get Patient Prescription Benefits
 * Get the Dosespot's Patient prescription benefits
 */
export const getPatientPrescriptionBenefits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientPrescriptionBenefitsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/dosespot/patients/{patient_id}/prescriptionbenefits",
    ...options,
  });
};

/**
 * Get Patient Medications History
 * Get the Dosespot's Patient medications history.
 */
export const getPatientMedicationsHistory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientMedicationsHistoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/dosespot/patients/{patient_id}/medications/history",
    ...options,
  });
};

/**
 * Dosespot Benefits check
 * Notifies the changelog,
 */
export const dosespotBenefitsCheck = <ThrowOnError extends boolean = false>(
  options: Options<DosespotBenefitsCheckData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/lambda/cases/{case}/benefits",
      ...options,
    }
  );
};

/**
 * Notify Changelog
 * Notifies the changelog,
 */
export const notifyChangelog = <ThrowOnError extends boolean = false>(
  options: Options<NotifyChangelogData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/lambda/changelogs/{changelog}/notify",
      ...options,
    }
  );
};

/**
 * Send Text Message
 * Sends the text message.
 */
export const sendTextMessage = <ThrowOnError extends boolean = false>(
  options: Options<SendTextMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/lambda/text-messages/{textMessage}/send",
      ...options,
    }
  );
};

/**
 * Send Email
 * Sends the email.
 */
export const sendEmail = <ThrowOnError extends boolean = false>(
  options: Options<SendEmailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/lambda/emails/{email}/send",
      ...options,
    }
  );
};

/**
 * Get Status
 * Get the status details.
 */
export const getStatus3 = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatus3Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/lambda/status",
      ...options,
    }
  );
};

/**
 * Send Webhook
 * Sends the webhook.
 */
export const sendWebhook = <ThrowOnError extends boolean = false>(
  options: Options<SendWebhookData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/lambda/webhooks/{webhook}/send",
      ...options,
    }
  );
};

/**
 * Patch File
 * Updates the file after lambda process.
 *
 * Eg. TextExtration
 */
export const patchFile1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchFile1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/lambda/files/{file}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get File
 * Get the file's file.
 */
export const getFile4 = <ThrowOnError extends boolean = false>(
  options: Options<GetFile4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/s3/files/{file}/file",
    ...options,
  });
};

/**
 * Get Thumbnail
 * Get the file's thumbnail.
 */
export const getThumbnail = <ThrowOnError extends boolean = false>(
  options: Options<GetThumbnailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/s3/files/{file}/thumbnail",
    ...options,
  });
};

/**
 * Get Status
 * Get the status details.
 */
export const getStatus4 = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatus4Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/s3/status",
      ...options,
    }
  );
};

/**
 * Get Articles
 * Get the articles (paginated).
 */
export const getArticles2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetArticles2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/articles",
      ...options,
    }
  );
};

/**
 * Get Article
 * Get the article details.
 */
export const getArticle2 = <ThrowOnError extends boolean = false>(
  options: Options<GetArticle2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/web/articles/{article}",
    ...options,
  });
};

/**
 * Get Changelogs
 * Get the changelogs (paginated).
 */
export const getChangelogs = <ThrowOnError extends boolean = false>(
  options?: Options<GetChangelogsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/changelogs",
      ...options,
    }
  );
};

/**
 * Create Changelog
 * Create a changelog
 *
 * | **Param** | **Type** | **Nullable** | **Required** | **Options** |
 * | --- | --- | --- | --- | --- |
 * | version | String | No | Yes | max:255 |
 * | date | Date | Yes | No |  |
 * | notes | String | Yes | No |  |
 * | scope | String | No | Yes | `api` `clinicians-app` `messages-app` `native-apps` `general` `patient-apps` |
 * | notify_clinicians | Boolean | Yes | No |  |
 * | notify_support_staffs | Boolean | Yes | No |  |
 */
export const createChangelog = <ThrowOnError extends boolean = false>(
  options?: Options<CreateChangelogData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/changelogs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete Changelog
 * Delete an existing changelog.
 */
export const deleteChangelog = <ThrowOnError extends boolean = false>(
  options: Options<DeleteChangelogData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/changelogs/{changelog_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update Changelog
 * Update an existing changelog
 *
 * | **Param** | **Type** | **Nullable** | **Required** | **Options** |
 * | --- | --- | --- | --- | --- |
 * | version | String | No | Yes | max:255 |
 * | date | Date | Yes | No |  |
 * | notes | String | Yes | No |  |
 * | scope | String | No | Yes | `api` `clinicians-app` `messages-app` `native-apps` `general` `patient-apps` |
 * | notify_clinicians | Boolean | Yes | No |  |
 * | notify_support_staffs | Boolean | Yes | No |  |
 */
export const updateChangelog = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChangelogData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/changelogs/{changelog_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Categories
 * Get the categories (paginated).
 */
export const getCategories = <ThrowOnError extends boolean = false>(
  options?: Options<GetCategoriesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/web/categories",
      ...options,
    }
  );
};

/**
 * Get Category
 * Get the category details.
 */
export const getCategory = <ThrowOnError extends boolean = false>(
  options: Options<GetCategoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/categories/{category}",
    ...options,
  });
};

/**
 * Get Licenses
 * Get the clinicians's licenses (paginated).
 */
export const getLicenses = <ThrowOnError extends boolean = false>(
  options: Options<GetLicensesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/licenses",
    ...options,
  });
};

/**
 * Get Medical Assistants
 * Get the medical assistants (paginated).
 */
export const getMedicalAssistants1 = <ThrowOnError extends boolean = false>(
  options: Options<GetMedicalAssistants1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/medical-assistants",
    ...options,
  });
};

/**
 * Detach Medical Assistant
 * Detach the medical assistant from the clinician.
 */
export const detachMedicalAssistant = <ThrowOnError extends boolean = false>(
  options: Options<DetachMedicalAssistantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/medical-assistants/{medicalAssistant}",
    ...options,
  });
};

/**
 * Attach Medical Assistant
 * Attach the medical assistant to the clinician.
 */
export const attachMedicalAssistant = <ThrowOnError extends boolean = false>(
  options: Options<AttachMedicalAssistantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/medical-assistants/{medicalAssistant}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get States
 * Get the clinician's states (paginated).
 */
export const getStates = <ThrowOnError extends boolean = false>(
  options: Options<GetStatesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/states",
    ...options,
  });
};

/**
 * Get Specialties
 * Get the partner's specialties (paginated).
 */
export const getSpecialties = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecialtiesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/specialties",
    ...options,
  });
};

/**
 * Detach Specialty
 * Detach the specialty from the partner.
 */
export const detachSpecialty = <ThrowOnError extends boolean = false>(
  options: Options<DetachSpecialtyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/specialties/{specialty}",
    ...options,
  });
};

/**
 * Update Specialty
 * Attach the specialty to the partner.
 */
export const updateSpecialty = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSpecialtyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/specialties/{specialty}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Specialty
 * Attach the specialty to the partner.
 */
export const attachSpecialty = <ThrowOnError extends boolean = false>(
  options: Options<AttachSpecialtyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/specialties/{specialty}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Clinicians
 * Get the clinicians list.
 */
export const getClinicians = <ThrowOnError extends boolean = false>(
  options?: Options<GetCliniciansData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/clinicians",
      ...options,
    }
  );
};

/**
 * Create Clinician
 * Get the clinician export file in xls format, containing basic information, licenses, and states.
 */
export const createClinician = <ThrowOnError extends boolean = false>(
  options?: Options<CreateClinicianData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Clinician
 * Get the clinician's details.
 */
export const getClinician = <ThrowOnError extends boolean = false>(
  options: Options<GetClinicianData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}",
    ...options,
  });
};

/**
 * Patch Clinician
 * Get the clinician export file in xls format, containing basic information, licenses, and states.
 */
export const patchClinician = <ThrowOnError extends boolean = false>(
  options: Options<PatchClinicianData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Clinician Export File
 * Get the clinician export file in xls format, containing basic information, licenses, and states.
 */
export const getClinicianExportFile = <ThrowOnError extends boolean = false>(
  options: Options<GetClinicianExportFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/clinicians/{clinician}/export",
      ...options,
    }
  );
};

/**
 * Get Clinician Partners
 * Get the clinician's partners.
 */
export const getClinicianPartners = <ThrowOnError extends boolean = false>(
  options: Options<GetClinicianPartnersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/clinicians/{clinician}/partners",
    ...options,
  });
};

/**
 * Get Countries
 * Get the countries (paginated).
 */
export const getCountries = <ThrowOnError extends boolean = false>(
  options?: Options<GetCountriesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/web/countries",
      ...options,
    }
  );
};

/**
 * Get Country
 * Get the country details.
 */
export const getCountry = <ThrowOnError extends boolean = false>(
  options: Options<GetCountryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/countries/{country}",
    ...options,
  });
};

/**
 * Get Disease
 * Get the disease details.
 */
export const getDisease = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/diseases/{disease}",
    ...options,
  });
};

/**
 * Get Diseases
 * Get the diseases (paginated).
 */
export const getDiseases = <ThrowOnError extends boolean = false>(
  options?: Options<GetDiseasesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/diseases",
      ...options,
    }
  );
};

/**
 * Get Dispense Unit
 * Get the dispense unit details.
 */
export const getDispenseUnit = <ThrowOnError extends boolean = false>(
  options: Options<GetDispenseUnitData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/dispense-units/{dispenseUnit}",
    ...options,
  });
};

/**
 * Get Dispense Units
 * Get the dispense units (paginated).
 */
export const getDispenseUnits2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetDispenseUnits2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/dispense-units",
      ...options,
    }
  );
};

/**
 * Get Email Templates
 * Get the email templates (paginated).
 */
export const getEmailTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<GetEmailTemplatesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/email-templates",
      ...options,
    }
  );
};

/**
 * Get Email Template
 * Get the email template details.
 */
export const getEmailTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailTemplateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/email-templates/{email-template}",
    ...options,
  });
};

/**
 * Get Environments
 * Get the environments (paginated).
 */
export const getEnvironments2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetEnvironments2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/environments",
      ...options,
    }
  );
};

/**
 * Get Environment
 * Get the environment details.
 */
export const getEnvironment1 = <ThrowOnError extends boolean = false>(
  options: Options<GetEnvironment1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/environments/{environment}",
    ...options,
  });
};

/**
 * Create File
 * Creates a file.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | file\* | file |
 */
export const createFile4 = <ThrowOnError extends boolean = false>(
  options?: Options<CreateFile4Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Get File
 * Get the file details.
 */
export const getFile5 = <ThrowOnError extends boolean = false>(
  options: Options<GetFile5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/files/{file}",
    ...options,
  });
};

/**
 * Get Internal Support Staff
 * Get the support staff details.
 */
export const getInternalSupportStaff = <ThrowOnError extends boolean = false>(
  options: Options<GetInternalSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/internal-support-staffs/{supportStaff}",
    ...options,
  });
};

/**
 * Get Internal Support Staffs
 * Get the support staffs list.
 */
export const getInternalSupportStaffs = <ThrowOnError extends boolean = false>(
  options?: Options<GetInternalSupportStaffsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/internal-support-staffs",
      ...options,
    }
  );
};

/**
 * Create Support Staff
 * Creates a support staff.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name\* | string |
 * | last_name\* | string |
 * | email\* | string |
 * | photo_id | uuid |
 * | active\* | boolean |
 * | timezone_id\* | uuid |
 * | permissions | array (live, sandbox) |
 */
export const createSupportStaff = <ThrowOnError extends boolean = false>(
  options?: Options<CreateSupportStaffData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/internal-support-staffs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Internal Support Staff Partners
 * Get the support staffs partners list.
 */
export const getInternalSupportStaffPartners = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetInternalSupportStaffPartnersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/internal-support-staffs/{supportStaff}/partners",
    ...options,
  });
};

/**
 * Get Support Staff
 * Get the support staff details.
 */
export const getSupportStaff = <ThrowOnError extends boolean = false>(
  options: Options<GetSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/support-staffs/{supportStaff}",
    ...options,
  });
};

/**
 * Update Support Staff
 * Updates the support staff.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name | string |
 * | last_name | string |
 * | email | string |
 * | photo_id | uuid |
 * | active | boolean |
 * | password | string |
 * | password_confirmation\* | string |
 * | timezone_id | uuid |
 * | permissions | array (live, sandbox) |
 */
export const updateSupportStaff = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/support-staffs/{supportStaff}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete Medical Assistant
 * Updates the medical assistant.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name | string |
 * | last_name | string |
 * | email | string |
 * | photo_id | uuid |
 * | active | boolean |
 * | password | string |
 * | password_confirmation\* | string |
 * | timezone_id | uuid |
 * | permissions | array (live, sandbox) |
 */
export const deleteMedicalAssistant1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMedicalAssistant1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/medical-assistants/{medicalAssistant}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Medical Assistant
 * Get the medical assistant details.
 */
export const getMedicalAssistant = <ThrowOnError extends boolean = false>(
  options: Options<GetMedicalAssistantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/medical-assistants/{medicalAssistant}",
    ...options,
  });
};

/**
 * Update Medical Assistant
 * Updates the medical assistant.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name | string |
 * | last_name | string |
 * | email | string |
 * | photo_id | uuid |
 * | active | boolean |
 * | password | string |
 * | password_confirmation\* | string |
 * | timezone_id | uuid |
 * | permissions | array (live, sandbox) |
 */
export const updateMedicalAssistant = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMedicalAssistantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/medical-assistants/{medicalAssistant}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Medical Assistants
 * Get the medical assistants list.
 */
export const getMedicalAssistants2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetMedicalAssistants2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/medical-assistants",
      ...options,
    }
  );
};

/**
 * Create Medical Assistant
 * Creates a medical assistant.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name\* | string |
 * | last_name\* | string |
 * | email\* | string |
 * | photo_id | uuid |
 * | active\* | boolean |
 * | timezone_id\* | uuid |
 * | permissions | array (live, sandbox) |
 */
export const createMedicalAssistant1 = <ThrowOnError extends boolean = false>(
  options?: Options<CreateMedicalAssistant1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/medical-assistants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Medical Assistant Clinicians
 * Get the medical assistant's clinician list.
 */
export const getMedicalAssistantClinicians = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMedicalAssistantCliniciansData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/medical-assistants/{medicalAssistant}/clinicians",
    ...options,
  });
};

/**
 * Create Panel User
 * Creates a panel user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | email\* | string |
 * | timezone_id | uuid |
 */
export const createPanelUser = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePanelUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/panel-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Panel User
 * Get the panel user details.
 */
export const getPanelUser = <ThrowOnError extends boolean = false>(
  options: Options<GetPanelUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/panel-users/{paneUser}",
    ...options,
  });
};

/**
 * Update Panel User
 * Updates the panel user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name | string |
 * | email | string |
 * | password | string |
 * | password_confirmation | string |
 * | timezone_id | string |
 */
export const updatePanelUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePanelUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/panel-users/{paneUser}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Service Notifications
 * Get the service notifications (paginated).
 */
export const getServiceNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetServiceNotificationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/service-notifications",
      ...options,
    }
  );
};

/**
 * Get Categories
 * Get the partner's categories (paginated).
 */
export const getCategories1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCategories1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/categories",
    ...options,
  });
};

/**
 * Detach Category
 * Detach the category from the partner.
 */
export const detachCategory = <ThrowOnError extends boolean = false>(
  options: Options<DetachCategoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/categories/{category}",
    ...options,
  });
};

/**
 * Attach Category
 * Attach the category to the partner.
 */
export const attachCategory = <ThrowOnError extends boolean = false>(
  options: Options<AttachCategoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/categories/{category}",
    ...options,
  });
};

/**
 * Detach Clinician
 * Detach the clinician from the partner.
 */
export const detachClinician = <ThrowOnError extends boolean = false>(
  options: Options<DetachClinicianData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/clinicians/{clinician}",
    ...options,
  });
};

/**
 * Update Attached Clinician
 * Updates the partner's clinician.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | priority | Clinician's priority |
 */
export const updateAttachedClinician = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAttachedClinicianData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/clinicians/{clinician}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Clinician
 * Attach the clinician to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | priority | Clinician's priority |
 */
export const attachClinician = <ThrowOnError extends boolean = false>(
  options: Options<AttachClinicianData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/clinicians/{clinician}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Clinicians
 * Get the partner's clinicians (paginated).
 */
export const getClinicians1 = <ThrowOnError extends boolean = false>(
  options: Options<GetClinicians1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/clinicians",
    ...options,
  });
};

/**
 * Get Clinicians Export File
 * Get the clinicians export file from a partner in xls format, containing basic information, licenses, and states.
 */
export const getCliniciansExportFile = <ThrowOnError extends boolean = false>(
  options: Options<GetCliniciansExportFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/clinicians/export",
      ...options,
    }
  );
};

/**
 * Get Diseases
 * Get the partner's compound's diseases (paginated).
 */
export const getDiseases1 = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseases1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/diseases",
    ...options,
  });
};

/**
 * Detach Disease
 * Detach the disease from the partner's compound.
 */
export const detachDisease = <ThrowOnError extends boolean = false>(
  options: Options<DetachDiseaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/diseases/{disease}",
    ...options,
  });
};

/**
 * Attach Disease
 * Attach the disease to the partner's compound.
 */
export const attachDisease = <ThrowOnError extends boolean = false>(
  options: Options<AttachDiseaseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/diseases/{disease}",
    ...options,
  });
};

/**
 * Get Tags
 * Get the partner's compound's tags (paginated).
 */
export const getTags1 = <ThrowOnError extends boolean = false>(
  options: Options<GetTags1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/tags",
    ...options,
  });
};

/**
 * Detach Tag
 * Detach the tag from the partner's compound.
 */
export const detachTag2 = <ThrowOnError extends boolean = false>(
  options: Options<DetachTag2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/tags/{tag}",
    ...options,
  });
};

/**
 * Update Tag
 * Update the tag's notes to the partner's compound.
 */
export const updateTag1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTag1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/tags/{tag}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Tag
 * Attach the tag to the partner's compound.
 */
export const attachTag2 = <ThrowOnError extends boolean = false>(
  options: Options<AttachTag2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/compounds/{compound}/tags/{tag}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get States
 * Get the partner's compound's states (paginated).
 */
export const getStates1 = <ThrowOnError extends boolean = false>(
  options: Options<GetStates1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/states",
    ...options,
  });
};

/**
 * Detach State
 * Detach the state from the partner's compound.
 */
export const detachState = <ThrowOnError extends boolean = false>(
  options: Options<DetachStateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/states/{state}",
    ...options,
  });
};

/**
 * Attach State
 * Attach the state to the partner's compound.
 */
export const attachState = <ThrowOnError extends boolean = false>(
  options: Options<AttachStateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/states/{state}",
    ...options,
  });
};

/**
 * Delete Compound
 * Deletes the partner's compound.
 */
export const deleteCompound = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCompoundData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}",
    ...options,
  });
};

/**
 * Get Compound
 * Get the partner's compound details.
 */
export const getCompound = <ThrowOnError extends boolean = false>(
  options: Options<GetCompoundData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}",
    ...options,
  });
};

/**
 * Update Compound
 * Updates the partner's compound.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | clinician_id | string |
 * | active | boolean |
 * | is_additional_approval_needed | boolean |
 * | title | string |
 * | name | string |
 * | refills | integer |
 * | quantity | string |
 * | days_supply | integer |
 * | directions | string |
 * | effective_date | integer |
 * | dispense_unit | string |
 * | dispense_unit_id | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy | boolean |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | metadata | string |
 * | order | integer |
 * | allow_substitutions | boolean |
 */
export const updateCompound = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCompoundData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Compounds
 * Get the partner's compounds (paginated).
 */
export const getCompounds = <ThrowOnError extends boolean = false>(
  options: Options<GetCompoundsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds",
    ...options,
  });
};

/**
 * Create Compound
 * Creates a compound for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | clinician_id | uuid |
 * | active\* | boolean |
 * | is_additional_approval_needed | boolean |
 * | title | string |
 * | name\* | string |
 * | refills\* | integer |
 * | quantity\* | string |
 * | days_supply | integer |
 * | directions\* | string |
 * | effective_date | integer |
 * | dispense_unit\* | string |
 * | dispense_unit_id\* | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy\* | boolean |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | metadata | string |
 * | order | integer |
 * | allow_substitutions\* | boolean |
 */
export const createCompound = <ThrowOnError extends boolean = false>(
  options: Options<CreateCompoundData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/compounds",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Restore Compound
 * Restores the partner's compound.
 */
export const restoreCompound = <ThrowOnError extends boolean = false>(
  options: Options<RestoreCompoundData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/compounds/{compound}/restore",
    ...options,
  });
};

/**
 * Apply Compounds Reviews
 * Apply all reviews for all compounds of the partner.
 */
export const applyCompoundsReviews = <ThrowOnError extends boolean = false>(
  options: Options<ApplyCompoundsReviewsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/compounds/reviews/apply",
      ...options,
    }
  );
};

/**
 * Apply Compound Review
 * Apply the review of the partner's compound.
 */
export const applyCompoundReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyCompoundReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/compounds/{compound}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Replicate Compound
 * Replicates the partner's compound.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateCompound1 = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateCompound1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/partners/{partner}/compounds/{compound}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Contacts
 * Get the partner's contacts (paginated).
 */
export const getContacts = <ThrowOnError extends boolean = false>(
  options: Options<GetContactsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/contacts",
    ...options,
  });
};

/**
 * Create Contact
 * Creates a contact for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name\* | string |
 * | last_name\* | string |
 * | email\* | string |
 * | job_title | string |
 */
export const createContact = <ThrowOnError extends boolean = false>(
  options: Options<CreateContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/contacts",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Contact
 * Deletes the partner's contact.
 */
export const deleteContact = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/contacts/{contact}",
    ...options,
  });
};

/**
 * Update Contact
 * Updates the partner's contact.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name | string |
 * | last_name | string |
 * | email | string |
 * | job_title | string |
 */
export const updateContact = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/contacts/{contact}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Credentials
 * Get the partner's credentials (paginated).
 */
export const getCredentials = <ThrowOnError extends boolean = false>(
  options: Options<GetCredentialsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/credentials",
    ...options,
  });
};

/**
 * Create Credential
 * Creates a credential for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | environment_id\* | uuid |
 */
export const createCredential = <ThrowOnError extends boolean = false>(
  options: Options<CreateCredentialData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/credentials",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Credential
 * Detach the partner's credential.
 */
export const deleteCredential = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCredentialData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/credentials/{credential}",
    ...options,
  });
};

/**
 * Get Documentations
 * Get the partner's documentations (paginated).
 */
export const getDocumentations = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/documentations",
    ...options,
  });
};

/**
 * Create Documentation
 * Creates a documentation for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | type\* | string (information. process) |
 * | description\* | string |
 * | title\* | string |
 * | key\* | string |
 */
export const createDocumentation = <ThrowOnError extends boolean = false>(
  options: Options<CreateDocumentationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/documentations",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Documentation
 * Deletes the partner's documentation.
 */
export const deleteDocumentation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDocumentationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/documentations/{documentation}",
    ...options,
  });
};

/**
 * Update Documentation
 * Updates the partner's documentation.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | type | string (information, process) |
 * | description | string |
 * | title | string |
 * | key | string |
 */
export const updateDocumentation = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDocumentationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/documentations/{documentation}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Encounters
 * Get the partner's encounters (paginated).
 */
export const getEncounters = <ThrowOnError extends boolean = false>(
  options: Options<GetEncountersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/encounters",
    ...options,
  });
};

/**
 * Export Encounters
 * Exports the partner's encounters, based on the given parameters.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | status\* | array |
 * | clinician_id | uuid |
 * | status_date_from | date |
 * | status_date_to | date |
 * | status_date_from | date |
 * | status_date_to | date |
 * | type | string (new, follow-up) |
 * | is_sync | boolean |
 * | is_chargeable | boolean |
 * | environments | array (live, sandbox) |
 */
export const exportEncounters = <ThrowOnError extends boolean = false>(
  options: Options<ExportEncountersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/encounters/export",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Environments
 * Get the partner's environments (paginated).
 */
export const getEnvironments3 = <ThrowOnError extends boolean = false>(
  options: Options<GetEnvironments3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/environments",
    ...options,
  });
};

/**
 * Create Environment
 * Creates a environment for the partner.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | webhook_url\* | string |
 * | webhook_secret | string |
 * | webhook_authorization | string |
 * | environment_id\* | uuid |
 */
export const createEnvironment = <ThrowOnError extends boolean = false>(
  options: Options<CreateEnvironmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/environments",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Environment
 * Deletes the partner's environment.
 */
export const deleteEnvironment = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEnvironmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/environments/{environment}",
    ...options,
  });
};

/**
 * Get Environment
 * Get the partner's environment details.
 */
export const getEnvironment2 = <ThrowOnError extends boolean = false>(
  options: Options<GetEnvironment2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/environments/{environment}",
    ...options,
  });
};

/**
 * Update Environment
 * Updates the partner's environment.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | webhook_url | string |
 * | webhook_secret | string |
 * | webhook_authorization | string |
 * | environment_id | uuid |
 */
export const updateEnvironment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEnvironmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/environments/{environment}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Contact Email
 * Sends a contact email from the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | company\* | string |
 * | email\* | string |
 * | text\* | string |
 * | recaptcha\* | string |
 */
export const contactEmail = <ThrowOnError extends boolean = false>(
  options?: Options<ContactEmailData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/partners/emails/contact",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Files
 * Get the partner's files (paginated).
 */
export const getFiles2 = <ThrowOnError extends boolean = false>(
  options: Options<GetFiles2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/files",
    ...options,
  });
};

/**
 * Detach File
 * Detach the file from the partner.
 */
export const detachFile = <ThrowOnError extends boolean = false>(
  options: Options<DetachFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/files/{file}",
    ...options,
  });
};

/**
 * Update File
 * Updates the partner's environment.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | title\* | string |
 * | type\* | string (other, review, document) |
 */
export const updateFile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/files/{file}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach File
 * Attach the file to the partner.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | title\* | string |
 * | type | string (document, review, other) |
 */
export const attachFile3 = <ThrowOnError extends boolean = false>(
  options: Options<AttachFile3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/files/{file}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach Internal Support Staff
 * Detach the support staff from the partner.
 */
export const detachInternalSupportStaff = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DetachInternalSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/internal-support-staffs/{supportStaff}",
    ...options,
  });
};

/**
 * Update Internal Support Staff
 * Updates the partner's support staff.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name | string |
 * | last_name | string |
 * | email | string |
 * | photo_id | uuid |
 * | active | boolean |
 * | password | string |
 * | password_confirmation\* | string |
 * | timezone_id | uuid |
 * | permissions | array (live, sandbox) |
 * | can_unlock_phi | boolean |
 */
export const updateInternalSupportStaff = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateInternalSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/internal-support-staffs/{supportStaff}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Internal Support Staff
 * Attach the support staff to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | can_unlock_phi | boolean |
 */
export const attachInternalSupportStaff = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AttachInternalSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/internal-support-staffs/{supportStaff}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Internal Support Staffs
 * Get the partner's support staffs (paginated).
 */
export const getInternalSupportStaffs1 = <ThrowOnError extends boolean = false>(
  options: Options<GetInternalSupportStaffs1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/internal-support-staffs",
    ...options,
  });
};

/**
 * Get Invoices
 * Get the partner's invoices (paginated).
 */
export const getInvoices = <ThrowOnError extends boolean = false>(
  options: Options<GetInvoicesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/invoices",
    ...options,
  });
};

/**
 * Get Diseases
 * Get the partner's medication's diseases (paginated).
 */
export const getDiseases2 = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseases2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/diseases",
    ...options,
  });
};

/**
 * Detach Disease
 * Detach the disease from the partner's medication.
 */
export const detachDisease1 = <ThrowOnError extends boolean = false>(
  options: Options<DetachDisease1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/diseases/{disease}",
    ...options,
  });
};

/**
 * Attach Disease
 * Attach the disease to the partner's medication.
 */
export const attachDisease1 = <ThrowOnError extends boolean = false>(
  options: Options<AttachDisease1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/diseases/{disease}",
    ...options,
  });
};

/**
 * Get Tags
 * Get the partner's medication's tags (paginated).
 */
export const getTags2 = <ThrowOnError extends boolean = false>(
  options: Options<GetTags2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/tags",
    ...options,
  });
};

/**
 * Detach Tag
 * Detach the tag from the partner's medication.
 */
export const detachTag3 = <ThrowOnError extends boolean = false>(
  options: Options<DetachTag3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/tags/{tag}",
    ...options,
  });
};

/**
 * Update Tag
 * Update the tag's notes to the partner's medication.
 */
export const updateTag2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTag2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/tags/{tag}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Tag
 * Attach the tag to the partner's medication.
 */
export const attachTag3 = <ThrowOnError extends boolean = false>(
  options: Options<AttachTag3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/medications/{medication}/tags/{tag}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get States
 * Get the partner's medication's states (paginated).
 */
export const getStates2 = <ThrowOnError extends boolean = false>(
  options: Options<GetStates2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/states",
    ...options,
  });
};

/**
 * Detach State
 * Detach the state from the partner's medication.
 */
export const detachState1 = <ThrowOnError extends boolean = false>(
  options: Options<DetachState1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/states/{state}",
    ...options,
  });
};

/**
 * Attach State
 * Attach the state to the partner's medication.
 */
export const attachState1 = <ThrowOnError extends boolean = false>(
  options: Options<AttachState1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/states/{state}",
    ...options,
  });
};

/**
 * Delete Medication
 * Deletes the partner's medication.
 */
export const deleteMedication = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMedicationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}",
    ...options,
  });
};

/**
 * Get Medication
 * Get the partner's medication details.
 */
export const getMedication = <ThrowOnError extends boolean = false>(
  options: Options<GetMedicationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}",
    ...options,
  });
};

/**
 * Update Medication
 * Updates the partner's medication.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | active | boolean |
 * | is_additional_approval_needed | boolean |
 * | title | string |
 * | refills | integer |
 * | quantity | string |
 * | days_supply | integer |
 * | directions | string |
 * | effective_date | integer |
 * | dispense_unit | string |
 * | dispense_unit_id | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy | boolean |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | metadata | string |
 * | order | integer |
 * | allow_substitutions | boolean |
 */
export const updateMedication = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMedicationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Medications
 * Get the partner's medications (paginated).
 */
export const getMedications = <ThrowOnError extends boolean = false>(
  options: Options<GetMedicationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications",
    ...options,
  });
};

/**
 * Create Medication
 * Creates a medication for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | active\* | boolean |
 * | is_additional_approval_needed | boolean |
 * | title | string |
 * | refills\* | integer |
 * | quantity\* | string |
 * | days_supply | integer |
 * | directions\* | string |
 * | name\* | string |
 * | strength\* | string |
 * | ndc | string |
 * | effective_date | integer |
 * | dispense_unit\* | string |
 * | dispense_unit_id\* | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy\* | boolean |
 * | dosespot_rxcui | integer |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | metadata | string |
 * | order | integer |
 * | allow_substitutions\* | boolean |
 */
export const createMedication = <ThrowOnError extends boolean = false>(
  options: Options<CreateMedicationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/medications",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Restore Medication
 * Restores the partner's medication.
 */
export const restoreMedication = <ThrowOnError extends boolean = false>(
  options: Options<RestoreMedicationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/medications/{medication}/restore",
    ...options,
  });
};

/**
 * Apply Medications Reviews
 * Apply all reviews for all medications of the partner.
 *
 */
export const applyMedicationsReviews = <ThrowOnError extends boolean = false>(
  options: Options<ApplyMedicationsReviewsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/medications/reviews/apply",
      ...options,
    }
  );
};

/**
 * Apply Medication Review
 * Apply the review of the partner's medication.
 */
export const applyMedicationReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyMedicationReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/medications/{medication}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Replicate Medication
 * Replicates the partner's medication.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateMedication1 = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateMedication1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/partners/{partner}/medications/{medication}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Offering Reviews
 * Get all reviews of partner's offerings.
 */
export const getOfferingReviews = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferingReviewsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/web/partners/{partner}/offerings/{offerginType}/{offering}/reviews",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Reject Review
 * Reject the review of partner offerings.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | reviewed_notes | string |
 */
export const rejectReview = <ThrowOnError extends boolean = false>(
  options: Options<RejectReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/offerings/{offerginType}/{offering}/reviews/{review}/reject",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Dismiss Review
 * Dismiss the review of partner offerings.
 */
export const dismissReview = <ThrowOnError extends boolean = false>(
  options: Options<DismissReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/offerings/{offerginType}/{offering}/reviews/{review}/dismiss",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Replicate Offerings
 * Replicates all the partner's offerings.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateOfferings1 = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateOfferings1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/partners/{partner}/offerings/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Panel Users
 * Get the partner's panel users (paginated).
 */
export const getPanelUsers = <ThrowOnError extends boolean = false>(
  options: Options<GetPanelUsersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/panel-users",
    ...options,
  });
};

/**
 * Create  Panel User
 * Creates a panel user and attaches it to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | email\* | string |
 * | timezone_id | uuid |
 * | managed_by_partner | boolean |
 */
export const createPanelUser1 = <ThrowOnError extends boolean = false>(
  options: Options<CreatePanelUser1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/panel-users",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Attach Panel User (Email)
 * Attach the panel user (email) to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | email\* | string |
 */
export const attachPanelUserEmail = <ThrowOnError extends boolean = false>(
  options: Options<AttachPanelUserEmailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/panel-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach Panel User
 * Detach the panel user from the partner.
 */
export const detachPanelUser = <ThrowOnError extends boolean = false>(
  options: Options<DetachPanelUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/panel-users/{panelUser}",
    ...options,
  });
};

/**
 * Attach Panel User
 * Attach the panel user to the partner.
 */
export const attachPanelUser = <ThrowOnError extends boolean = false>(
  options: Options<AttachPanelUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/panel-users/{panelUser}",
    ...options,
  });
};

/**
 * Get Patients
 * Get the partner's patients (paginated).
 */
export const getPatients1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPatients1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/patients",
    ...options,
  });
};

/**
 * Get Parameters
 * Get the partner's parameters (paginated).
 */
export const getParameters = <ThrowOnError extends boolean = false>(
  options: Options<GetParametersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/parameters",
    ...options,
  });
};

/**
 * Create Parameter
 * Creates a parameter for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | key\* | string |
 * | value\* | string |
 * | type\* | string |
 */
export const createParameter = <ThrowOnError extends boolean = false>(
  options: Options<CreateParameterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/parameters",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Parameter
 * Deletes the partner's parameter.
 */
export const deleteParameter = <ThrowOnError extends boolean = false>(
  options: Options<DeleteParameterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/parameters/{parameter}",
    ...options,
  });
};

/**
 * Update Parameter
 * Updates the partner's parameter.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | key | string |
 * | value | string |
 * | type | string |
 */
export const updateParameter = <ThrowOnError extends boolean = false>(
  options: Options<UpdateParameterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/parameters/{parameter}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Diseases
 * Get the partner's supply's diseases (paginated).
 */
export const getDiseases3 = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseases3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/diseases",
    ...options,
  });
};

/**
 * Detach Disease
 * Detach the disease from the partner's supply.
 */
export const detachDisease2 = <ThrowOnError extends boolean = false>(
  options: Options<DetachDisease2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/diseases/{disease}",
    ...options,
  });
};

/**
 * Attach Disease
 * Attach the disease to the partner's supply.
 */
export const attachDisease2 = <ThrowOnError extends boolean = false>(
  options: Options<AttachDisease2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/diseases/{disease}",
    ...options,
  });
};

/**
 * Get Tags
 * Get the partner's supply's tags (paginated).
 */
export const getTags3 = <ThrowOnError extends boolean = false>(
  options: Options<GetTags3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/tags",
    ...options,
  });
};

/**
 * Detach Tag
 * Detach the tag from the partner's supply.
 */
export const detachTag4 = <ThrowOnError extends boolean = false>(
  options: Options<DetachTag4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/tags/{tag}",
    ...options,
  });
};

/**
 * Update Tag
 * Update the tag's notes to the partner's supply.
 */
export const updateTag3 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTag3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/tags/{tag}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Tag
 * Attach the tag to the partner's supply.
 */
export const attachTag4 = <ThrowOnError extends boolean = false>(
  options: Options<AttachTag4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/supplies/{supply}/tags/{tag}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get States
 * Get the partner's supply's states (paginated).
 */
export const getStates3 = <ThrowOnError extends boolean = false>(
  options: Options<GetStates3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/states",
    ...options,
  });
};

/**
 * Detach State
 * Detach the state from the partner's supply.
 */
export const detachState2 = <ThrowOnError extends boolean = false>(
  options: Options<DetachState2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/states/{state}",
    ...options,
  });
};

/**
 * Attach State
 * Attach the state to the partner's supply.
 */
export const attachState2 = <ThrowOnError extends boolean = false>(
  options: Options<AttachState2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/states/{state}",
    ...options,
  });
};

/**
 * Get Supply
 * Get the partner's supply details.
 */
export const getSupply2 = <ThrowOnError extends boolean = false>(
  options: Options<GetSupply2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{suppply}",
    ...options,
  });
};

/**
 * Delete Supply
 * Deletes the partner's supply.
 */
export const deleteSupply = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSupplyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}",
    ...options,
  });
};

/**
 * Update Supply
 * Updates the partner's supply.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | active | boolean |
 * | is_additional_approval_needed | boolean |
 * | title | string |
 * | refills | integer |
 * | quantity | string |
 * | days_supply | integer |
 * | directions | string |
 * | effective_date | integer |
 * | dispense_unit | string |
 * | dispense_unit_id | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy | boolean |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | order | integer |
 * | metadata | string |
 */
export const updateSupply = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSupplyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Supplies
 * Get the partner's supplies (paginated).
 */
export const getSupplies = <ThrowOnError extends boolean = false>(
  options: Options<GetSuppliesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies",
    ...options,
  });
};

/**
 * Create Supply
 * Creates a supply for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | active\* | boolean |
 * | is_additional_approval_needed | boolean |
 * | title | string |
 * | refills\* | integer |
 * | quantity\* | string |
 * | days_supply | integer |
 * | directions\* | string |
 * | name\* | string |
 * | ndc\* | string |
 * | effective_date | integer |
 * | dispense_unit\* | string |
 * | dispense_unit_id\* | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy\* | boolean |
 * | dosespot_supply_id | integer |
 * | rx_required | boolean |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | order | integer |
 * | metadata | string |
 */
export const createSupply = <ThrowOnError extends boolean = false>(
  options: Options<CreateSupplyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/supplies",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Restore Supply
 * Restores the partner's supply.
 */
export const restoreSupply = <ThrowOnError extends boolean = false>(
  options: Options<RestoreSupplyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/supplies/{supply}/restore",
    ...options,
  });
};

/**
 * Apply Supplies Reviews
 * Apply all reviews for all supplies of the partner.
 */
export const applySuppliesReviews = <ThrowOnError extends boolean = false>(
  options: Options<ApplySuppliesReviewsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/supplies/reviews/apply",
      ...options,
    }
  );
};

/**
 * Apply Supply Review
 * Apply the review of the partner's supply.
 */
export const applySupplyReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplySupplyReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/supplies/{supply}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Replicate Supply
 * Replicates the partner's supply.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateSupply1 = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateSupply1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/partners/{partner}/supplies/{supply}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Diseases
 * Get the partner's service's diseases (paginated).
 */
export const getDiseases4 = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseases4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/diseases",
    ...options,
  });
};

/**
 * Detach Disease
 * Detach the disease from the partner's service.
 */
export const detachDisease3 = <ThrowOnError extends boolean = false>(
  options: Options<DetachDisease3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/diseases/{disease}",
    ...options,
  });
};

/**
 * Attach Disease
 * Attach the disease to the partner's service.
 */
export const attachDisease3 = <ThrowOnError extends boolean = false>(
  options: Options<AttachDisease3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/diseases/{disease}",
    ...options,
  });
};

/**
 * Get Tags
 * Get the partner's services tags (paginated).
 */
export const getTags4 = <ThrowOnError extends boolean = false>(
  options: Options<GetTags4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/tags",
    ...options,
  });
};

/**
 * Detach Tag
 * Detach the tag from the partner's service.
 */
export const detachTag5 = <ThrowOnError extends boolean = false>(
  options: Options<DetachTag5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/tags/{tag}",
    ...options,
  });
};

/**
 * Update Tag
 * Update the tag's notes to the partner's service.
 */
export const updateTag4 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTag4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/tags/{tag}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Tag
 * Attach the tag to the partner's service.
 */
export const attachTag5 = <ThrowOnError extends boolean = false>(
  options: Options<AttachTag5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/services/{service}/tags/{tag}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get States
 * Get the partner's services's states (paginated).
 */
export const getStates4 = <ThrowOnError extends boolean = false>(
  options: Options<GetStates4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/states",
    ...options,
  });
};

/**
 * Detach State
 * Detach the state from the partner's service.
 */
export const detachState3 = <ThrowOnError extends boolean = false>(
  options: Options<DetachState3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/states/{state}",
    ...options,
  });
};

/**
 * Attach State
 * Attach the state to the partner's service.
 */
export const attachState3 = <ThrowOnError extends boolean = false>(
  options: Options<AttachState3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/states/{state}",
    ...options,
  });
};

/**
 * Delete Service
 * Deletes the partner's service.
 */
export const deleteService = <ThrowOnError extends boolean = false>(
  options: Options<DeleteServiceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}",
    ...options,
  });
};

/**
 * Get Service
 * Get the partner's service details.
 */
export const getService2 = <ThrowOnError extends boolean = false>(
  options: Options<GetService2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}",
    ...options,
  });
};

/**
 * Update Service
 * Updates the partner's service.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | service_type | string (device, lab order, medication, compound, other) |
 * | title | string |
 * | is_additional_approval_needed | boolean |
 * | description | string |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | additional_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 * | order | integer |
 * | metadata | string |
 */
export const updateService = <ThrowOnError extends boolean = false>(
  options: Options<UpdateServiceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Services
 * Get the partner's services (paginated).
 */
export const getServices = <ThrowOnError extends boolean = false>(
  options: Options<GetServicesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services",
    ...options,
  });
};

/**
 * Create Service
 * Creates a service for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | service_type\* | string (device, lab order, medication, compound, other) |
 * | title\* | string |
 * | is_additional_approval_needed | boolean |
 * | description\* | string |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | additional_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license\* | boolean |
 * | send_pdf_file_automatically\* | boolean |
 * | order | integer |
 * | metadata | string |
 */
export const createService = <ThrowOnError extends boolean = false>(
  options: Options<CreateServiceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/services",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Restore Service
 * Restores the partner's service.
 */
export const restoreService = <ThrowOnError extends boolean = false>(
  options: Options<RestoreServiceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/services/{service}/restore",
    ...options,
  });
};

/**
 * Apply Services Reviews
 * Apply all reviews for all services of the partner.
 */
export const applyServicesReviews = <ThrowOnError extends boolean = false>(
  options: Options<ApplyServicesReviewsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/services/reviews/apply",
      ...options,
    }
  );
};

/**
 * Apply Service Review
 * Apply the review of the partner's service.
 */
export const applyServiceReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyServiceReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/services/{service}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Replicate Service
 * Replicates the partner's service.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateService1 = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateService1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/partners/{partner}/services/{service}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Support Staffs
 * Get the partner's support staffs (paginated).
 */
export const getSupportStaffs = <ThrowOnError extends boolean = false>(
  options: Options<GetSupportStaffsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/support-staffs",
    ...options,
  });
};

/**
 * Create  Support Staff
 * Creates a support staff and attaches it to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name\* | string |
 * | last_name\* | string |
 * | email\* | string |
 * | photo_id | uuid |
 * | active\* | boolean |
 * | timezone_id | uuid |
 * | permissions | array (live, sandbox) |
 * | can_unlock_phi | boolean |
 */
export const createSupportStaff1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateSupportStaff1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/support-staffs",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Attach Support Staff (Email)
 * Attach the support staff (email) to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | can_unlock_phi | boolean |
 * | email\* | string |
 */
export const attachSupportStaffEmail = <ThrowOnError extends boolean = false>(
  options: Options<AttachSupportStaffEmailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/support-staffs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach Support Staff
 * Detach the support staff from the partner.
 */
export const detachSupportStaff = <ThrowOnError extends boolean = false>(
  options: Options<DetachSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/support-staffs/{supportStaff}",
    ...options,
  });
};

/**
 * Update Support Staff
 * Updates the partner's support staff.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name | string |
 * | last_name | string |
 * | email | string |
 * | photo_id | uuid |
 * | active | boolean |
 * | password | string |
 * | password_confirmation\* | string |
 * | timezone_id | uuid |
 * | permissions | array (live, sandbox) |
 * | can_unlock_phi | boolean |
 */
export const updateSupportStaff1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSupportStaff1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/support-staffs/{supportStaff}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Support Staff
 * Attach the support staff to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | can_unlock_phi | boolean |
 */
export const attachSupportStaff = <ThrowOnError extends boolean = false>(
  options: Options<AttachSupportStaffData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/support-staffs/{supportStaff}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Specialties
 * Get the partner's specialties (paginated).
 */
export const getSpecialties1 = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecialties1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/specialties",
    ...options,
  });
};

/**
 * Detach Specialty
 * Detach the specialty from the partner.
 */
export const detachSpecialty1 = <ThrowOnError extends boolean = false>(
  options: Options<DetachSpecialty1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/specialties/{specialty}",
    ...options,
  });
};

/**
 * Patch Specialty
 * Patch the specialty to the partner.
 */
export const patchSpecialty = <ThrowOnError extends boolean = false>(
  options: Options<PatchSpecialtyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/specialties/{specialty}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Specialty
 * Attach the specialty to the partner.
 */
export const attachSpecialty1 = <ThrowOnError extends boolean = false>(
  options: Options<AttachSpecialty1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/specialties/{specialty}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Tickets
 * Get the partner's tickets (paginated).
 */
export const getTickets1 = <ThrowOnError extends boolean = false>(
  options: Options<GetTickets1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/tickets",
    ...options,
  });
};

/**
 * Create Ticket
 * Creates a ticket for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title\* | string |
 * | description\* | string |
 * | type\* | string (bug-report, feature-suggestion, question-help, other) |
 * | environment\* | string (development, staging, production, not-applicable) |
 * | product\* | string (api, clinician-portal, admin-panel, messaging-app, messaging-widget, onboarding-app, api-documentation, other) |
 * | is_urgent\* | boolean |
 * | requester_email\* | string |
 */
export const createTicket1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateTicket1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/tickets",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Ticket
 * Deletes the partner's ticket.
 */
export const deleteTicket1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTicket1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/tickets/{ticket}",
    ...options,
  });
};

/**
 * Get Ticket
 * Get the partner's ticket details.
 */
export const getTicket1 = <ThrowOnError extends boolean = false>(
  options: Options<GetTicket1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/tickets/{ticket}",
    ...options,
  });
};

/**
 * Get Options
 * Get the partner's questionnaire's question's option (paginated).
 */
export const getOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetOptionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/options",
    ...options,
  });
};

/**
 * Post Option
 * Create a partner's questionnaire's question's option.
 */
export const postOption = <ThrowOnError extends boolean = false>(
  options: Options<PostOptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/options",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Option
 * Delete the partner's questionnaire's question's option.
 */
export const deleteOption = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/options/{option}",
    ...options,
  });
};

/**
 * Get Option
 * Get the partner's questionnaire's question's option.
 */
export const getOption = <ThrowOnError extends boolean = false>(
  options: Options<GetOptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/options/{option}",
    ...options,
  });
};

/**
 * Patch Option
 * Update the partner's questionnaire's question's option.
 */
export const patchOption = <ThrowOnError extends boolean = false>(
  options: Options<PatchOptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/options/{option}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Apply Option Review
 * Apply the review of the offering.
 */
export const applyOptionReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyOptionReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/options/{option}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Get Requirements
 * Get the partner's questionnaire's question's rule's requirements (paginated).
 */
export const getRequirements = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirementsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements",
    ...options,
  });
};

/**
 * Post Requirement
 * Create a partner's questionnaire's question's rule's requirement.
 */
export const postRequirement = <ThrowOnError extends boolean = false>(
  options: Options<PostRequirementData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Requirement
 * Delete the partner's questionnaire's question's rule's requirement.
 */
export const deleteRequirement = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRequirementData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Get Requirement
 * Get the partner's questionnaire's question's rule's requirement.
 */
export const getRequirement = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirementData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Patch Requirement
 * Update the partner's questionnaire's question's rule's requirement.
 */
export const patchRequirement = <ThrowOnError extends boolean = false>(
  options: Options<PatchRequirementData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements/{requirement}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Apply Requirement Review
 * Apply the review of the offering.
 */
export const applyRequirementReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyRequirementReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements/{requirement}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Get Rules
 * Get the partner's questionnaire's question's rules (paginated).
 */
export const getRules = <ThrowOnError extends boolean = false>(
  options: Options<GetRulesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules",
    ...options,
  });
};

/**
 * Post Rule
 * Create a partner's questionnaire's question's rule.
 */
export const postRule = <ThrowOnError extends boolean = false>(
  options: Options<PostRuleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Rule
 * Delete the partner's questionnaire's question's rule.
 */
export const deleteRule = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRuleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}",
    ...options,
  });
};

/**
 * Get Rule
 * Get the partner's questionnaire's question's rule.
 */
export const getRule = <ThrowOnError extends boolean = false>(
  options: Options<GetRuleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}",
    ...options,
  });
};

/**
 * Patch Rule
 * Update the partner's questionnaire's question's rule.
 */
export const patchRule = <ThrowOnError extends boolean = false>(
  options: Options<PatchRuleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Rule/Requirements
 * Save partner's questionnaire's question's rules and requirements.
 */
export const postRuleRequirements = <ThrowOnError extends boolean = false>(
  options: Options<PostRuleRequirementsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/save",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Apply Rule Review
 * Apply the review of the offering.
 */
export const applyRuleReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyRuleReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Detach File
 * Detach the file from the partner.
 */
export const detachFile1 = <ThrowOnError extends boolean = false>(
  options: Options<DetachFile1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/files/{file}",
    ...options,
  });
};

/**
 * Attach File
 * Attach the file to the partner.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | title\* | string |
 * | type | string (document, review, other) |
 */
export const attachFile4 = <ThrowOnError extends boolean = false>(
  options: Options<AttachFile4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/files/{file}",
    ...options,
  });
};

/**
 * Get Questions
 * Get the partner's questionnaire's questions (paginated).
 */
export const getQuestions = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions",
    ...options,
  });
};

/**
 * Post Question
 * Create a partner's questionnaire's question.
 */
export const postQuestion = <ThrowOnError extends boolean = false>(
  options: Options<PostQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Question
 * Delete the partner's questionnaire's question.
 */
export const deleteQuestion = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}",
    ...options,
  });
};

/**
 * Get Question
 * Get the partner's questionnaire's question.
 */
export const getQuestion = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}",
    ...options,
  });
};

/**
 * Patch Question
 * Update the partner's questionnaire's question.
 */
export const patchQuestion = <ThrowOnError extends boolean = false>(
  options: Options<PatchQuestionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Apply Question Review
 * Apply the review of the offering.
 */
export const applyQuestionReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyQuestionReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/questions/{question}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Get Requirements
 * Get the partner's questionnaire's offering's rule's requirements (paginated).
 */
export const getRequirements1 = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirements1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements",
    ...options,
  });
};

/**
 * Post Requirement
 * Create a partner's questionnaire's offering's rule's requirement.
 */
export const postRequirement1 = <ThrowOnError extends boolean = false>(
  options: Options<PostRequirement1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Requirement
 * Delete the partner's questionnaire's offering's rule's requirement.
 */
export const deleteRequirement1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRequirement1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Get Requirement
 * Get the partner's questionnaire's offering's rule's requirement.
 */
export const getRequirement1 = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirement1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Patch Requirement
 * Update the partner's questionnaire's offering's rule's requirement.
 */
export const patchRequirement1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchRequirement1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements/{requirement}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Apply Requirement Review
 * Apply the review of the rule.
 */
export const applyRequirementReview1 = <ThrowOnError extends boolean = false>(
  options: Options<ApplyRequirementReview1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements/{requirement}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Get Rules
 * Get the partner's questionnaire's offering's rules (paginated).
 */
export const getRules1 = <ThrowOnError extends boolean = false>(
  options: Options<GetRules1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules",
    ...options,
  });
};

/**
 * Post Rule
 * Create a partner's questionnaire's offering's rule.
 */
export const postRule1 = <ThrowOnError extends boolean = false>(
  options: Options<PostRule1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Rule
 * Delete the partner's questionnaire's offering's rule.
 */
export const deleteRule1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRule1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}",
    ...options,
  });
};

/**
 * Get Rule
 * Get the partner's questionnaire's offering's rule.
 */
export const getRule1 = <ThrowOnError extends boolean = false>(
  options: Options<GetRule1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}",
    ...options,
  });
};

/**
 * Patch Rule
 * Update the partner's questionnaire's offering's rule.
 */
export const patchRule1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchRule1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Rule/Requirements
 * Save partner's questionnaire's question's rules and requirements.
 */
export const postRuleRequirements1 = <ThrowOnError extends boolean = false>(
  options: Options<PostRuleRequirements1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/save",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Apply Rule Review
 * Apply the review of the rule.
 */
export const applyRuleReview1 = <ThrowOnError extends boolean = false>(
  options: Options<ApplyRuleReview1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Get Offerings
 * Get the partner's questionnaire's offerings (paginated).
 */
export const getOfferings = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferingsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings",
    ...options,
  });
};

/**
 * Post Offerings
 * Create a partner's questionnaire's offering.
 */
export const postOfferings = <ThrowOnError extends boolean = false>(
  options: Options<PostOfferingsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Offering
 * Delete the partner's questionnaire's offering.
 */
export const deleteOffering = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOfferingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}",
    ...options,
  });
};

/**
 * Get Offering
 * Get the partner's questionnaire's offering.
 */
export const getOffering = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}",
    ...options,
  });
};

/**
 * Patch Offering
 * Update the partner's questionnaire's offering.
 */
export const patchOffering = <ThrowOnError extends boolean = false>(
  options: Options<PatchOfferingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Apply Offering Review
 * Apply the review of the offering.
 */
export const applyOfferingReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyOfferingReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/offerings/{offering}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Get Questionnaires
 * Get the partner's questionnaires (paginated).
 */
export const getQuestionnaires = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionnairesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires",
    ...options,
  });
};

/**
 * Post Questionnaire
 * Create a partner's questionnaire.
 */
export const postQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<PostQuestionnaireData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Questionnaire
 * Deletes the partner's questionnaire.
 */
export const deleteQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQuestionnaireData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}",
    ...options,
  });
};

/**
 * Get Questionnaire
 * Get the partner's questionnaire.
 */
export const getQuestionnaire2 = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionnaire2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}",
    ...options,
  });
};

/**
 * Patch Questionnaire
 * Update the partner's questionnaire.
 */
export const patchQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<PatchQuestionnaireData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Apply Questionnaire Review
 * Apply the review of the questionnaire.
 */
export const applyQuestionnaireReview = <ThrowOnError extends boolean = false>(
  options: Options<ApplyQuestionnaireReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/reviews/{review}/apply",
      ...options,
    }
  );
};

/**
 * Apply Questionnaires Reviews
 * Apply all reviews for all questionnaires of the partner.
 */
export const applyQuestionnairesReviews = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApplyQuestionnairesReviewsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/questionnaires/reviews/apply",
      ...options,
    }
  );
};

/**
 * Restore Questionnaire
 * Restore the partner's questionnaire.
 */
export const restoreQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<RestoreQuestionnaireData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/questionnaires/{questionnaire}/restore",
    ...options,
  });
};

/**
 * Replicate Questionnaire
 * Replicates the partner's questionnaire.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateQuestionnaire1 = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateQuestionnaire1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/partners/{partner}/questionnaires/{questionnaire}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Tags
 * Delete the partner's questionnaire.
 */
export const getTags5 = <ThrowOnError extends boolean = false>(
  options: Options<GetTags5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/tags",
    ...options,
  });
};

/**
 * Create Tag
 * Creates a tag for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | key\* | string |
 * | color\* | string |
 * | description | string |
 * | removable_role | string (admin) |
 * | auto_detach_status | array (created, assigned, waiting, support, processing, cancelled, completed) |
 */
export const createTag1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateTag1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/tags",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Tag
 * Deletes the partner's tag.
 */
export const deleteTag1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTag1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/tags/{tag}",
    ...options,
  });
};

/**
 * Update Tag
 * Updates the partner's tag.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name | string |
 * | description | string |
 * | color | string |
 * | removable_role (admin) | string |
 * | auto_detach_status | array |
 */
export const updateTag5 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTag5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/tags/{tag}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Vouchers
 * Get the partner's vouchers (paginated).
 */
export const getVouchers1 = <ThrowOnError extends boolean = false>(
  options: Options<GetVouchers1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/vouchers",
    ...options,
  });
};

/**
 * Create Voucher
 * Creates a voucher for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | expires_at\* | datetime |
 * | demo\* | boolean |
 * | medications | array |
 * | compounds | array |
 * | supplies | array |
 * | diseases | array |
 * | hold_status | boolean |
 * | questionnaire_id\* | uuid |
 * | clinician_id | uuid |
 *
 * # Payload (medications)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 * | pharmacy_id | integer |
 * | force_pharmacy\* | boolean |
 *
 * # Payload (compounds)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 * | pharmacy_id | integer |
 * | force_pharmacy\* | boolean |
 *
 * # Payload (supplies)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 * | pharmacy_id | integer |
 * | force_pharmacy\* | boolean |
 *
 * # Payload (services)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 *
 * # Payload (diseases)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 */
export const createVoucher2 = <ThrowOnError extends boolean = false>(
  options: Options<CreateVoucher2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/vouchers",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Voucher
 * Deletes the partner's voucher.
 */
export const deleteVoucher1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVoucher1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/vouchers/{voucher}",
    ...options,
  });
};

/**
 * Get Voucher
 * Get the partner's voucher details.
 */
export const getVoucher3 = <ThrowOnError extends boolean = false>(
  options: Options<GetVoucher3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/vouchers/{voucher}",
    ...options,
  });
};

/**
 * Expire Voucher
 * Expires the partner's voucher.
 */
export const expireVoucher1 = <ThrowOnError extends boolean = false>(
  options: Options<ExpireVoucher1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/vouchers/{voucher}/expire",
      ...options,
    }
  );
};

/**
 * Get Webhooks
 * Get the partner's webhooks (paginated).
 */
export const getWebhooks = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhooksData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/webhooks",
    ...options,
  });
};

/**
 * Get Webhook
 * Get the partner's webhook details.
 */
export const getWebhook = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/webhooks/{webhook}",
    ...options,
  });
};

/**
 * Test Webhook
 * Tests the partner's webhook.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | event\* | string (case_processing, case_cancelled, case_waiting, case_completed, case_transferred_to_support, case_assigned_to_clinician, message_created, patient_modified, patient_deleted, prescription_submitted, case_created, voucher_used) |
 * | metadata | object |
 * | encounter_id | uuid |
 * | voucher_id | uuid |
 * | patient_id | uuid |
 * | message_id | uuid |
 * | channel | string (patient, support) |
 * | from | string (support, patient, clinician) |
 * | message | string |
 * | environment_id\* | uuid |
 */
export const testWebhook = <ThrowOnError extends boolean = false>(
  options: Options<TestWebhookData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/webhooks/test",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Post Webhook Resend
 * Resend a partner's webhook.
 */
export const postWebhookResend = <ThrowOnError extends boolean = false>(
  options: Options<PostWebhookResendData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/webhooks/{webhook}/resend",
      ...options,
    }
  );
};

/**
 * Create Partner's Slack Channel
 * With this endpoint, you can create a slack channel for direct communication with MD Integrations.
 */
export const createPartnerSSlackChannel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePartnerSSlackChannelData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/slack/channel",
      ...options,
    }
  );
};

/**
 * Create Encounter
 * Create a new encounter for a given patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | patient_id | uuid\* | Patient ID. Check **Partners > Cases > Patients** to create new patients |
 * | reference_case_id | uuid | The referenced case UUID |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid\* | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_services | array(Service) | List of services to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | is_chargeable | boolean | Whether or not the case should be charged |
 * | tags | array(object(uuid)) | Tags ID to be attached to the case. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`, `dosespot_supply_ndc`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. ItIt can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `dosespot_supply_ndc` are `null` |
 * | dosespot_supply_ndc | string | Dosespot Supply NDC code. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* **Required if** `dosespot_medication_id` or `dosespot_supply_ndc` is present |
 * | pharmacy_id | integer | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/b5039151-5d8d-48e7-8fda-24feff80438b/aW1hZ2UucG5n" width="1637" height="421">
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 * | description | text | A description for your question |
 * | label | string(50) | The question label |
 * | metadata | text | A metadata field |
 * | displayed_options | array | An array of options that were displayed to the patient |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found under your company's offerings from the Partners Website. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 */
export const createEncounter1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateEncounter1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/tests/encounters",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Post Encounter Status
 * Create a new encounter for a given patient.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | status | string\* | The new status (assigned, processing, waiting, cancelled, resubmit, completed) |
 * | reason | string | The reason. Necessary if the status is cancelled or waiting. |
 * | clinician_id | uuid\* | Clinician to simulate the action. |
 */
export const postEncounterStatus1 = <ThrowOnError extends boolean = false>(
  options: Options<PostEncounterStatus1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner_id}/tests/encounters/{encounter_id}/status",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Encounter Prescription
 * Create a encounter prescription.
 *
 * # Payload
 *
 * Receives an object of **Prescription**.
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`, `dosespot_supply_ndc`\]
 *
 * **Note**: We strongly advise asking our medical team to add medications to your company's dashboard so it's easier to manage prescriptions details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | clinician_id | uuid\* | Clinician to simulate the action |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_medication_id` and `partner_supply_id` and `dosespot_supply_ndc` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found under your company's offerings from the Partners Website. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `dosespot_supply_ndc` are `null` |
 * | dosespot_supply_ndc | string | Dosespot Supply NDC code. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_medication_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 *
 * ### Prescription Status Flow
 *
 * `pending`: When prescription is created on MDI side and not synced with Dosespot yet;
 * `processing`: When MDI receives the Dosespot ID and send through the Dosespot the prescription to Pharmacy;
 * `completed`: When Dosespot responds to the MDI that this prescription has been verified by the pharmacy;
 * `cancelled`: When a doctor cancel the prescription (_when it was synced with Dosespot we try to cancel it there too_)
 *
 * <img src="https://content.pstmn.io/f2e85db2-8cd9-4f25-ae04-8e72d17fdb0a/aW1hZ2UucG5n" width="1637" height="421">
 */
export const createEncounterPrescription1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateEncounterPrescription1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner_id}/tests/encounters/{encounter_id}/prescriptions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Reassign clinician to encounter
 * Reassign a given clinician to a given encounter.
 *
 * # Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | clinician_id | uuid\* | Clinician UUID |
 * | reason | string | A reason for the assignment. |
 */
export const reassignClinicianToEncounter1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReassignClinicianToEncounter1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner_id}/tests/encounters/{encounter_id}/reassign",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Create Patient and Encounter
 * Create a new patient and encounter.
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | preferred_pharmacy_id | integer | Dosespot Pharmacy ID |
 * | questionnaire_id | uuid\* | Questionnaire ID |
 * | completion_time | string\* | Time in the format "hh:mm:ss" |
 *
 * # Patient Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | prefix | string(10)\* | Prefix |
 * | first_name | string(35)\* | First name |
 * | last_name | string(35)\* | Last name |
 * | ssn | string(11) | Security Social Number. **Format**: `AAAGGSSSS` |
 * | email | string(80)\* | E-mail |
 * | date_of_birth | date\* | Date of birth, as YYYY-MM-DD |
 * | driver_license_id | uuid | Patient's Driver License, needs to reference an existing **File**. Created through **Files > Create file**. |
 * | gender | integer\* | Gender (ISO 5218 format) |
 * | metadata | string(255) | Field meant to store any information that helps identifying the patient. (e.g., an ID that will be used to identify this patient in another database) |
 * | phone_number | string(25)\* | Phone number - _US format_ |
 * | phone_type | integer\* | Phone type. Available options: 2 (cell) or 4 (home) |
 * | address.address | string(35)\* | Address |
 * | address.address2 | string(35) | Additional address - Allows `null` value |
 * | address.zip_code | string(9)\* | US zip code - _5 or 9 digit format\*_OR\*CA zip code - 6 alphanumeric characters |
 * | address.city_name | string(35)\* | City name. |
 * | address.state_name | string\* | State name or State USPS abbreviation. |
 * | weight | float (from 0 to 999) | Weight in KG \* _required if patient is underage_ |
 * | height | integer (from 0 to 300) | Height in CM \* _required if patient is underage_ |
 * | allergies | text | Known patient's allergies |
 * | pregnancy | boolean | Define the patient with a pregnancy |
 * | current_medications | text | Medications that the patient is currently taking |
 * | intro_video_id | uuid | Patient's Intro Video, needs to reference an existing **File**. Created through **Files > Create file**. |
 *
 * # Case Payload
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | metadata | string(255) | Field meant to store any information that helps identifying the case. (e.g., an ID that will be used to identify this case in another database) |
 * | clinician_id | uuid | Clinician to assign the case to, in case there is a preference for a specific clinician in a specific case. If the field is not sent, a clinician will be assigned according to MDIntegrations algorithm. |
 * | case_prescriptions | array(Prescription) | List of prescriptions to be reviewed by a clinician |
 * | case_files | array(uuid) | Files ID to be attached to the case. The files must be uploaded before creating a case. To upload files check **Partners > Files** |
 * | case_questions | array(Question) | Questions and answers list |
 * | case_services | array(Services) | List of services to be reviewed by a clinician |
 * | tags | array(uuid) | Tags ID to be attached to the case. |
 *
 * ## Prescription Properties
 *
 * **Important**: a prescription object must always contain **exactly one** drug type ID from the following:
 *
 * \[`partner_medication_id`, `partner_compound_id`, `partner_supply_id`\]
 *
 * **Note**: We strongly advise to add a medication to the Admin Panel so it's easier to manage a prescription's details from there. Should you need to add a one-time-only medication, you can use the dosespot_medication_id to reference a Dosespot medication directly.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | partner_compound_id | uuid | Partner compound ID. Check **Partners > Compounds** to get a `partner_compound_id` for a given compound. **Required if** `dosespot_medication_id` and `partner_medication_id` are `null` |
 * | partner_medication_id | uuid | Partner medication ID. It can be found at the Admin Panel. **Required if** `dosespot_medication_id` and `partner_compound_id` are `null` |
 * | partner_supply_id | uuid | Partner supply ID. It can be found at the Admin Panel. **Required if** `dosespot_medication_id` and `partner_compound_id` and `partner_supply_id` are `null` |
 * | refills | integer (from 0 to 99) | Total of refills for the given medication \* Required if `dosespot_medication_id` is present |
 * | quantity | string | Medication quantity string representing a float number (from 0 to 9999999999) **Required if** `dosespot_medication_id` is present |
 * | days_supply | integer (from 0 to 365) | Number of days of supply of the medication provided - Allows `null` value |
 * | directions | string(140) | Instructions about how the medication is administered **Required if** `dosespot_medication_id` is present |
 * | pharmacy_notes | string(210) | Additional information about the prescription |
 * | no_substitutions | boolean | Whether or not a medication or compound can be changed |
 * | dispense_unit_id | integer | \- **Medication** (prescription with a `dosespot_medication_id` included): each medication has one associated dispense unit ID. To get the dispense unit ID associated with a given medication check **Partners > Medications > Get details for a specific medication**;  <br>  <br>\- **Compound** (prescription with `partner_compound_id` included): compounds can be associated with any available dispense unit ID. For a list of all available dispense units check **Partners > Dispense Units**. \* Required if `dosespot_medication_id` is present |
 * | pharmacy_id | integer\* | Pharmacy where the prescription must be sent to. Check **Partners > Pharmacies > Get pharmacies** to get a list of all pharmacies available.  <br>  <br>**Required if**: `dosespot_medication_id` is present.  <br>**Required if**: `partner_medication_id` or `partner_medication_id` does not have a registered default pharmacy.  <br>  <br>**Important note**:  <br>  <br>Dosespot works with **different IDs** for pharmacies according to the environment.  <br>Example:  <br>\- Curexa pharmacy ID in **staging** environment: 133012  <br>\- Curexa pharmacy ID in **production** environment: 29992 |
 * | effective_date | string | Date from which prescription is effective (time will always be 00:00:00). Format: `Y-m-d` |
 *
 * # Question Properties
 *
 * For more information about `questions` and how they affect prescriptions, contact us via Slack or send an email to:
 * [mserota@mdintegrations.com](https://mailto:mserota@mdintegrations.com) and [jeff@mdintegrations.com](https://mailto:jeff@mdintegrations.com)
 *
 * We are also available through Slack (partner's channel).
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | question | string(255)\* | Question |
 * | answer | text\* | Answer |
 * | type | string\* | Question type. Available options: `boolean`, `number` or `string` |
 * | important | boolean | Flag to set a question as `important`.  <br>  <br>**Important Note**:  <br>This flag is used to identify which questions could affect the final prescription. You could also implement custom logic to set this flag only when specific answers are selected. |
 * | display_in_pdf | boolean | Flag to set if this question will be displayed in the case PDF file |
 *
 * # Diseases
 *
 * **Important**: Every disease object will add the disease with the ICD (International Classification of Disease) to the case.
 *
 * **Note**: Diseases can be found in the diseases list on the Admin panel. Once you know a disease's id, you can also retrieve its information through the API using the **Get Disease** route.
 *
 * | field | type | description |
 * | --- | --- | --- |
 * | disease_id | UUID | Disease ID. It can be found at the Admin Panel or through the diseases endpoints. |
 *
 * ## Service Properties
 *
 * **Important**: a service object can include a **partner_service_id** in order to use predefined information from a partner service.
 *
 * **Note**: Partner services can be found at the partner details page on the Admin panel. Once you know a partner's service id, you can also retrieve its information through the api using the **Get Service** route.
 *
 * | **field** | **type** |
 * | --- | --- |
 * | title | string (**required if partner_service_id is NOT included)** |
 * | description | string (**required if partner_service_id is NOT included)** |
 * | service_type | string (**required if partner_service_id is NOT included)** |
 * | additional_note | string |
 * | partner_service_id | uuid |
 * | clinical_notes | string |
 * | thank_you_note | string |
 * | pharmacy_fax_number | string |
 * | include_drivers_license | boolean |
 * | send_pdf_file_automatically | boolean |
 */
export const createPatientAndEncounter1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePatientAndEncounter1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner_id}/tests/vouchers/{voucher_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Encounter
 * Get the partner's encounter by ID.
 *
 * **Note**: Only for `sandbox` patients.
 */
export const getEncounter = <ThrowOnError extends boolean = false>(
  options: Options<GetEncounterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/tests/encounters/{encounter_id}",
    ...options,
  });
};

/**
 * Create Message
 * Creates a patient's message, and attaches its files.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | channel\* | string |
 * | clinician_id | uuid |
 * | support_staff_id | uuid |
 * | text | string |
 * | reference_message_id | uuid |
 * | files | array |
 *
 * # Payload (files)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 */
export const createMessage5 = <ThrowOnError extends boolean = false>(
  options: Options<CreateMessage5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/tests/patients/{patient_id}/messages",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Audits
 * Get the partner's audits (paginated).
 */
export const getAudits = <ThrowOnError extends boolean = false>(
  options: Options<GetAuditsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/audits",
    ...options,
  });
};

/**
 * Get Reviews
 * Get the partner's pending reviews (paginated).
 */
export const getReviews = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/reviews",
    ...options,
  });
};

/**
 * Associate Products
 * Associate Products
 */
export const associateProducts = <ThrowOnError extends boolean = false>(
  options: Options<AssociateProductsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/associate-products",
    ...options,
  });
};

/**
 * Association Products
 * Association Products
 */
export const associationProducts = <ThrowOnError extends boolean = false>(
  options: Options<AssociationProductsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/shopify/associate-products",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Diassociation Products
 * Diassociation Products
 */
export const diassociationProducts = <ThrowOnError extends boolean = false>(
  options: Options<DiassociationProductsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/associate-products/{partnerQuestShopifyProduct}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Association Products
 * Association Products
 */
export const associationProducts1 = <ThrowOnError extends boolean = false>(
  options: Options<AssociationProducts1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/associate-products/{partnerQuestShopifyProduct}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Product-Questionnaire Associations
 * Product-Questionnaire Associations
 */
export const productQuestionnaireAssociations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductQuestionnaireAssociationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-questionnaires",
    ...options,
  });
};

/**
 * Product-Questionnaire Association
 * Product-Questionnaire Association
 */
export const productQuestionnaireAssociation1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductQuestionnaireAssociation1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/shopify/product-questionnaires",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Product-Questionnaire Association
 * Product-Questionnaire Association
 */
export const productQuestionnaireAssociation3 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductQuestionnaireAssociation3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-questionnaires/{productQuestionnaire}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Product-Questionnaire Association
 * Product-Questionnaire Association
 */
export const productQuestionnaireAssociation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductQuestionnaireAssociationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-questionnaires/{productQuestionnaire}",
    ...options,
  });
};

/**
 * Product-Questionnaire Association
 * Product-Questionnaire Association
 */
export const productQuestionnaireAssociation2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductQuestionnaireAssociation2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-questionnaires/{productQuestionnaire}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Product-Offering Association
 * Product-Offering Association
 */
export const productOfferingAssociation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductOfferingAssociationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-offerings/{productOffering}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Product-Offerings Association
 * Product-Offerings Association
 */
export const productOfferingsAssociation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductOfferingsAssociationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-offerings/{productOffering}",
    ...options,
  });
};

/**
 * Product-Offerings Association
 * Product-Offerings Association
 */
export const productOfferingsAssociation2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductOfferingsAssociation2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-offerings/{productOffering}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Product-Offerings Associations
 * Product-Offerings Associations
 */
export const productOfferingsAssociations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductOfferingsAssociationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/product-offerings",
    ...options,
  });
};

/**
 * Product-Offerings Association
 * Product-Offerings Association
 */
export const productOfferingsAssociation1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProductOfferingsAssociation1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/shopify/product-offerings",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Products
 * Get Products
 */
export const getProducts = <ThrowOnError extends boolean = false>(
  options: Options<GetProductsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/products",
    ...options,
  });
};

/**
 * Get Order Analysis
 * This endpoint retrieves a detailed analysis of a specific Shopify order associated with a partner. It provides paginated results of order-related events, including filters for sorting based on the creation date.
 */
export const getOrderAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderAnalysisData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/shopify/{order}/analysis",
    ...options,
  });
};

/**
 * Delete Email Domain
 * Deletes the Partner's Email Domain setting.
 */
export const deleteEmailDomain = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEmailDomainData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-domain",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Email Domain
 * Get the Partner's Email Domain setting.
 */
export const getEmailDomain = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailDomainData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-domain",
    ...options,
  });
};

/**
 * Post Email Domain
 * Post the Partner's Email Domain setting.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | from\* | string|email |
 */
export const postEmailDomain = <ThrowOnError extends boolean = false>(
  options: Options<PostEmailDomainData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/email-domain",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Post Validate Email Domain
 * Post validate the Partner's Email Domain setting.
 */
export const postValidateEmailDomain = <ThrowOnError extends boolean = false>(
  options: Options<PostValidateEmailDomainData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/email-domain/validate",
      ...options,
    }
  );
};

/**
 * Post Send Test Email Domain
 * Post send a test email for the Partner's Email Domain setting.
 */
export const postSendTestEmailDomain = <ThrowOnError extends boolean = false>(
  options: Options<PostSendTestEmailDomainData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/email-domain/send",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Email Templates
 * Get the email templates (paginated).
 */
export const getEmailTemplates1 = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailTemplates1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-templates",
    ...options,
  });
};

/**
 * Post Email Template
 * Post the email template.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | key\* | string |
 * | subject\* | string |
 * | title\* | string |
 * | content\* | string |
 * | button_label\* | string |
 * | closing_notes | string |
 */
export const postEmailTemplate = <ThrowOnError extends boolean = false>(
  options: Options<PostEmailTemplateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/email-templates",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Email Template
 * Deletes the email template.
 */
export const deleteEmailTemplate = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEmailTemplateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-templates/{email-template}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Email Template
 * Get the email templates details.
 */
export const getEmailTemplate1 = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailTemplate1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-templates/{email-template}",
    ...options,
  });
};

/**
 * Patch Email Template
 * Patch the email template.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | key\* | string |
 * | subject\* | string |
 * | title\* | string |
 * | content\* | string |
 * | button_label\* | string |
 * | closing_notes | string |
 */
export const patchEmailTemplate = <ThrowOnError extends boolean = false>(
  options: Options<PatchEmailTemplateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-templates/{email-template}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Email Template Send Test
 * Deletes the email template.
 */
export const postEmailTemplateSendTest = <ThrowOnError extends boolean = false>(
  options: Options<PostEmailTemplateSendTestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/email-templates/send",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Wildcard
 * Deletes the partner's wildcard.
 */
export const deleteWildcard = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWildcardData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/wildcards/{wildcard}",
    ...options,
  });
};

/**
 * Update Wildcard
 * Updates the partner's wildcard.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name | string |
 * | description | string |
 * | color | string |
 * | removable_role (admin) | string |
 * | auto_detach_status | array |
 */
export const updateWildcard = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWildcardData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/wildcards/{wildcard}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete Email Style
 * Deletes the email style.
 */
export const deleteEmailStyle = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEmailStyleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-style",
    ...options,
  });
};

/**
 * Get Email Style
 * Get the email style.
 */
export const getEmailStyle = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailStyleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/email-style",
    ...options,
  });
};

/**
 * Post Email Style
 * Post the email style.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | style\* | string |
 */
export const postEmailStyle = <ThrowOnError extends boolean = false>(
  options: Options<PostEmailStyleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/email-style",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Partner
 * Get the partner details.
 */
export const getPartner1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPartner1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}",
    ...options,
  });
};

/**
 * Update Partner
 * Updates the partner.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | name | string |
 * | notification_priority | string |
 * | active | boolean |
 * | logo_file_id | uuid |
 * | operation_country_id | uuid |
 * | address_id | uuid |
 * | customer_support_email | string |
 * | operations_support_email | string |
 * | patient_message_capability | string |
 * | support_message_capability | string |
 * | messaging_app_primary_color | string |
 * | support_hours | string |
 * | support_location | string (international, us-based) |
 * | use_intake_form | boolean |
 * | use_messaging | boolean |
 * | messaging_app_secondary_color | string |
 * | messaging_app_background_color | string |
 * | partner_notes | string |
 * | thank_you_note_header | string |
 * | thank_you_note_footer | string |
 * | vouched_integration_type | string |
 * | text_message_integration_type | string (disabled, automatic) |
 * | accepted_at | datetime |
 * | parent_company | string |
 * | enable_av_flow | boolean |
 * | is_review_required | boolean |
 * | charge_sync_new_case | numeric |
 * | charge_async_new_case | numeric |
 * | charge_sync_follow_up_case | numeric |
 * | charge_async_follow_up_case | numeric |
 * | clinician_due_sync_case | numeric |
 * | clinician_due_async_case | numeric |
 * | clinician_due_sync_followup_encounter | numeric |
 * | clinician_due_async_followup_encounter | numeric |
 * | vouched_integration_charge | numeric |
 * | text_message_integration_charge | numeric |
 * | is_statistics_enabled | boolean |
 * | force_is_additional_approval_need | boolean |
 */
export const updatePartner = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePartnerData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create Partner
 * Creates a partner, attaches its categories, creates a panel user, and attaches it to the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner\* | object |
 * | categories | array |
 * | panel_user\* | object |
 *
 * # Payload (partner)
 *
 * | field | **type** |
 * | --- | --- |
 * | name\* | string |
 * | notification_priority | string |
 * | active | boolean |
 * | logo_file_id | uuid |
 * | operation_country_id\* | uuid |
 * | address_id | uuid |
 * | customer_support_email | string |
 * | operations_support_email | string |
 * | patient_message_capability | string |
 * | support_message_capability | string |
 * | messaging_app_primary_color | string |
 * | support_hours | string |
 * | support_location | string (international, us-based) |
 * | use_intake_form | boolean |
 * | use_messaging | boolean |
 * | messaging_app_secondary_color | string |
 * | messaging_app_background_color | string |
 * | partner_notes | string |
 * | thank_you_note_header | string |
 * | thank_you_note_footer | string |
 * | vouched_integration_type | string |
 * | text_message_integration_type | string (disabled, automatic) |
 * | enable_av_flow | boolean |
 * | accepted_at | datetime |
 * | parent_company | string |
 * | recaptcha\* | string |
 * | is_statistics_enabled | boolean |
 * | force_is_additional_approval_need | boolean |
 *
 * # Payload (categories)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | id\* | uuid |
 *
 * # Payload (panel_user)
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name\* | string |
 * | email\* | string |
 * | timezone_id | uuid |
 */
export const createPartner = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePartnerData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/partners",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Review Partner
 * Reviews the partner.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | file\* | file |
 */
export const reviewPartner = <ThrowOnError extends boolean = false>(
  options: Options<ReviewPartnerData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      ...formDataBodySerializer,
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/partners/{partner}/review",
      ...options,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Partner Statistic
 * Get the partner statistic.
 */
export const getPartnerStatistic = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerStatisticData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/partners/{partner}/statistics/{statistic}",
    ...options,
  });
};

/**
 * Get Clinicians
 * Get the specialty's clinicians.
 */
export const getClinicians2 = <ThrowOnError extends boolean = false>(
  options: Options<GetClinicians2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/clinicians",
    ...options,
  });
};

/**
 * Get Partners
 * Get the specialty's partners.
 */
export const getPartners = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/partners",
    ...options,
  });
};

/**
 * Get Compounds
 * Get the specialty's compounds.
 */
export const getCompounds1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCompounds1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/compounds",
    ...options,
  });
};

/**
 * Get Medications
 * Get the specialty's medications.
 */
export const getMedications1 = <ThrowOnError extends boolean = false>(
  options: Options<GetMedications1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/medications",
    ...options,
  });
};

/**
 * Get Supplies
 * Get the specialty's supplies.
 */
export const getSupplies1 = <ThrowOnError extends boolean = false>(
  options: Options<GetSupplies1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/supplies",
    ...options,
  });
};

/**
 * Get Services
 * Get the specialty's services.
 */
export const getServices1 = <ThrowOnError extends boolean = false>(
  options: Options<GetServices1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/services",
    ...options,
  });
};

/**
 * Get Questionnaires
 * Get the specialty's questionnaires.
 */
export const getQuestionnaires1 = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionnaires1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires",
    ...options,
  });
};

/**
 * Post Questionnaire
 * Create a questionnaire.
 */
export const postQuestionnaire1 = <ThrowOnError extends boolean = false>(
  options: Options<PostQuestionnaire1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Diseases
 * Get the partner's medication's diseases (paginated).
 */
export const getDiseases5 = <ThrowOnError extends boolean = false>(
  options: Options<GetDiseases5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/diseases",
    ...options,
  });
};

/**
 * Attach Disease
 * Attach the disease to the partner's medication.
 */
export const attachDisease4 = <ThrowOnError extends boolean = false>(
  options: Options<AttachDisease4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}//diseases/{disease}",
    ...options,
  });
};

/**
 * Detach Disease
 * Detach the disease from the partner's medication.
 */
export const detachDisease4 = <ThrowOnError extends boolean = false>(
  options: Options<DetachDisease4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/diseases/{disease}",
    ...options,
  });
};

/**
 * Get Tags
 * Get the partner's medication's tags (paginated).
 */
export const getTags6 = <ThrowOnError extends boolean = false>(
  options: Options<GetTags6Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/tags",
    ...options,
  });
};

/**
 * Detach Tag
 * Detach the tag from the partner's medication.
 */
export const detachTag6 = <ThrowOnError extends boolean = false>(
  options: Options<DetachTag6Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/tags/{tag}",
    ...options,
  });
};

/**
 * Update Tag
 * Update the tag's notes to the partner's medication.
 */
export const updateTag6 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTag6Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/tags/{tag}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Attach Tag
 * Attach the tag to the partner's medication.
 */
export const attachTag6 = <ThrowOnError extends boolean = false>(
  options: Options<AttachTag6Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/{offerginType}/{offering}/tags/{tag}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get States
 * Get the partner's medication's states (paginated).
 */
export const getStates5 = <ThrowOnError extends boolean = false>(
  options: Options<GetStates5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/states",
    ...options,
  });
};

/**
 * Detach State
 * Detach the state from the partner's medication.
 */
export const detachState4 = <ThrowOnError extends boolean = false>(
  options: Options<DetachState4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/states/{state}",
    ...options,
  });
};

/**
 * Attach State
 * Attach the state to the partner's medication.
 */
export const attachState4 = <ThrowOnError extends boolean = false>(
  options: Options<AttachState4Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/states/{state}",
    ...options,
  });
};

/**
 * Attach Specialty
 * Attach the state to the partner's medication.
 */
export const attachSpecialty2 = <ThrowOnError extends boolean = false>(
  options: Options<AttachSpecialty2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/speccialties/{specialty}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Detach Specialty
 * Detach the state from the partner's medication.
 */
export const detachSpecialty2 = <ThrowOnError extends boolean = false>(
  options: Options<DetachSpecialty2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/specialties/{specialty}",
    ...options,
  });
};

/**
 * Delete Offering
 * Deletes the partner's medication.
 */
export const deleteOffering1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOffering1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}",
    ...options,
  });
};

/**
 * Get Offering
 * Get the partner's medication details.
 */
export const getOffering1 = <ThrowOnError extends boolean = false>(
  options: Options<GetOffering1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}",
    ...options,
  });
};

/**
 * Update Offering
 * Updates the partner's medication.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | active | boolean |
 * | title | string |
 * | refills | integer |
 * | quantity | string |
 * | days_supply | integer |
 * | directions | string |
 * | effective_date | integer |
 * | dispense_unit | string |
 * | dispense_unit_id | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy | boolean |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | metadata | string |
 * | order | integer |
 * | allow_substitutions | boolean |
 */
export const updateOffering = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOfferingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Offerings
 * Get the partner's medications (paginated).
 */
export const getOfferings1 = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferings1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}",
    ...options,
  });
};

/**
 * Create Offering
 * Creates a medication for the partner.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | active\* | boolean |
 * | title | string |
 * | refills\* | integer |
 * | quantity\* | string |
 * | days_supply | integer |
 * | directions\* | string |
 * | name\* | string |
 * | strength\* | string |
 * | ndc | string |
 * | effective_date | integer |
 * | dispense_unit\* | string |
 * | dispense_unit_id\* | integer |
 * | pharmacy_id | integer |
 * | pharmacy_name | string |
 * | force_pharmacy\* | boolean |
 * | dosespot_rxcui | integer |
 * | clinical_note | string |
 * | pharmacy_notes | string |
 * | thank_you_note | string |
 * | metadata | string |
 * | order | integer |
 * | allow_substitutions\* | boolean |
 */
export const createOffering = <ThrowOnError extends boolean = false>(
  options: Options<CreateOfferingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/{offerginType}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Restore Offering
 * Restores the partner's medication.
 */
export const restoreOffering = <ThrowOnError extends boolean = false>(
  options: Options<RestoreOfferingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/{offerginType}/{offering}/restore",
    ...options,
  });
};

/**
 * Replicate Offering
 * Replicates the partner's medication.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateOffering = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateOfferingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/specialties/{specialty}/{offerginType}/{offering}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Options
 * Get the questionnaire's question's option (paginated).
 */
export const getOptions1 = <ThrowOnError extends boolean = false>(
  options: Options<GetOptions1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/options",
    ...options,
  });
};

/**
 * Post Option
 * Create a questionnaire's question's option.
 */
export const postOption1 = <ThrowOnError extends boolean = false>(
  options: Options<PostOption1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/options",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Option
 * Delete the questionnaire's question's option.
 */
export const deleteOption1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOption1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/options/{option}",
    ...options,
  });
};

/**
 * Get Option
 * Get the partner's questionnaire's question's option.
 */
export const getOption1 = <ThrowOnError extends boolean = false>(
  options: Options<GetOption1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/options/{option}",
    ...options,
  });
};

/**
 * Patch Option
 * Update the questionnaire's question's option.
 */
export const patchOption1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchOption1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/options/{option}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Requirements
 * Get the questionnaire's question's rule's requirements (paginated).
 */
export const getRequirements2 = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirements2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements",
    ...options,
  });
};

/**
 * Post Requirement
 * Create a questionnaire's question's rule's requirement.
 */
export const postRequirement2 = <ThrowOnError extends boolean = false>(
  options: Options<PostRequirement2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Requirement
 * Delete the questionnaire's question's rule's requirement
 */
export const deleteRequirement2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRequirement2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Get Requirement
 * Get the questionnaire's question's rule's requirement.
 */
export const getRequirement2 = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirement2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Patch Requirement
 * Update the questionnaire's question's rule's requirement.
 */
export const patchRequirement2 = <ThrowOnError extends boolean = false>(
  options: Options<PatchRequirement2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}/requirements/{requirement}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Rules
 * Get the questionnaire's question's rules (paginated).
 */
export const getRules2 = <ThrowOnError extends boolean = false>(
  options: Options<GetRules2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules",
    ...options,
  });
};

/**
 * Post Rule
 * Create a questionnaire's question's rule.
 */
export const postRule2 = <ThrowOnError extends boolean = false>(
  options: Options<PostRule2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Rule
 * Delete the questionnaire's question's rule.
 */
export const deleteRule2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRule2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}",
    ...options,
  });
};

/**
 * Get Rule
 * Get the questionnaire's question's rule.
 */
export const getRule2 = <ThrowOnError extends boolean = false>(
  options: Options<GetRule2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}",
    ...options,
  });
};

/**
 * Patch Rule
 * Update the questionnaire's question's rule.
 */
export const patchRule2 = <ThrowOnError extends boolean = false>(
  options: Options<PatchRule2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/{rule}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Rule/Requirements
 * Save questionnaire's question's rules and requirements.
 */
export const postRuleRequirements2 = <ThrowOnError extends boolean = false>(
  options: Options<PostRuleRequirements2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/rules/save",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Detach File
 * Detach the file from the question.
 */
export const detachFile2 = <ThrowOnError extends boolean = false>(
  options: Options<DetachFile2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/files/{file}",
    ...options,
  });
};

/**
 * Attach File
 * Attach the file to the question.
 *
 * # Payload
 *
 * | field | **type** |
 * | --- | --- |
 * | title\* | string |
 * | type | string (document, review, other) |
 */
export const attachFile5 = <ThrowOnError extends boolean = false>(
  options: Options<AttachFile5Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}/files/{file}",
    ...options,
  });
};

/**
 * Get Questions
 * Get the questionnaire's questions (paginated).
 */
export const getQuestions1 = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestions1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions",
    ...options,
  });
};

/**
 * Post Question
 * Create a questionnaire's question.
 */
export const postQuestion1 = <ThrowOnError extends boolean = false>(
  options: Options<PostQuestion1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Question
 * Delete the questionnaire's question.
 */
export const deleteQuestion1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQuestion1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}",
    ...options,
  });
};

/**
 * Get Question
 * Get the questionnaire's question.
 */
export const getQuestion1 = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestion1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}",
    ...options,
  });
};

/**
 * Patch Question
 * Update the questionnaire's question.
 */
export const patchQuestion1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchQuestion1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/questions/{question}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Requirements
 * Get the questionnaire's offering's rule's requirements (paginated).
 */
export const getRequirements3 = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirements3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements",
    ...options,
  });
};

/**
 * Post Requirement
 * Create a questionnaire's offering's rule's requirement.
 */
export const postRequirement3 = <ThrowOnError extends boolean = false>(
  options: Options<PostRequirement3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Requirement
 * Delete the questionnaire's offering's rule's requirement.
 */
export const deleteRequirement3 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRequirement3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Get Requirement
 * Get the questionnaire's offering's rule's requirement.
 */
export const getRequirement3 = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirement3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements/{requirement}",
    ...options,
  });
};

/**
 * Patch Requirement
 * Update the questionnaire's offering's rule's requirement.
 */
export const patchRequirement3 = <ThrowOnError extends boolean = false>(
  options: Options<PatchRequirement3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}/requirements/{requirement}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Rules
 * Get the questionnaire's offering's rules (paginated).
 */
export const getRules3 = <ThrowOnError extends boolean = false>(
  options: Options<GetRules3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules",
    ...options,
  });
};

/**
 * Post Rule
 * Create a questionnaire's offering's rule.
 */
export const postRule3 = <ThrowOnError extends boolean = false>(
  options: Options<PostRule3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Rule
 * Delete the questionnaire's offering's rule.
 */
export const deleteRule3 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRule3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}",
    ...options,
  });
};

/**
 * Get Rule
 * Get the questionnaire's offering's rule.
 */
export const getRule3 = <ThrowOnError extends boolean = false>(
  options: Options<GetRule3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}",
    ...options,
  });
};

/**
 * Patch Rule
 * Update the questionnaire's offering's rule.
 */
export const patchRule3 = <ThrowOnError extends boolean = false>(
  options: Options<PatchRule3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/{rule}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Post Rule/Requirements
 * Save questionnaire's question's rules and requirements.
 */
export const postRuleRequirements3 = <ThrowOnError extends boolean = false>(
  options: Options<PostRuleRequirements3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}/rules/save",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Offerings
 * Get the questionnaire's offerings (paginated).
 */
export const getOfferings2 = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferings2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings",
    ...options,
  });
};

/**
 * Post Offerings
 * Create a questionnaire's offering.
 */
export const postOfferings1 = <ThrowOnError extends boolean = false>(
  options: Options<PostOfferings1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Offering
 * Delete the questionnaire's offering.
 */
export const deleteOffering2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOffering2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}",
    ...options,
  });
};

/**
 * Get Offering
 * Get the questionnaire's offering.
 */
export const getOffering2 = <ThrowOnError extends boolean = false>(
  options: Options<GetOffering2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}",
    ...options,
  });
};

/**
 * Patch Offering
 * Update the questionnaire's offering.
 */
export const patchOffering1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchOffering1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/offerings/{offering}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete Questionnaire
 * Deletes the questionnaire.
 */
export const deleteQuestionnaire1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQuestionnaire1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}",
    ...options,
  });
};

/**
 * Get Questionnaire
 * Get the questionnaire.
 */
export const getQuestionnaire3 = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionnaire3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}",
    ...options,
  });
};

/**
 * Patch Questionnaire
 * Update the questionnaire.
 */
export const patchQuestionnaire1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchQuestionnaire1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Restore Questionnaire
 * Restore the questionnaire.
 */
export const restoreQuestionnaire1 = <ThrowOnError extends boolean = false>(
  options: Options<RestoreQuestionnaire1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/restore",
    ...options,
  });
};

/**
 * Replicate Questionnaire
 * Replicates the questionnaire.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | partner_id | uuid |
 */
export const replicateQuestionnaire2 = <ThrowOnError extends boolean = false>(
  options: Options<ReplicateQuestionnaire2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/specialties/{specialty}/questionnaires/{questionnaire}/replicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Specialties
 * Get the specialties (paginated).
 */
export const getSpecialties2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetSpecialties2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/web/specialties",
      ...options,
    }
  );
};

/**
 * Post Specialty
 * Post a specialty.
 */
export const postSpecialty = <ThrowOnError extends boolean = false>(
  options?: Options<PostSpecialtyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/specialties",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete Specialty
 * Delete the specialty.
 */
export const deleteSpecialty = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSpecialtyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/specialties/{specialty}",
    ...options,
  });
};

/**
 * Get Specialty
 * Get the specialty details.
 */
export const getSpecialty = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecialtyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/specialties/{specialty}",
    ...options,
  });
};

/**
 * Patch Specialty
 * Patch the specialty.
 */
export const patchSpecialty1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchSpecialty1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/specialties/{specialty}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get State
 * Get the state details.
 */
export const getState = <ThrowOnError extends boolean = false>(
  options: Options<GetStateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/states/{state}",
    ...options,
  });
};

/**
 * Get States
 * Get the states (paginated).
 */
export const getStates6 = <ThrowOnError extends boolean = false>(
  options?: Options<GetStates6Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/states",
      ...options,
    }
  );
};

/**
 * Get Statistics
 * Get the statistics (paginated).
 */
export const getStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatisticsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/statistics",
      ...options,
    }
  );
};

/**
 * Get Status
 * Get the status details.
 */
export const getStatus5 = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatus5Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: "/web/status",
      ...options,
    }
  );
};

/**
 * Get Support Staffs
 * Get the support staffs list.
 */
export const getSupportStaffs1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetSupportStaffs1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/support-staffs",
      ...options,
    }
  );
};

/**
 * Create Support Staff
 * Creates a support staff.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | first_name\* | string |
 * | last_name\* | string |
 * | email\* | string |
 * | photo_id | uuid |
 * | active\* | boolean |
 * | timezone_id\* | uuid |
 * | permissions | array (live, sandbox) |
 */
export const createSupportStaff2 = <ThrowOnError extends boolean = false>(
  options?: Options<CreateSupportStaff2Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/support-staffs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Support Staff Partners
 * Get the support staffs partners list.
 */
export const getSupportStaffPartners = <ThrowOnError extends boolean = false>(
  options: Options<GetSupportStaffPartnersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/support-staffs/{supportStaff}/partners",
    ...options,
  });
};

/**
 * Get Timezones
 * Get the timezones (paginated).
 */
export const getTimezones = <ThrowOnError extends boolean = false>(
  options?: Options<GetTimezonesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/timezones",
      ...options,
    }
  );
};

/**
 * Get Timezone
 * Get the timezone details.
 */
export const getTimezone = <ThrowOnError extends boolean = false>(
  options: Options<GetTimezoneData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/timezones/{timezone}",
    ...options,
  });
};

/**
 * Request 2FA
 * Creates a passcode for the user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | email\* | string |
 * | password\* | string |
 */
export const request2Fa = <ThrowOnError extends boolean = false>(
  options?: Options<Request2FaData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/user/passcodes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Login User
 * Logins the user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | email\* | string |
 * | password\* | string |
 * | code\* | string |
 */
export const loginUser1 = <ThrowOnError extends boolean = false>(
  options?: Options<LoginUser1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/user/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Logout User
 * Logouts the user from the current device.
 */
export const logoutUser1 = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutUser1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/user/logout",
    ...options,
  });
};

/**
 * Logout User (All)
 * Logouts the user from all devices.
 */
export const logoutUserAll1 = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutUserAll1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/user/logout/all",
    ...options,
  });
};

/**
 * Create Password Reset (Token)
 * Creates a password reset (token) for the user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | email\* | string |
 */
export const createPasswordResetToken = <ThrowOnError extends boolean = false>(
  options?: Options<CreatePasswordResetTokenData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/web/user/password-resets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Reset Password Reset
 * Retes the user's password through its password reset's token.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | email\* | string |
 * | password\* | string |
 * | password_confirmation\* | string |
 */
export const resetPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordResetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/web/user/password-resets/{token}/reset",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get Partners
 * Get the user's partners (paginated).
 */
export const getPartners1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetPartners1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/user/partners",
      ...options,
    }
  );
};

/**
 * Get devices
 * Get all active devices
 */
export const getDevices1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetDevices1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/user/devices",
      ...options,
    }
  );
};

/**
 * Delete device
 * Delete user device
 */
export const deleteDevice1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDevice1Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/user/devices/{device_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get User
 * Get the user details.
 */
export const getUser1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetUser1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/user",
      ...options,
    }
  );
};

/**
 * Update User
 * Updates the user.
 *
 * # Payload
 *
 * | **field** | **type** |
 * | --- | --- |
 * | name | string |
 * | email | string |
 * | password | string |
 * | password_confirmation | string |
 * | timezone_id | string |
 */
export const updateUser = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/web/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Reviews
 * Get the partners's reviews (paginated).
 */
export const getReviews1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetReviews1Data, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/web/reviews",
      ...options,
    }
  );
};

/**
 * Get Partner Patients
 * Get Partner Patients
 */
export const getPartnerPatients = <ThrowOnError extends boolean = false>(
  options?: Options<GetPartnerPatientsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/shopify/partners/patients",
      ...options,
    }
  );
};

/**
 * Request patient data
 * Request patient data
 */
export const requestPatientData3 = <ThrowOnError extends boolean = false>(
  options: Options<RequestPatientData3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/shopify/partners/patients/{patient}/data",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Delete Partner Patient
 * Delete Partner Patient
 */
export const deletePartnerPatient = <ThrowOnError extends boolean = false>(
  options: Options<DeletePartnerPatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/partners/patients/{patient}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get Partner Vouchers
 * Get Partner Vouchers
 */
export const getPartnerVouchers = <ThrowOnError extends boolean = false>(
  options?: Options<GetPartnerVouchersData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/shopify/partners/vouchers",
      ...options,
    }
  );
};

/**
 * Delete Partner Shopify
 * Delete Partner Shopify
 */
export const deletePartnerShopify = <ThrowOnError extends boolean = false>(
  options?: Options<DeletePartnerShopifyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/shopify/partners",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update Partner Shopify
 * Update Partner Shopify
 */
export const updatePartnerShopify = <ThrowOnError extends boolean = false>(
  options?: Options<UpdatePartnerShopifyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/shopify/partners",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Notifications
 * Notifications
 */
export const notifications = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/shopify/notifications",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Processing Cases Queue
 * Get processing cases queue.
 */
export const processingCasesQueue = <ThrowOnError extends boolean = false>(
  options?: Options<ProcessingCasesQueueData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/health-check/processing-cases-queue",
      ...options,
    }
  );
};

/**
 * Servers Load
 * Get servers load.
 */
export const serversLoad = <ThrowOnError extends boolean = false>(
  options?: Options<ServersLoadData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/health-check/servers-load",
      ...options,
    }
  );
};

/**
 * Servers Memory
 * Get servers memory.
 */
export const serversMemory = <ThrowOnError extends boolean = false>(
  options?: Options<ServersMemoryData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/health-check/servers-memory",
      ...options,
    }
  );
};

/**
 * Servers Storage
 * Get servers storage.
 */
export const serversStorage = <ThrowOnError extends boolean = false>(
  options?: Options<ServersStorageData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/health-check/servers-storage",
      ...options,
    }
  );
};
